"use strict";

(function () {
  "use strict";

  angular.module("app", ["pascalprecht.translate", "tmh.dynamicLocale", "ui.router", "ui.bootstrap", "ngSanitize", "uiGmapgoogle-maps"]);
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuRechStep6bRefunded", {
    controller: CVURechStep6bRefundedController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-recharge/s6b-refunded/cvu-rech-s6b-refunded.view.html"
  });
  /** @ngInject */

  function CVURechStep6bRefundedController($log, $scope, $state, CoreService) {
    $log.debug("CVU Recharge Step 6b Refunded activated");
    $scope.showErrors = false;
    $scope.data = {
      tagId: 0
    };

    $scope.finish = function () {
      CoreService.sessionTimerStop();
      $state.go("home");
    }; //
    // Session timeout handler


    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuRechStep6Done", {
    controller: CVURechStep6DoneController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-recharge/s6-done/cvu-rech-s6-done.view.html"
  });
  /** @ngInject */

  function CVURechStep6DoneController($log, $scope, $state, CoreService) {
    $log.debug("CVU Recharge Step 6 Done activated");
    $scope.completed = CoreService.session.wizardRecharge.completed;

    $scope.finish = function () {
      $state.go("home");
    }; //
    // Session timeout handler


    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuRechStep5bRefund", {
    controller: CVURechStep5bRefundController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-recharge/s5b-refund/cvu-rech-s5b-refund.view.html"
  });
  /** @ngInject */

  function CVURechStep5bRefundController($log, $scope, CoreService, ApiService, $state, $timeout) {
    $log.debug("CVU Recharge Step 5b Refund activated");
    $scope.refundStep = 0;
    $scope.paymentData = {
      transactionId: null,
      customerId: null,
      status: null
    };
    $scope.payCompleted = false;
    $scope.pageCancelled = false;
    $scope.commRetries = 2;
    $scope.amountToRefund = parseInt(CoreService.session.wizardRecharge.amount.amount).toString();
    $scope.status = "Cancelando transacción...";

    $scope["continue"] = function () {
      $state.go("cvu-rech-s6b-refunded");
    };

    $scope.initRefund = function () {
      $scope.status = "Enviando transacción a POS...";
      ApiService.SareaRefund(CoreService.session.wizardRecharge.payment.id).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $scope.refundData = response.data; // Otherwise, trigger check status timer

          $timeout(function () {
            $scope.checkStatus();
          }, response.data.timeout && response.data.timeout > 0 && response.data.timeout < 60000 ? response.data.timeout * 1000 : 5000);
        } else {
          CoreService.showError("Ocurrió un error", response.data.statusDesc);
          $log.error("Error on initRefund");
          $log.error(response);
          $state.go("contact-support");
        }
      }, function (err) {
        //
        // Server comm error
        //
        if (err.outcode == -2) {
          $log.error("Process|initRefund with timeout!");

          if ($scope.commRetries > 0) {
            $scope.commRetries--;
            $log.debug("Retrying...");
            $scope.status = "Reintenando enviar solicitud...";
            $scope.initRefund();
          } else {
            $log.error("Process|Process with timeout and no more retries!");
            CoreService.showError("Ocurrió un error", "No fue posible procesar la transacción.");
            $log.error("Error on initRefund 3");
            $log.error(err);
            $state.go("contact-support");
          }
        } else {
          CoreService.showError("Ocurrió un error", err.message, err.outcode);
          $log.error("Error on initRefund");
          $log.error(err);
          $state.go("contact-support");
        }
      });
    };

    $scope.simCheckStatus = function () {
      $scope.status = "Esperando anulación...";
      $timeout(function () {
        $scope.payCompleted = true;
        $scope.status = "Anulación completada con éxito!";
        $timeout(function () {
          $scope["continue"]();
        }, 3000);
      }, 3000);
    };

    $scope.checkStatus = function () {
      $scope.status = "Esperando anulación...";
      $log.log("checkStatus|Checking refund for payId " + CoreService.session.wizardRecharge.payment.id);
      ApiService.SareaCheckRefund(CoreService.session.wizardRecharge.payment.id, CoreService.session.wizardRecharge.payment.transaction.id).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $log.log("checkStatus|Server response is OK with data:");
          $log.log(response);

          if (response.data.status == "REFUNDED") {
            //
            // Update screen and continue to process
            //
            $log.log("checkStatus|Refund completed successfully, moving to next step...");
            $scope.status = "Anulación de dinero completada con éxito";
            $scope.payCompleted = true;

            if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
              $scope.$apply();
            }

            $timeout(function () {
              $scope["continue"]();
            }, 3000);
          } else if (response.data.status == "REFUNDING") {
            //
            // Payment still in course, wait 2 seconds
            //
            $log.log("checkStatus|Refund not completed yet, re-checking in 2 seconds...");
            $scope.checkStatusTimeout = $timeout(function () {
              $scope.checkStatus();
            }, 2000);
          } else {
            //
            // Payment status is errored
            //
            $log.log("checkStatus|Refund with error!");
            $log.error("Error on continue 3");
            $log.error(response);
            CoreService.showError("La anulación no se pudo completar", response.data.statusDesc, null, true).then(function () {
              $state.go("contact-support");
            }, function () {});
          }
        } else {
          //
          // Server returned error
          //
          $log.error("Error on continue 2");
          $log.error(response);
          CoreService.showError("La anulación no se pudo completar", response.data.statusDesc, null, true).then(function () {
            $state.go("contact-support");
          }, function () {});
        }
      }, function (error) {
        CoreService.showError("La anulación no se pudo completar", error.message, error.outcode, true).then(function () {
          $state.go("contact-support");
        }, function () {});
        $log.error("Error on continue");
        $log.error(error);
      });
    };

    $scope.cancelTransaction = function () {
      $scope.processCompleted = false;
      $log.log("cancelTransaction|Cancelling trx " + CoreService.session.wizardRecharge.transactionId);
      ApiService.CVUReverseRecharge(CoreService.session.wizardRecharge.transactionId).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $log.log("CVUReverseRecharge|Server response is OK with data:");
          $log.log(response);
          ApiService.CVUExecuteRollback(CoreService.session.wizardRecharge.transactionId).then(function (response) {
            if (response.outcode == 200 || response.outcode == 201) {
              $log.log("cancelTransaction|Server response is OK with data:");
              $log.log(response);

              if (response.data.status == "CANCELED") {
                $log.log("cancelTransaction| Transaction " + CoreService.session.wizardRecharge.transactionId + " cancelled sucessfully.");
              } else {
                $log.error("cancelTransaction| Transaction " + CoreService.session.wizardRecharge.transactionId + " could not be cancelled correctly.");
              }
            } else {
              $log.error("cancelTransaction| Transaction " + CoreService.session.wizardRecharge.transactionId + " could not be cancelled correctly. Server returned " + response.outcode);
            }

            $scope.status = "Transacción cancelada";
            $scope.processCompleted = true;

            if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
              $scope.$apply();
            }

            $timeout(function () {
              $scope.refundStep = 1;

              if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
                $scope.$apply();
              } // $scope.initRefund();

            }, 1000);
          });
        } else {
          $log.error("CVUReverseRecharge| Transaction " + CoreService.session.wizardRecharge.transactionId + " could not be reverted correctly. Server returned " + response.outcode);
        }
      });
    };

    $scope.continueToRefund = function () {
      $scope.refundStep = 2;
      $scope.initRefund();
    };

    $scope.$on("$destroy", function () {
      $log.debug("Destroy called");
      $scope.pageCancelled = true;

      if ($scope.checkStatusTimeout) {
        $log.debug("Cancelling checkStatusTimeout...");
        $timeout.cancel($scope.checkStatusTimeout);
      }
    }); // Init payment

    $timeout(function () {
      // Check if page was closed
      if ($scope.pageCancelled) {
        $log.debug("Pages was destroyed before starting to request payment. Cancelling.");
        return;
      } // $scope.simCheckStatus();
      // $scope.initRefund();


      $scope.cancelTransaction();
    }, 2000);
    CoreService.sessionTimerStop();
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuRechStep5Confirm", {
    controller: CVURechStep5ConfirmController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-recharge/s5-confirm/cvu-rech-s5-confirm.view.html"
  });
  /** @ngInject */

  function CVURechStep5ConfirmController($log, $scope, $state, CoreService, $timeout, ApiService) {
    $log.debug("CVU Recharge Step 5 Confirm activated");
    $scope.processCompleted = false;
    $scope.status = "Confirmando transacción...";

    $scope["continue"] = function () {
      $state.go("cvu-rech-s6-done");
    };

    $scope.process = function () {
      $log.debug("Process | CVUConfirm for trxId " + CoreService.session.wizardRecharge.payment.transaction.id + "...");
      ApiService.CVUConfirmRecharge(CoreService.session.wizardRecharge.payment.transaction.id).then(function (response) {
        $log.debug(response);

        if (response.outcode == 200 || response.outcode == 201) {
          if (response.data.status == "COMPLETED") {
            $scope["continue"]();
          } else {
            $state.go("cvu-rech-s5b-refund");
          }
        } else {
          //
          // Server returned error
          //
          CoreService.showRetryDialog("No fue posible confirmar la transacción").then(function (retry) {
            if (retry) {
              $scope.process();
            } else {
              CoreService.showCancelDialog().then(function (cancel) {
                if (cancel) {
                  //
                  // User cancelled transaction
                  //
                  $state.go("cvu-rech-s5b-refund");
                } else {
                  // Retry again
                  $scope.process();
                }
              }, function () {});
            }
          }, function () {});
          $log.error("Error on CVUConfirm");
          $log.error(response);
        }
      }, function (err) {
        //
        // Comm error with server
        //
        CoreService.showRetryDialog("No fue posible confirmar la transacción").then(function (retry) {
          if (retry) {
            $scope.process();
          } else {
            CoreService.showCancelDialog().then(function (cancel) {
              if (cancel) {
                //
                // User cancelled transaction
                //
                $state.go("cvu-rech-s5b-refund");
              } else {
                // Retry again
                $scope.process();
              }
            }, function () {});
          }
        }, function () {});
        $log.error("Error on CVUConfirm");
        $log.error(err);
      });
    };

    $timeout(function () {
      $scope.process();
    }, 1000);
    CoreService.sessionTimerStop();
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuRechStep4bRevert", {
    controller: CVURechStep4bRevertController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-recharge/s4b-revert/cvu-rech-s4b-revert.view.html"
  });
  /** @ngInject */

  function CVURechStep4bRevertController($log, $scope, CoreService, ApiService, $state, $timeout) {
    $log.debug("CVU Recharge Step 4b Revert Recharge activated");
    $scope.revertCompleted = false;
    $scope.commRetries = 2;
    $scope.status = "Procesando la cancelación...";

    $scope["continue"] = function () {
      $state.go("home");
    };

    $scope.doRevert = function () {
      ApiService.CVUReverseRecharge(CoreService.session.wizardRecharge.transactionId).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $scope.refundData = response.data;
          CoreService.session.wizardRecharge.completed = false;
          $scope.revertCompleted = true;
          $scope.status = "Recarga cancelada con éxito";

          if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
            $scope.$apply();
          }

          $timeout(function () {
            $scope["continue"]();
          }, 3000);
        } else {
          CoreService.showError("Ocurrió un error", response.data.statusDesc);
          $log.error("Error on doRevert");
          $log.error(response);
        }
      }, function (err) {
        //
        // Server comm error
        //
        if (err.outcode == -2) {
          $log.error("Process|doRefund with timeout!");

          if ($scope.commRetries > 0) {
            $scope.commRetries--;
            $log.debug("Retrying...");
            $scope.status = "Reintenando enviar solicitud...";
            $scope.doRefund();
          } else {
            $log.error("Process|Process with timeout and no more retries!");
            CoreService.showError("Ocurrió un error", "No fue posible procesar la cancelación.");
            $log.error("Error on initRefund 3");
            $log.error(err);
            $state.go("home");
          }
        } else {
          CoreService.showError("Ocurrió un error", err.message, err.outcode);
          $log.error("Error on doRefund");
          $log.error(err);
          $state.go("home");
        }
      });
    }; // Init payment


    $timeout(function () {
      $scope.doRevert();
    }, 2000);
    CoreService.sessionTimerStop();
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuRechStep4Pay", {
    controller: CVURechStep4PayController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-recharge/s4-pay/cvu-rech-s4-pay.view.html"
  });
  /** @ngInject */

  function CVURechStep4PayController($log, $scope, CoreService, ApiService, $state, $timeout) {
    $log.debug("CVU Recharge Step 4 Pay activated");
    $scope.payStep = 0;
    $scope.paymentData = {
      transactionId: null,
      customerId: null,
      status: null
    };
    $scope.payCompleted = false;
    $scope.pageCancelled = false;
    $scope.statusCheckWait = 2000;
    $scope.statusChecks = 0;
    $scope.maxStatusChecks = 200;
    $scope.amountToPay = parseInt(CoreService.session.wizardRecharge.amount.amount).toString();
    $scope.status = "Enviando transacción a POS...";

    $scope["continue"] = function () {
      $state.go("cvu-rech-s5-confirm");
    };

    $scope.initPayment = function () {
      var params = {
        transactionId: CoreService.session.wizardRecharge.transactionId,
        user: CoreService.session.wizardRecharge.user,
        amount: CoreService.session.wizardRecharge.amount,
        operation: "RECHARGE"
      };
      ApiService.SareaPay(params).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $scope.paymentData = response.data;
          CoreService.session.wizardRecharge.payment = response.data; // Check if page was closed

          if ($scope.pageCancelled) {
            $log.debug("Payment response received but page was cancelled");
            return;
          } // Otherwise, trigger check status timer


          $timeout(function () {
            $scope.statusChecks = 0;
            $scope.checkStatus();
          }, $scope.statusCheckWait);
        } else {
          // CoreService.showError("Ocurrió un error", response.message, response.outcode);
          $log.error("Error on continue");
          $log.error(response);
          $scope.showRetry("No se pudo iniciar el pago", null, response.data.statusDesc);
        }
      }, function (error) {
        // CoreService.showError("Ocurrió un error", error.message, error.outcode);
        $log.error("Error on continue");
        $log.error(error);
        $scope.showRetry("No se pudo iniciar el pago", null, "No se pudo comunicar con el servidor");
      });
    };

    $scope.simCheckStatus = function (resultOK) {
      $scope.status = "Esperando pago...";
      $timeout(function () {
        CoreService.session.wizardRecharge.payment = {
          amount: "25000.00",
          amountDiscount: "0.00",
          id: 91,
          status: resultOK ? "PAID" : "ERROR",
          statusDesc: resultOK ? "TRANSACCION EJECUTADA CON SUCESO" : "ERROR",
          transaction: {
            id: 141,
            type: "",
            status: "PAID",
            userId: 141,
            errorCode: null,
            errorDesc: null
          },
          errorCode: null,
          errorDesc: null,
          type: "",
          userId: 141
        };
        $timeout(function () {
          if (resultOK) {
            $scope.payCompleted = true;
            $scope.status = "Pago completado con éxito!";
            CoreService.session.wizardRecharge.completed = true;
            $scope["continue"]();
          } else {
            $scope.showRetry("No se pudo procesar el pago", null, "Error simulado");
          }
        }, 3000);
      }, 3000);
    };

    $scope.checkStatus = function () {
      $scope.status = "Esperando pago...";
      $scope.statusChecks++;
      $log.log("checkStatus|Checking (" + $scope.statusChecks + ") payment for trx " + $scope.paymentData.transactionId + " and customer " + $scope.paymentData.customerId);
      ApiService.SareaCheckPayment($scope.paymentData.id, $scope.paymentData.transaction.id
      /*, $scope.paymentData.transaction.userId*/
      ).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $log.log("checkStatus|Server response is OK with data:");
          $log.log(response);

          if (response.data.status == "PAID") {
            //
            // Store payment data
            //
            CoreService.session.wizardRecharge.payment = response.data; //
            // Update screen and continue to process
            //

            $log.log("checkStatus|Payment completed successfully, moving to next step...");
            $scope.status = "Pago completado con éxito";
            $scope.payCompleted = true;
            CoreService.session.wizardRecharge.completed = true;

            if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
              $scope.$apply();
            }

            $timeout(function () {
              $scope["continue"]();
            }, $scope.statusCheckWait);
          } else if (response.data.status == "PAYING") {
            //
            // Payment still in course, wait 2 seconds
            //
            if ($scope.statusChecks == $scope.maxStatusChecks) {
              $log.log("checkStatus|Max checks reached! Ask to manual retry");
              CoreService.showRetryDialog("No se pudo verificar el pago").then(function (retry) {
                if (retry) {
                  $scope.initPayment();
                } else {
                  $state.go("cvu-rech-s4b-revert");
                }
              }, function () {});
            } else {
              $log.log("checkStatus|Payment not completed yet, re-checking #" + $scope.statusChecks + " in 2 seconds...");
              $scope.checkStatusTimeout = $timeout(function () {
                $scope.checkStatus();
              }, $scope.statusCheckWait);
            }
          } else {
            //
            // Payment status is errored
            //
            $log.log("checkStatus|Payment with error!");
            $log.error("Error on continue 2");
            $log.error(response); // CoreService.showError("Ocurrió un error", response.data.transaction.errorDesc, response.data.transaction.errorCode);

            $scope.showRetry("No se pudo procesar el pago", null, response.data.statusDesc);
          }
        } else {
          //
          // Server returned error
          //
          // CoreService.showError("Ocurrió un error", response.message, response.outcode);
          $log.error("checkStatus|Error on continue 2");
          $log.error(response);
          $scope.showRetry("No se pudo procesar el pago", response.outcode, response.message);
        }
      }, function (error) {
        if (error.outcode == -2) {
          if ($scope.statusChecks == $scope.maxStatusChecks) {
            $log.log("checkStatus|Max checks reached! Ask to manual retry");
            CoreService.showRetryDialog("No se pudo verificar el pago").then(function (retry) {
              if (retry) {
                $scope.initPayment();
              } else {
                $state.go("cvu-rech-s4b-revert");
              }
            }, function () {});
          } else {
            $log.warn("checkStatus|Timeout ocurred!, retrying #" + $scope.statusChecks + " in 2 seconds...");
            $scope.checkStatusTimeout = $timeout(function () {
              $scope.checkStatus();
            }, $scope.statusCheckWait);
          }
        } else {
          $scope.showRetry("No se pudo procesar el pago", null, "Error de comunicación con el servidor");
          $log.error("checkStatus|Error on continue");
          $log.error(error);
        }
      });
    };

    $scope.showRetry = function (title, errorCode, errorDesc) {
      CoreService.showRetryDialog(title, errorCode, errorDesc).then(function (retry) {
        if (retry) {
          $scope.initPayment();
        } else {
          $state.go("cvu-rech-s4b-revert");
        }
      }, function () {});
    };

    $scope.$on("$destroy", function () {
      $log.debug("Destroy called");
      $scope.pageCancelled = true;

      if ($scope.checkStatusTimeout) {
        $log.debug("Cancelling checkStatusTimeout...");
        $timeout.cancel($scope.checkStatusTimeout);
      }
    });

    $scope.cancelTransaction = function () {
      $scope.payStep = 2;
      $scope.status = "Cancelando transacción...";
      $scope.processCompleted = false;
      $log.log("cancelTransaction|Cancelling trx " + CoreService.session.wizardRecharge.transactionId);
      ApiService.CVUReverseRecharge(CoreService.session.wizardRecharge.transactionId).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $log.log("cancelTransaction|Server response is OK with data:");
          $log.log(response);

          if (response.data.status == "CANCELED") {
            $log.log("cancelTransaction| Transaction " + CoreService.session.wizardRecharge.transactionId + " cancelled sucessfully.");
          } else {
            $log.error("cancelTransaction| Transaction " + CoreService.session.wizardRecharge.transactionId + " could not be cancelled correctly.");
          }
        } else {
          $log.error("cancelTransaction| Transaction " + CoreService.session.wizardRecharge.transactionId + " could not be cancelled correctly. Server returned " + response.outcode);
        }

        $scope.status = "Transacción cancelada";
        $scope.processCompleted = true;

        if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
          $scope.$apply();
        }

        $timeout(function () {
          CoreService.clearSession();
          $state.go("start");
        }, 3000);
      });
    };

    $scope.cancel = function () {
      CoreService.showCancelDialog().then(function (cancel) {
        if (cancel) {
          $scope.cancelTransaction();
        }
      }, function (err) {
        $log.error(err);
      });
    };

    $scope.continueToPay = function () {
      $scope.payStep = 1;
      $scope.initPayment();
    }; // Init payment
    // $timeout(function(){
    //   // Check if page was closed
    //   if ($scope.pageCancelled) {
    //     $log.debug('Pages was destroyed before starting to request payment. Cancelling.');
    //     return;
    //   }
    //   // $scope.simCheckStatus(false);
    //   $scope.initPayment();
    // }, 2000);


    CoreService.sessionTimerStop();
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuRechStep3Process", {
    controller: CVURechStep3ProcessController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-recharge/s3-process/cvu-rech-s3-process.view.html"
  });
  /** @ngInject */

  function CVURechStep3ProcessController($log, $scope, $state, $timeout, CoreService, ApiService) {
    $log.debug("CVU Recharge Step 3 Process activated");
    $scope.commRetries = 2;
    $scope.status = "Enviando solicitud...";
    $scope.showErrors = false;
    $scope.data = {
      tagId: 0
    };

    $scope.process = function () {
      $log.debug("Process | CVUExecuteStart for trxId " + CoreService.session.wizardRecharge.transactionId + "...");
      ApiService.CVUExecuteStart(CoreService.session.wizardRecharge.transactionId, null, CoreService.session.wizardRecharge.user.externalId, CoreService.session.wizardRecharge.amount, CoreService.session.wizardRecharge.user).then(function (response) {
        $log.debug(response);

        if (response.outcode == 200 || response.outcode == 201) {
          $timeout(function () {
            $scope.checkStatus(); // $scope.simCheckStatus();
          }, 2000);
        } else {
          //
          // Server returned error
          //
          // CoreService.showError("Ocurrió un error", response.message, response.outcode);
          $log.error("Error on process");
          $log.error(response);
          $scope.showRetry("Ocurrió un error al recargar", response.message, response.outcode);
        }
      }, function (err) {
        //
        // Server comm error
        //
        if (err.outcode == -2) {
          $log.error("Process|Process with timeout!");

          if ($scope.commRetries > 0) {
            $scope.commRetries--;
            $log.debug("Retrying...");
            $scope.status = "Reintenando enviar solicitud #" + $scope.commRetries + "...";
            $scope.process();
          } else {
            $log.error("Process|Process with timeout and no more retries!");
            CoreService.showError("Ocurrió un error", "No fue posible procesar la transacción.");
            $log.error("Error on process 3");
            $log.error(err);
          }
        } else {
          $log.error("Process|Process with error!");
          $log.error("Error on process 2");
          $log.error(err); // CoreService.showError("Ocurrió un error", "No fue posible procesar la transacción.");

          $scope.showRetry("Ocurrió un error al enviar la solicitud", err.message, err.outcode);
        }
      });
    };

    $scope.simCheckStatus = function () {
      $scope.status = "Esperando respuesta...";
      $timeout(function () {
        $scope.payCompleted = true;
        $scope.status = "Proceso completado con éxito!";
        $timeout(function () {
          $scope.processStep = 1;

          if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
            $scope.$apply();
          }
        }, 3000);
      }, 3000);
    };

    $scope.checkStatus = function () {
      $scope.status = "Esperando respuesta...";
      $log.log("checkStatus|Checking process for trx " + CoreService.session.wizardRecharge.transactionId);
      ApiService.CVUExecuteStatus(CoreService.session.wizardRecharge.transactionId, CoreService.session.wizardRecharge.user.externalId).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $log.log("checkStatus|Server response is OK with data:");
          $log.log(response);

          if (response.data.status == "EXECUTED") {
            //
            // Update screen and continue to process
            //
            $log.log("checkStatus|Process completed successfully, finishing...");
            $scope.status = "Recarga preparada con éxito";
            $scope.processCompleted = true;

            if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
              $scope.$apply();
            }

            $timeout(function () {
              $state.go("cvu-rech-s4-pay");
            }, 1000);
          } else if (response.data.status == "PROCESSING") {
            //
            // Payment still in course, wait 2 seconds
            //
            $log.log("checkStatus|Process not completed yet, re-checking in 2 seconds...");
            $scope.checkStatusTimeout = $timeout(function () {
              $scope.checkStatus();
            }, 2000);
          } else {
            //
            // Payment status is errored
            //
            $log.log("checkStatus|Process with error!");
            $log.error("Error on continue 2");
            $log.error(response);
            $scope.showError("Ocurrió un error 1", response.data.errorDesc, response.data.errorCode);
          }
        } else {
          //
          // Server returned error
          //
          $log.error("Error on continue");
          $log.error(response);
          $scope.showError("Ocurrió un error 2", response.message, response.outcode);
        }
      }, function (error) {
        $log.error("Error on continue");
        $log.error(error);
        $scope.showError("Ocurrió un error 3", error.message, error.outcode);
      });
    }; // $scope.continueToPay = function () {
    //   $state.go('cvu-rech-s4-pay');
    // }


    $scope.showError = function (title, message, outcode) {
      CoreService.showError(title, message, outcode, true).then(function () {
        $state.go("home");
      }, function () {});
    };

    $scope.showRetry = function (title, errorCode, errorDesc) {
      CoreService.showRetryDialog(title, errorCode, errorDesc).then(function (retry) {
        if (retry) {
          $scope.process();
        } else {
          $state.go("cvu-rech-s4b-refund");
        }
      }, function () {});
    }; // $scope.cancel = function(){
    //   CoreService.showCancelDialog().then(function(cancel){
    //     if (cancel){
    //       $scope.status = 'Cancelando la recarga...';
    //       $scope.processStep = 2;
    //       if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
    //         $scope.$apply();
    //       }
    //       ApiService.CVUReverseRecharge(CoreService.session.wizardRecharge.transactionId).then((response) => {
    //         if (response.outcode == 200 || response.outcode == 201){
    //           $log.log('Transaction ' + CoreService.session.wizardRecharge.transactionId + ' reverted successfully!');
    //           $scope.cancelCompleted = true;
    //           $timeout(function(){
    //             CoreService.clearSession();
    //             $state.go('start');
    //           }, 2000);
    //         }else{
    //           //
    //           // Server returned error
    //           //
    //           $log.error('Server returned error reversing recharge transaction '+ CoreService.session.wizardRecharge.transactionId);
    //           $log.error(response);
    //           CoreService.clearSession();
    //           $state.go('start');
    //         }
    //       }, (error) => {
    //         $log.error('Comm error reversing recharge transaction '+ CoreService.session.wizardRecharge.transactionId);
    //         $log.error(error);
    //         CoreService.clearSession();
    //         $state.go('start');
    //       });
    //     }
    //   }, function(err){
    //     $log.error(err);
    //   })
    // }


    $timeout(function () {
      $scope.process();
    }, 500);
    CoreService.sessionTimerStop();
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuRechStep2Topup", {
    controller: CVURechStep2TopupController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-recharge/s2-topup/cvu-rech-s2-topup.view.html"
  });
  /** @ngInject */

  function CVURechStep2TopupController($log, $scope, CoreService, ApiService, $state) {
    $log.debug("CVU Recharge Step 2 TopUp activated");
    $scope.keyboardLayout = "number";
    $scope.keyboardInput = "";
    $scope.showKeyboard = false;
    $scope.showErrors = false;
    $scope.data = {
      rechargeAmount: 0,
      amounts: null,
      includesTaxes: false
    };

    $scope.initialize = function () {
      CoreService.showProgress();
      $scope.showKeyboard = false;

      try {
        ApiService.CVUGetRechargeAmounts().then(function (response) {
          if (response.data && response.data.length) {
            for (var i = 0; i < response.data.length; i++) {
              response.data[i].amountNice = parseInt(response.data[i].amount).toString();
            }

            $scope.data.amounts = response.data;

            if ($scope.data.amounts && $scope.data.amounts.length) {
              $scope.data.includesTaxes = $scope.data.amounts[0].includesTaxes;
            }
          }

          CoreService.hideProgress();
          $scope.$apply();
        }, function (error) {
          CoreService.showError("Ocurrió un error", error.message, error.outcode);
          $log.error("Error on continue");
          $log.error(error);
          CoreService.hideProgress();
        });
      } catch (exc) {
        $log.error("Exception catched on continue");
        CoreService.hideProgress();
      }
    };

    $scope.select = function (amount) {
      // Store data in session
      CoreService.session.wizardRecharge.amount = amount;
      $state.go("cvu-rech-s3-process");
    };

    $scope.selectCustom = function () {
      $scope.showKeyboard = true;
      CoreService.showCustomAmountSelector($scope).then(function (customAmount) {
        CoreService.session.wizardRecharge.amount = {
          amount: customAmount
        };
        $state.go("cvu-rech-s3-process");
      }, function (error) {
        if (error) {
          $log.error(error);
        } else {
          $scope.showKeyboard = false;
        }
      });
    };

    $scope.cancel = function () {
      CoreService.showCancelDialog().then(function (cancel) {
        if (cancel) {
          CoreService.clearSession();
          $state.go("start");
        }
      }, function (err) {
        $log.error(err);
      });
    };

    $scope.goBack = function () {
      $state.go("cvu-rech-s1-id");
    };

    $scope.initialize(); //
    // Session timeout handler

    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuRechStep1ClientSelect", {
    controller: CVURechStep1ClientSelectController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-recharge/s1b-client-select/cvu-rech-s1b-client-select.view.html"
  });
  /** @ngInject */

  function CVURechStep1ClientSelectController($log, $scope, CoreService, ApiService, $state) {
    $log.debug("CVURechStep1ClientSelectController activated");
    $scope.data = {
      clientes: CoreService.session.wizardRecharge.clients
    };

    $scope.selectUser = function (cliente) {
      // Store user data at session
      CoreService.session.wizardRecharge.user.externalId = cliente.xiNroCliente;
      CoreService.session.wizardRecharge.user.observation = "";
      CoreService.session.wizardRecharge.user.docType = cliente.xiTipoCli;
      CoreService.session.wizardRecharge.user.doc = cliente.xsIdentificadorCli;
      CoreService.session.wizardRecharge.user.name = cliente.xsNombreCliente;
      $state.go("cvu-rech-s2-topup");
    };

    $scope.cancel = function () {
      CoreService.showCancelDialog().then(function (cancel) {
        if (cancel) {
          CoreService.clearSession();
          $state.go("start");
        }
      }, function (err) {
        $log.error(err);
      });
    };

    $scope.goBack = function () {
      $state.go("cvu-rech-s1-id");
    }; // Session timeout handler


    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuRechStep1User", {
    controller: CVURechStep1UserController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-recharge/s1-id/cvu-rech-s1-id.view.html"
  });
  /** @ngInject */

  function CVURechStep1UserController($log, $scope, $rootScope, $state, $timeout, $document, CoreService, ApiService, $window) {
    $log.debug("CVU Recharge Step 1 User activated");
    $scope.showKeyboard = true;
    $scope.keyboardLayout = "number";
    $scope.keyboardInput = "";
    $scope.showErrors = false;
    $scope.data = {
      userDocType: 5,
      userDocValue: ""
    };

    if ($window.IS_DEBUG && $window.DEBUG_DATA) {
      $scope.data = {
        userDocType: $window.DEBUG_DATA.userDocType ? $window.DEBUG_DATA.userDocType : 2,
        userDocValue: $window.DEBUG_DATA.userDocValue ? $window.DEBUG_DATA.userDocValue : ""
      };
    }

    $scope.keyboardLayout = "default";

    $scope.inputFocus = function (ev) {
      $scope.showKeyboard = true;
      $rootScope.$broadcast("keyboard::changeInput", ev.target.value);

      if (ev.target.id == "userDocValue") {
        $timeout(function () {
          switch ($scope.data.userDocType) {
            case 1:
              $scope.keyboardLayout = "number";
              break;

            case 2:
              $scope.keyboardLayout = "number";
              break;

            case 3:
              $scope.keyboardLayout = "default";
              break;

            case 4:
              $scope.keyboardLayout = "default";
              break;

            case 5:
              $scope.keyboardLayout = "default";
              break;
          }
        }, 50);
      } else if (ev.target.id == "vehiclePlateNumber") {
        $scope.keyboardLayout = "default";
      }
    };

    $scope["continue"] = function (isValid) {
      if (!isValid) {
        $scope.showErrors = true;
        return;
      } // Store data in session


      CoreService.session.wizardRecharge.user = {
        docType: $scope.data.docType,
        docValue: $scope.data.docValue
      }; // $state.go('cvu-rech-s2-topup');
      // return;

      CoreService.showProgress();
      $scope.showKeyboard = true;

      if ($scope.data.userDocType == 4) {
        $scope.data.userDocType = 3;
        $scope.data.docValue = "PRE" + $scope.data.docValue;
      }

      try {
        ApiService.CVUStartRecharge($scope.data).then(function (response) {
          $log.log(response);
          CoreService.hideProgress();

          if (response.data.exists) {
            // Store user data at session
            CoreService.session.wizardRecharge.user.externalId = response.data.nroCliente;
            CoreService.session.wizardRecharge.user.observation = response.data.observacion;
            CoreService.session.wizardRecharge.transactionId = response.data.transactionId;
            $state.go("cvu-rech-s2-topup");
          } else {
            $scope.showKeyboard = false;

            if ($scope.data.userDocType == 5) {
              if (!response.data.clientes) {
                CoreService.showNewAccountMessage("Cuenta no encontrada", response.data.observacion);
              } else {
                CoreService.session.wizardRecharge.clients = response.data.clientes;
                CoreService.session.wizardRecharge.transactionId = response.data.transactionId;
                $state.go("cvu-rech-s1b-client-select");
              }
            } else {
              CoreService.showMessage("Cuenta no encontrada", "No se encontró la cuenta para esos datos, vuelva a intentarlo o use la opción para adquirir un nuevo TAG", true).then(function () {
                $state.go("start");
              }, function () {
                $state.go("start");
              });
            }
          }
        }, function (error) {
          CoreService.showError("Ocurrió un error", error.message, error.outcode);
          $log.error("Error on continue");
          $log.error(error);
          CoreService.hideProgress();
        });
      } catch (exc) {
        $log.error("Exception catched on continue");
        CoreService.hideProgress();
      }
    };

    $scope.docTypeSelect = function () {
      $document[0].getElementById("userDocValue").focus();
    };

    $scope.cancel = function () {
      CoreService.clearSession();
      $state.go("start");
    };

    $scope.goBack = function () {
      $state.go("start");
    };

    $timeout(function () {
      var e = $document[0].getElementById("userDocValue");
      if (e) e.focus();
    }, 500); //
    // Session timeout handler

    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });

    function clean_ci(ci) {
      return ci.replace(/\D/g, "");
    }

    function validation_digit(ci) {
      var a = 0;
      var i = 0;

      if (ci.length <= 6) {
        for (i = ci.length; i < 7; i++) {
          ci = "0" + ci;
        }
      }

      for (i = 0; i < 7; i++) {
        a += parseInt("2987634"[i]) * parseInt(ci[i]) % 10;
      }

      if (a % 10 === 0) {
        return 0;
      } else {
        return 10 - a % 10;
      }
    }

    function validate_ci(ci) {
      ci = clean_ci(ci);
      var dig = ci[ci.length - 1];
      ci = ci.replace(/[0-9]$/, "");
      return dig == validation_digit(ci);
    }

    $scope.validateDocValue = function () {
      if ($scope.data.userDocType == 2) {
        return validate_ci($scope.data.userDocValue);
      }

      return true;
    };
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuNewStep8bRefunded", {
    controller: CVUNewStep8bRefundedController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-new/s8b-refunded/cvu-new-s8b-refunded.view.html"
  });
  /** @ngInject */

  function CVUNewStep8bRefundedController($log, $scope, $state, CoreService) {
    $log.debug("CVU New Step 8b Refunded activated");
    $scope.showErrors = false;
    $scope.data = {
      tagId: 0
    };

    $scope.finish = function () {
      CoreService.sessionTimerStop();
      $state.go("home");
    }; //
    // Session timeout handler


    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuNewStep8Done", {
    controller: CVUNewStep8DoneController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-new/s8-done/cvu-new-s8-done.view.html"
  });
  /** @ngInject */

  function CVUNewStep8DoneController($log, $scope, $state, CoreService) {
    $log.debug("CVU New Step 8 Done activated");
    $scope.showErrors = false;
    $scope.data = {
      tagId: 0
    };

    $scope.finish = function () {
      CoreService.sessionTimerStop();
      $state.go("home");
    }; //
    // Session timeout handler


    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuNewStep7bRefund", {
    controller: CVUNewStep7bRefundController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-new/s7b-refund/cvu-new-s7b-refund.view.html"
  });
  /** @ngInject */

  function CVUNewStep7bRefundController($log, $scope, CoreService, ApiService, $state, $timeout) {
    $log.debug("CVU New Step 7b Refund activated");
    $scope.refundStep = 0;
    $scope.paymentData = {
      transactionId: null,
      customerId: null,
      status: null
    };
    $scope.payCompleted = false;
    $scope.pageCancelled = false;
    $scope.commRetries = 2;
    $scope.amountToRefund = parseInt(CoreService.session.wizardNew.amount.amount).toString();
    $scope.status = "Cancelando transacción...";

    $scope["continue"] = function () {
      $state.go("cvu-new-s8b-refunded");
    };

    $scope.initRefund = function () {
      $scope.status = "Enviando transacción a POS...";
      ApiService.SareaRefund(CoreService.session.wizardNew.payment.id).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $scope.refundData = response.data; // Otherwise, trigger check status timer

          $timeout(function () {
            $scope.checkStatus();
          }, response.data.timeout && response.data.timeout > 0 && response.data.timeout < 60000 ? response.data.timeout * 1000 : 5000);
        } else {
          CoreService.showError("Ocurrió un error", response.data.statusDesc);
          $log.error("Error on initRefund");
          $log.error(response);
        }
      }, function (err) {
        //
        // Server comm error
        //
        if (err.outcode == -2) {
          $log.error("Process|initRefund with timeout!");

          if ($scope.commRetries > 0) {
            $scope.commRetries--;
            $log.debug("Retrying...");
            $scope.status = "Reintenando enviar solicitud...";
            $scope.initRefund();
          } else {
            $log.error("Process|Process with timeout and no more retries!");
            CoreService.showError("Ocurrió un error", "No fue posible procesar la transacción.");
            $log.error("Error on initRefund 3");
            $log.error(err);
          }
        } else {
          CoreService.showError("Ocurrió un error", err.message, err.outcode);
          $log.error("Error on initRefund");
          $log.error(err);
        }
      });
    };

    $scope.simCheckStatus = function () {
      $scope.status = "Esperando anulación...";
      $timeout(function () {
        $scope.payCompleted = true;
        $scope.status = "Anulación de dinero completada con éxito!";
        $timeout(function () {
          $scope["continue"]();
        }, 3000);
      }, 3000);
    };

    $scope.checkStatus = function () {
      $scope.status = "Esperando anulación...";
      $log.log("checkStatus|Checking refund for payId " + CoreService.session.wizardNew.payment.id);
      ApiService.SareaCheckRefund(CoreService.session.wizardNew.payment.id, CoreService.session.wizardNew.payment.transaction.id).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $log.log("checkStatus|Server response is OK with data:");
          $log.log(response);

          if (response.data.status == "REFUNDED") {
            //
            // Update screen and continue to process
            //
            $log.log("checkStatus|Refund completed successfully, moving to next step...");
            $scope.status = "Anulación completada con éxito";
            $scope.payCompleted = true;

            if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
              $scope.$apply();
            }

            $timeout(function () {
              $scope["continue"]();
            }, 3000);
          } else if (response.data.status == "REFUNDING") {
            //
            // Payment still in course, wait 2 seconds
            //
            $log.log("checkStatus|Refund not completed yet, re-checking in 2 seconds...");
            $scope.checkStatusTimeout = $timeout(function () {
              $scope.checkStatus();
            }, 2000);
          } else {
            //
            // Payment status is errored
            //
            $log.log("checkStatus|Refund with error!");
            $log.error("Error on continue 3");
            $log.error(response);
            CoreService.showError("La anulación no se pudo completar", response.data.statusDesc, null, true).then(function () {
              $state.go("contact-support");
            }, function () {});
          }
        } else {
          //
          // Server returned error
          //
          $log.error("Error on continue 2");
          $log.error(response);
          CoreService.showError("La anulación no se pudo completar", response.data.statusDesc, null, true).then(function () {
            $state.go("contact-support");
          }, function () {});
        }
      }, function (error) {
        CoreService.showError("La anulación no se pudo completar", error.message, error.outcode, true).then(function () {
          $state.go("contact-support");
        }, function () {});
        $log.error("Error on continue");
        $log.error(error);
      });
    };

    $scope.cancelTransaction = function () {
      $scope.processCompleted = false;
      $log.log("cancelTransaction|Cancelling trx " + CoreService.session.wizardNew.transactionId);
      ApiService.CVUReverseRecharge(CoreService.session.wizardNew.transactionId).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $log.log("CVUReverseRecharge|Server response is OK with data:");
          $log.log(response);
          ApiService.CVUExecuteRollback(CoreService.session.wizardNew.transactionId).then(function (response) {
            if (response.outcode == 200 || response.outcode == 201) {
              $log.log("cancelTransaction|Server response is OK with data:");
              $log.log(response);

              if (response.data.status == "CANCELED") {
                $log.log("cancelTransaction| Transaction " + CoreService.session.wizardNew.transactionId + " cancelled sucessfully.");
              } else {
                $log.error("cancelTransaction| Transaction " + CoreService.session.wizardNew.transactionId + " could not be cancelled correctly.");
              }
            } else {
              $log.error("cancelTransaction| Transaction " + CoreService.session.wizardNew.transactionId + " could not be cancelled correctly. Server returned " + response.outcode);
            }

            $scope.status = "Transacción cancelada";
            $scope.processCompleted = true;

            if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
              $scope.$apply();
            }

            $timeout(function () {
              $scope.refundStep = 1;

              if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
                $scope.$apply();
              } // $scope.initRefund();

            }, 1000);
          });
        } else {
          $log.error("CVUReverseRecharge| Transaction " + CoreService.session.wizardRecharge.transactionId + " could not be reverted correctly. Server returned " + response.outcode);
        }
      });
    };

    $scope.continueToRefund = function () {
      $scope.refundStep = 2;
      $scope.initRefund();
    };

    $scope.$on("$destroy", function () {
      $log.debug("Destroy called");
      $scope.pageCancelled = true;

      if ($scope.checkStatusTimeout) {
        $log.debug("Cancelling checkStatusTimeout...");
        $timeout.cancel($scope.checkStatusTimeout);
      }
    }); // Init payment

    $timeout(function () {
      // Check if page was closed
      if ($scope.pageCancelled) {
        $log.debug("Pages was destroyed before starting to request payment. Cancelling.");
        return;
      } // $scope.simCheckStatus();
      // $scope.initRefund();


      $scope.cancelTransaction();
    }, 2000);
    CoreService.sessionTimerStop();
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuNewStep7Process", {
    controller: CVUNewStep7ProcessController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-new/s7-process/cvu-new-s7-process.view.html"
  });
  /** @ngInject */

  function CVUNewStep7ProcessController($log, $scope, $state, $timeout, CoreService, ApiService) {
    $log.debug("CVU New Step 7 Process activated");
    $scope.commRetries = 2;
    $scope.processCompleted = false;
    $scope.status = "Enviando solicitud...";
    $scope.showErrors = false;
    $scope.statusCheckWait = 2000;
    $scope.statusChecks = 0;
    $scope.maxStatusChecks = 30;
    $scope.data = {
      tagId: 0
    };

    $scope["continue"] = function () {
      $state.go("cvu-new-s8-done");
    };

    $scope.process = function () {
      $log.debug("Process | CVUConfirm for trxId " + CoreService.session.wizardNew.payment.transaction.id + "...");
      var vehicle = {
        brand: CoreService.session.wizardNew.vehicle.brand,
        model: CoreService.session.wizardNew.vehicle.model,
        color: CoreService.session.wizardNew.vehicle.color,
        plateNumber: CoreService.session.wizardNew.vehicle.plateNumber
      };
      ApiService.CVUConfirm(CoreService.session.wizardNew.payment.transaction.id, vehicle).then(function (response) {
        $log.debug(response);

        if (response.outcode == 200 || response.outcode == 201) {
          if (response.data.status == "COMPLETED") {
            $scope["continue"]();
          } else {
            $log.error("Error on CVUConfirm, server returned status: " + response.data.status);
            $log.error(response);
            CoreService.showError("Error al confirmar", "No fue posible confirmar la transacción, se procederá a cancelar la misma y devolver el pago", null, true).then(function () {
              $state.go("cvu-new-s7b-refund");
            }, function () {});
          }
        } else {
          //
          // Server returned error
          //
          CoreService.showRetryDialog("No fue posible confirmar la transacción").then(function (retry) {
            if (retry) {
              $scope.process();
            } else {
              CoreService.showCancelDialog().then(function (cancel) {
                if (cancel) {
                  //
                  // User cancelled transaction
                  //
                  $state.go("cvu-new-s7b-refund");
                } else {
                  // Retry again
                  $scope.process();
                }
              }, function () {});
            }
          }, function () {});
          $log.error("Error on CVUConfirm, server returned error");
          $log.error(response);
        }
      }, function (err) {
        //
        // Comm error with server
        //
        CoreService.showRetryDialog("No fue posible confirmar la transacción").then(function (retry) {
          if (retry) {
            $scope.process();
          } else {
            CoreService.showCancelDialog().then(function (cancel) {
              if (cancel) {
                //
                // User cancelled transaction
                //
                $state.go("cvu-new-s7b-refund");
              } else {
                // Retry again
                $scope.process();
              }
            }, function () {});
          }
        }, function () {});
        $log.error("Error on CVUCheckTAG, comm error");
        $log.error(err);
      });
    };

    $timeout(function () {
      $scope.process();
    }, 3000);
    CoreService.sessionTimerStop();
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuNewStep6Tag", {
    controller: CVUNewStep6TagController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-new/s6-tag/cvu-new-s6-tag.view.html"
  });
  /** @ngInject */

  function CVUNewStep6TagController($log, $scope, $state, $window, $document, $timeout, ApiService, CoreService) {
    $log.debug("CVU New Step 6 Tag activated");
    $scope.status = "Esperando lectura de TAG...";
    $scope.scanCompleted = false;
    $scope.showErrors = false;
    $scope.data = {
      tagId: 0,
      printQty: CoreService.session.wizardNew.printQty
    };

    $scope.expendTag = function () {
      $log.log("Expending tag...");
      $scope.status = "Imprimiendo TAG...";

      if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
        $scope.$apply();
      } //
      // Send prin request
      //


      CoreService.printTag($scope.data.printQty, [CoreService.session.wizardNew.theoricTag]).then(function () {
        $timeout(function () {
          $log.log("Notifying expended tag to server for trxid " + CoreService.session.wizardNew.transactionId + " with qty " + CoreService.session.wizardNew.printQty);
          ApiService.expendedTag(CoreService.session.wizardNew.transactionId, CoreService.session.wizardNew.printQty).then(function (response) {
            if (response.outcode == 200 || response.outcode == 201) {
              $log.log("Tag expended notified to server successfully");
              $scope.status = "Esperando lectura de TAG...";

              if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
                $scope.$apply();
              }

              $scope.initializeOnScan();
            } else {
              //
              // Server returned error
              //
              CoreService.showRetryDialog("El TAG no se pudo imprimir correctamente").then(function (retry) {
                if (retry) {
                  $scope.expendTag();
                } else {
                  CoreService.showCancelDialog().then(function (cancel) {
                    if (cancel) {
                      //
                      // User cancelled transaction
                      //
                      $state.go("cvu-new-s7b-refund");
                    } else {
                      // Retry again
                      $scope.expendTag();
                    }
                  }, function () {});
                }
              }, function () {});
              $log.error("Error on CVUCheckTAG.printTag.expendedTag, server returned error");
              $log.error(response);
            }
          }, function (error) {
            //
            // Comm error with server
            //
            CoreService.showRetryDialog("Ocurrió un error al intentar imprimir el TAG").then(function (retry) {
              if (retry) {
                $scope.expendTag();
              } else {
                CoreService.showCancelDialog().then(function (cancel) {
                  if (cancel) {
                    //
                    // User cancelled transaction
                    //
                    $state.go("cvu-new-s7b-refund");
                  } else {
                    // Retry again
                    $scope.expendTag();
                  }
                }, function () {});
              }
            }, function () {});
            $log.error("Error on CVUCheckTAG.printTag.expendedTag, comm error");
            $log.error(error);
          });
        }, 1000);
      }, function () {
        $log.error("Error trying to print, showing retry dialog...");
        CoreService.showRetryDialog("No fue posible imprimir el tag").then(function (retry) {
          if (retry) {
            $scope.expendTag();
          } else {
            CoreService.showCancelDialog().then(function (cancel) {
              if (cancel) {
                $state.go("cvu-new-s7b-refund");
              } else {
                $scope.expendTag();
              }
            }, function () {});
          }
        }, function () {});
        return;
      });
    };

    $scope["continue"] = function () {
      var isValid = true;

      if (!$scope.data.tagId || $scope.data.tagId <= 0) {
        isValid = false;
      }

      if (!isValid) {
        $scope.showErrors = true;
        return;
      }
    };

    $scope.autoScanTimeout = null;

    $scope.initializeOnScan = function () {
      $log.log("Initializing onscan...");
      $window.onScan.attachTo($document[0], {
        suffixKeyCodes: [13],
        // enter-key expected at the end of a scan
        reactToPaste: true,
        // Compatibility to built-in scanners in paste-mode (as opposed to keyboard-mode)
        onScan: function onScan(sCode, iQty) {
          // Alternative to document.addEventListener('scan')
          $scope.processScan(sCode, iQty);
        },
        onKeyDetect: function onKeyDetect(iKeyCode) {
          // output all potentially relevant key events - great for debugging!
          $log.log("Pressed: " + iKeyCode);
        },
        onScanError: function onScanError(objDebug) {
          $log.error("Error: ");
          $log.error(objDebug);
        }
      });
      $scope.autoScanTimeout = setTimeout(function () {
        $scope.processScan(CoreService.session.wizardNew.theoricTag, 1);
      }, 10 * 1000);
    };

    $scope.detachOnScan = function () {
      $window.onScan.detachFrom($document[0]);
    };

    $scope.processScan = function (sCode, iQty) {
      clearTimeout($scope.autoScanTimeout); // Alternative to document.addEventListener('scan')
      //
      // TODO: Evaluate sCode read
      //

      var tagCode = sCode;
      var tagQty = iQty;
      $log.log("Scanned: " + tagQty + "x " + tagCode);
      CoreService.session.wizardNew.tagCode = tagCode; //
      // Validate TAG at server
      //

      $scope.status = "Verificando TAG...";

      if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
        $scope.$apply();
      }

      $timeout(function () {
        ApiService.CVUCheckTAG(CoreService.session.wizardNew.transactionId, tagCode).then(function (response) {
          if (response.outcode == 200 || response.outcode == 201) {
            if (response.data.status == "FREE") {
              //
              // TAG is correct, continue
              //
              $scope.status = "TAG leído correctamente!";
              $scope.scanCompleted = true;

              if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
                $scope.$apply();
              }

              $timeout(function () {
                $state.go("cvu-new-s7-process");
              }, 2000);
            } else {
              //
              // TAG is INVALID, ask for a new one
              //
              CoreService.showRetryDialog("El TAG no es válido, por favor retire otro y vuelva a escanearlo").then(function (retry) {
                if (retry) {
                  $scope.status = "Esperando lectura de nuevo TAG...";

                  if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
                    $scope.$apply();
                  }
                } else {
                  CoreService.showCancelDialog().then(function (cancel) {
                    if (cancel) {
                      //
                      // User cancelled transaction
                      //
                      $state.go("cvu-new-s7b-refund");
                    } else {
                      //
                      // Retry again
                      //
                      $scope.status = "Esperando lectura de nuevo TAG...";

                      if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
                        $scope.$apply();
                      }
                    }
                  }, function () {});
                }
              }, function () {});
            }
          } else {
            //
            // Server returned error
            //
            CoreService.showRetryDialog("El TAG no se pudo verificar").then(function (retry) {
              if (retry) {//$scope.processScan(tagCode, tagQty);
                // Let user scan the tag again
              } else {
                CoreService.showCancelDialog().then(function (cancel) {
                  if (cancel) {
                    //
                    // User cancelled transaction
                    //
                    $state.go("cvu-new-s7b-refund");
                  } else {// Retry again
                    // $scope.processScan(tagCode, tagQty);
                    // Let user scan the tag again
                  }
                }, function () {});
              }
            }, function () {});
            $log.error("Error on CVUCheckTAG, server response with error");
            $log.error(response);
          }
        }, function (error) {
          //
          // Comm error with server
          //
          CoreService.showRetryDialog("Ocurrió un error al intentar verificar el TAG").then(function (retry) {
            if (retry) {// $scope.processScan(tagCode, tagQty);
              // Let user scan the tag again
            } else {
              CoreService.showCancelDialog().then(function (cancel) {
                if (cancel) {
                  //
                  // User cancelled transaction
                  //
                  $state.go("cvu-new-s7b-refund");
                } else {// Retry again
                  // $scope.processScan(tagCode, tagQty);
                  // Let user scan the tag again
                }
              }, function () {});
            }
          }, function () {});
          $log.error("Error on CVUCheckTAG, comm error");
          $log.error(error);
        });
      }, 1000);
    };

    $scope.simulateScan = function () {
      $window.onScan.simulate(document, CoreService.session.wizardNew.theoricTag);
    };

    $scope.simulateScanWrong = function () {
      $window.onScan.simulate(document, "E280110C20007A8EC5A7099C");
    };

    $scope.$on("$destroy", function () {
      $log.log("Destroying onscan...");
      $scope.detachOnScan();
    }); //
    // Init
    //

    CoreService.sessionTimerStop();
    $scope.expendTag(); // $scope.initializeOnScan();
    // $timeout(() => {
    //   $scope.status = 'TAG leído correctamente!';
    //   $scope.scanCompleted = true;
    // }, 2000);
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuNewStep5Pay", {
    controller: CVUNewStep5PayController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-new/s5-pay/cvu-new-s5-pay.view.html"
  });
  /** @ngInject */

  function CVUNewStep5PayController($log, $scope, $state, $timeout, CoreService, ApiService) {
    $scope.payStep = 0;
    $scope.paymentData = {
      transactionId: null,
      customerId: null,
      status: null
    };
    $scope.payCompleted = false;
    $scope.checkedTimes = 0;
    $scope.commRetries = 2;
    $scope.statusCheckWait = 2000;
    $scope.processCompleted = false;
    $scope.processChecks = 0;
    $scope.maxStatusChecks = 40;
    $scope.amountToPay = parseInt(CoreService.session.wizardNew.amount.amount).toString();
    $log.debug("CVU New Step 5 Pay activated");
    $scope.processStatus = "Preparando la transacción...";
    $scope.status = "Enviando transacción a POS...";

    $scope["continue"] = function () {
      $state.go("cvu-new-s6-tag");
    }; //
    // CVU Process
    //


    $scope.CVUProcess = function () {
      $log.debug("Process | CVUExecuteStart for trxId " + CoreService.session.wizardNew.transactionId + "...");
      var vehicle = {
        brand: CoreService.session.wizardNew.vehicle.brand,
        model: CoreService.session.wizardNew.vehicle.model,
        color: CoreService.session.wizardNew.vehicle.color,
        plateNumber: CoreService.session.wizardNew.vehicle.plateNumber
      };
      $scope.commRetries = 2;
      ApiService.CVUExecuteStart(CoreService.session.wizardNew.transactionId, vehicle, CoreService.session.wizardNew.user.externalId, CoreService.session.wizardNew.amount, CoreService.session.wizardNew.user).then(function (response) {
        $log.debug(response);

        if (response.outcode == 200 || response.outcode == 201) {
          $scope.CVUCheckStatus();
        } else {
          //
          // Server returned error
          //
          // CoreService.showError("Ocurrió un error", response.message, response.outcode);
          CoreService.showRetryDialog("No se pudo iniciar el procesamiento", response.outcode, response.message).then(function (retry) {
            if (retry) {
              $scope.CVUProcess();
            } else {
              $state.go("start");
            }
          }, function () {});
          $log.error("Error on CVUProcess");
          $log.error(response);
        }
      }, function (err) {
        //
        // Server comm error
        //
        if (err.outcode == -2) {
          $log.error("CVUProcess|Process with timeout!");

          if ($scope.commRetries > 0) {
            $scope.commRetries--;
            $log.debug("Retrying...");
            $scope.status = "Reintenando enviar solicitud #" + $scope.commRetries + "...";
            $scope.CVUProcess();
          } else {
            $log.error("CVUProcess|Process with timeout and no more retries!");
            CoreService.showError("Ocurrió un error", "No fue posible procesar la transacción.");
            $log.error("Error on CVUProcess 3");
            $log.error(err);
          }
        } else {
          // CoreService.showError("Ocurrió un error", "No fue posible procesar la transacción.");
          CoreService.showRetryDialog("Ocurrió un error de comunicación").then(function (retry) {
            if (retry) {
              $scope.CVUProcess();
            } else {
              $state.go("start");
            }
          }, function () {});
          $log.error("Error on CVUProcess 2");
          $log.error(err);
        }
      });
    };

    $scope.CVUCheckStatus = function () {
      $scope.processStatus = "Esperando respuesta...";
      $scope.processChecks++;
      $log.log("checkStatus|Checking (" + $scope.processChecks + ") process for trx " + CoreService.session.wizardNew.transactionId);
      ApiService.CVUExecuteStatus(CoreService.session.wizardNew.transactionId).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $log.log("checkStatus|Server response is OK with data:");
          $log.log(response);

          if (response.data.status == "EXECUTED") {
            //
            // Update screen and continue to process
            //
            $log.log("checkStatus|Process completed successfully, finishing..."); // $scope.processStatus = 'Proceso completado con éxito';

            $scope.processCompleted = true;

            if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
              $scope.$apply();
            }

            $timeout(function () {
              $scope.showPreparePay();
            }, 3000);
          } else if (response.data.status == "PROCESSING") {
            //
            // Process still in course, wait 2 seconds
            //
            if ($scope.processChecks == $scope.maxStatusChecks) {
              $log.log("checkStatus|Max checks reached! Ask to manual retry");
              CoreService.showRetryDialog("No se pudo verificar la transacción").then(function (retry) {
                if (retry) {
                  $scope.CVUProcess();
                } else {
                  $state.go("start");
                }
              }, function () {});
            } else {
              $log.log("checkStatus|Process not completed yet, re-checking in 2 seconds...");
              $scope.checkStatusTimeout = $timeout(function () {
                $scope.CVUCheckStatus();
              }, $scope.statusCheckWait);
            }
          } else {
            //
            // Server status is not correct
            //
            $log.error("checkStatus|Process with error!");
            $log.error("Error on continue 1");
            $log.error(response);
            CoreService.showError("Ocurrió un error", response.data.errorDesc, response.data.errorCode, true).then(function () {
              //
              // Execute rollback to undo transaction
              //
              $scope.cancelTransaction();
            }, function () {});
          }
        } else {
          //
          // Server returned error
          //
          CoreService.showRetryDialog("Ocurrió un error verificando la transacción").then(function (retry) {
            if (retry) {
              $scope.CVUCheckStatus();
            } else {
              $state.go("start");
            }
          }, function () {});
          $log.error("Error on continue 2");
          $log.error(response); // $scope.showError("Ocurrió un error", response.message, response.outcode);
        }
      }, function (error) {
        $log.error("Error on continue 3");
        $log.error(error); // $scope.showError("Ocurrió un error", error.message, error.outcode);

        CoreService.showRetryDialog("Ocurrió un error verificando la transacción").then(function (retry) {
          if (retry) {
            $scope.CVUCheckStatus();
          } else {
            $state.go("start");
          }
        }, function () {});
      });
    };

    $scope.showError = function (localMsg, serverMsg, serverOutcode) {
      var msg = serverMsg && serverMsg.length > 0 ? serverMsg : localMsg;
      CoreService.showError("No se pudo procesar la transacción", msg, serverOutcode, true).then(function () {
        $state.go("start");
      }, function () {});
    };

    $scope.showPreparePay = function () {
      $scope.payStep = 1;
    };

    $scope.continueToPay = function () {
      $scope.payStep = 2;
      $scope.initPayment();
    }; //
    // Payment Process
    //


    $scope.initPayment = function () {
      ApiService.SareaPay(CoreService.session.wizardNew).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $scope.paymentData = response.data;
          $timeout(function () {
            $scope.checkStatus();
          }, response.data.timeout && response.data.timeout > 0 && response.data.timeout < 60000 ? response.data.timeout * 1000 : 5000);
        } else {
          $log.error("Error on initPayment");
          $log.error(response);
          CoreService.showRetryDialog("No se pudo iniciar el pago").then(function (retry) {
            if (retry) {
              $scope.initPayment();
            } else {
              $log.warn("User cancelled, starting rollback at CVU...");
              $scope.cancelTransaction();
            }
          }, function () {});
        }
      }, function (error) {
        // CoreService.showError("Ocurrió un error", error.message, error.outcode);
        $log.error("Error on initPayment (2)");
        $log.error(error);
        CoreService.showRetryDialog("Ocurrió un error al iniciar el pago").then(function (retry) {
          if (retry) {
            $scope.initPayment();
          } else {
            $log.warn("User cancelled (2), starting rollback at CVU...");
            $scope.cancelTransaction();
          }
        }, function () {});
      });
    };

    $scope.checkStatus = function () {
      $scope.status = "Esperando pago...";
      $log.log("checkPayStatus|Checking payment for trx " + $scope.paymentData.transactionId + " and customer " + $scope.paymentData.customerId);
      ApiService.SareaCheckPayment($scope.paymentData.id, $scope.paymentData.transaction.id).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $log.log("checkPayStatus|Server response is OK with data:");
          $log.log(response);

          if (response.data.status == "PAID") {
            $log.log("checkPayStatus|Payment completed successfully, moving to next step...");
            CoreService.session.wizardNew.payment = $scope.paymentData;
            $scope.status = "Pago completado con éxito";
            $scope.payCompleted = true;

            if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
              $scope.$apply();
            }

            $timeout(function () {
              $scope["continue"]();
            }, 3000);
          } else if (response.data.status == "PAYING") {
            $log.log("checkPayStatus|Payment not completed yet (paying), re-checking in " + $scope.statusCheckWait + " second...");
            $timeout(function () {
              $scope.checkStatus();
            }, $scope.statusCheckWait);
          } else if (response.data.status == "PENDING") {
            $log.log("checkPayStatus|Payment not completed yet (pending), re-checking in " + $scope.statusCheckWait + " second...");
            $timeout(function () {
              $scope.checkStatus();
            }, $scope.statusCheckWait);
          } else {
            $log.log("checkPayStatus|Payment returned errored status!");
            $log.error(response); // CoreService.showError("Ocurrió un error", response.data.message);

            CoreService.showRetryDialog("El pago no se pudo completar").then(function (retry) {
              if (retry) {
                $scope.initPayment();
              } else {
                $log.warn("User cancelled at errored status payment, starting rollback at CVU...");
                $scope.cancelTransaction();
              }
            }, function () {});
          }
        } else {
          // CoreService.showError("Ocurrió un error", response.message, response.outcode);
          $log.error("checkPayStatus|Error on server response ");
          $log.error(response);
          CoreService.showRetryDialog("El pago no se pudo completar").then(function (retry) {
            if (retry) {
              $scope.initPayment();
            } else {
              $log.warn("User cancelled at payment server response error, starting rollback at CVU...");
              $scope.cancelTransaction();
            }
          }, function () {});
        }
      }, function (error) {
        // CoreService.showError("Ocurrió un error", error.message, error.outcode);
        $log.error("checkPayStatus|Error on server comm");
        $log.error(error);
        CoreService.showRetryDialog("El pago no se pudo completar").then(function (retry) {
          if (retry) {
            $scope.initPayment();
          } else {
            $log.warn("checkPayStatus|User cancelled at payment server comm error, starting rollback at CVU...");
            $scope.cancelTransaction();
          }
        }, function () {});
      });
    };

    $scope.simInitPayment = function () {
      $timeout(function () {
        $scope.simCheckStatus();
      }, 5000);
    };

    $scope.simCheckStatus = function () {
      $scope.status = "Esperando pago...";
      $timeout(function () {
        CoreService.session.wizardNew.payment = {
          amount: "25000.00",
          amountDiscount: "0.00",
          id: 76,
          status: "PAID",
          statusDesc: "TRANSACCION EJECUTADA CON SUCESO",
          transaction: {
            id: 141,
            type: "",
            status: "PAID",
            userId: 141,
            errorCode: null,
            errorDesc: null
          },
          errorCode: null,
          errorDesc: null,
          type: "",
          userId: 141
        };
        $scope.status = "Pago completado con éxito";
        $scope.payCompleted = true;
        $timeout(function () {
          $timeout(function () {
            $scope.status = "Le llegará una notificación de la transacción vía correo electrónico";
          }, 3000);
          $scope["continue"]();
        }, 3000);
      }, 3000);
    };

    $scope.cancelTransaction = function () {
      $scope.payStep = 4;
      $scope.status = "Cancelando transacción...";
      $scope.processCompleted = false;
      $log.log("cancelTransaction|Cancelling trx " + CoreService.session.wizardNew.transactionId);
      ApiService.CVUReverseRecharge(CoreService.session.wizardNew.transactionId).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $log.log("CVUReverseRecharge|Server response is OK with data:");
          $log.log(response);
          ApiService.CVUExecuteRollback(CoreService.session.wizardNew.transactionId).then(function (response) {
            if (response.outcode == 200 || response.outcode == 201) {
              $log.log("cancelTransaction|Server response is OK with data:");
              $log.log(response);

              if (response.data.status == "CANCELED") {
                $log.log("cancelTransaction| Transaction " + CoreService.session.wizardNew.transactionId + " cancelled sucessfully.");
              } else {
                $log.error("cancelTransaction| Transaction " + CoreService.session.wizardNew.transactionId + " could not be cancelled correctly.");
              }
            } else {
              $log.error("cancelTransaction| Transaction " + CoreService.session.wizardNew.transactionId + " could not be cancelled correctly. Server returned " + response.outcode);
            }

            $scope.status = "Transacción cancelada";
            $scope.processCompleted = true;

            if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
              $scope.$apply();
            }

            $timeout(function () {
              CoreService.clearSession();
              $state.go("start");
            }, 3000);
          });
        } else {
          $log.error("CVUReverseRecharge| Transaction " + CoreService.session.wizardRecharge.transactionId + " could not be reverted correctly. Server returned " + response.outcode);
        }
      });
    };

    $scope.cancel = function () {
      CoreService.showCancelDialog().then(function (cancel) {
        if (cancel) {
          $scope.cancelTransaction();
        }
      }, function (err) {
        $log.error(err);
      });
    }; // Init payment


    $timeout(function () {
      // $scope.simInitPayment();
      // $scope.initPayment();
      $scope.CVUProcess();
    }, 2000);
    CoreService.sessionTimerStop();
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuNewStep4Topup", {
    controller: CVUNewStep4TopupController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-new/s4-topup/cvu-new-s4-topup.view.html"
  });
  /** @ngInject */

  function CVUNewStep4TopupController($log, $scope, $document, $window, CoreService, ApiService, $state) {
    $log.debug("CVU New Step 4 TopUp activated");
    $scope.keyboardLayout = "number";
    $scope.keyboardInput = "";
    $scope.showErrors = false;
    $scope.showKeyboard = false;
    $scope.data = {
      rechargeAmount: 0,
      amounts: null,
      includesTaxes: false
    };

    $scope.initialize = function () {
      CoreService.showProgress();
      $scope.showKeyboard = false;

      try {
        ApiService.CVUGetRechargeAmounts().then(function (response) {
          if (response.data && response.data.length) {
            for (var i = 0; i < response.data.length; i++) {
              response.data[i].amountNice = parseInt(response.data[i].amount).toString();
            }

            $scope.data.amounts = response.data;

            if ($scope.data.amounts && $scope.data.amounts.length) {
              $scope.data.includesTaxes = $scope.data.amounts[0].includesTaxes;
            }
          }

          CoreService.hideProgress();
          $scope.$apply();
        }, function (error) {
          CoreService.showError("Ocurrió un error", error.message, error.outcode);
          $log.error("Error on continue");
          $log.error(error);
          CoreService.hideProgress();
        });
      } catch (exc) {
        $log.error("Exception catched on continue");
        CoreService.hideProgress();
      }
    };

    $scope.select = function (amount) {
      // Store data in session
      CoreService.session.wizardNew.amount = amount;
      $state.go("cvu-new-s5-pay"); // $state.go('cvu-new-s6-tag');
    };

    $scope.selectCustom = function () {
      $scope.showKeyboard = true;
      CoreService.showCustomAmountSelector($scope).then(function (customAmount) {
        CoreService.session.wizardNew.amount = {
          amount: customAmount
        };
        $state.go("cvu-new-s5-pay");
      }, function (error) {
        if (error) {
          $log.error(error);
        } else {
          $scope.showKeyboard = false;
        }
      });
    };

    $scope.cancel = function () {
      CoreService.showCancelDialog().then(function (cancel) {
        if (cancel) {
          CoreService.clearSession();
          $state.go("start");
        }
      }, function (err) {
        $log.error(err);
      });
    };

    $scope.goBack = function () {
      if (CoreService.session.wizardNew.operation == "NEW_CLIENT") {
        $state.go("cvu-new-s2-user-data");
      } else if (CoreService.session.wizardNew.operation == "ADD_VEHICLE") {
        $state.go("cvu-new-s1-id");
      } else if (CoreService.session.wizardNew.operation == "ASSIGN_TAG") {
        $state.go("cvu-new-s1-id");
      } else {
        $state.go("cvu-new-s1-id");
      }
    };

    $scope.initialize(); //
    // Session timeout handler

    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuNewStep3Vehicle", {
    controller: CVUNewStep3VehicleController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-new/s3-vehicle/cvu-new-s3-vehicle.view.html"
  });
  /** @ngInject */

  function CVUNewStep3VehicleController($log, $scope, $document, $window, CoreService, ApiService, $state
  /*, $rootScope */
  ) {
    $log.debug("CVU New Step 3 Vehicle activated"); // $scope.form = $document[0].getElementById('s2form');

    $scope.keyboardLayout = "default";
    $scope.keyboardInput = "";
    $scope.showErrors = false;
    $scope.showKeyboard = false;

    if ($window.IS_DEBUG) {
      $scope.data = {
        vehicleBrand: $window.DEBUG_DATA.vehicleBrand ? $window.DEBUG_DATA.vehicleBrand : {
          id: null,
          name: null
        },
        vehicleModel: $window.DEBUG_DATA.vehicleModel ? $window.DEBUG_DATA.vehicleModel : {
          id: null,
          name: null
        },
        vehicleColor: $window.DEBUG_DATA.vehicleColor ? $window.DEBUG_DATA.vehicleColor : {
          id: null,
          name: null
        }
      };
    } else {
      $scope.data = {
        vehicleBrand: {
          id: null,
          name: null
        },
        vehicleModel: {
          id: null,
          name: null
        },
        vehicleColor: {
          id: null,
          name: null
        }
      };
    }

    $scope.pickBrand = function () {
      $scope.keyboardInput = $document[0].getElementById("bt-search");
      CoreService.showVehicleBrandSelector($scope).then(function (selectedBrand) {
        $scope.data.vehicleBrand = selectedBrand;
        $scope.data.vehicleModel = [];
        $scope.showKeyboard = false;
      }, function () {
        $scope.showKeyboard = false;
      });
    };

    $scope.pickModel = function () {
      $scope.keyboardInput = $document[0].getElementById("bt-search");

      if ($scope.data.vehicleBrand && $scope.data.vehicleBrand.id && $scope.data.vehicleBrand.id > 0) {
        CoreService.showVehicleModelSelector($scope.data.vehicleBrand.id, $scope).then(function (selectedModel) {
          $scope.data.vehicleModel = selectedModel;
          $scope.showKeyboard = false;
        }, function () {
          $scope.showKeyboard = false;
        });
      } else {
        CoreService.showMessage(null, "Seleccione una marca primero");
      }
    };

    $scope.pickColor = function () {
      CoreService.showVehicleColorSelector(null, $scope).then(function (selectedColor) {
        $scope.data.vehicleColor = selectedColor;
        $scope.showKeyboard = false;
      }, function () {
        $scope.showKeyboard = false;
      });
    };

    $scope.cancel = function () {
      CoreService.showCancelDialog().then(function (cancel) {
        if (cancel) {
          CoreService.clearSession();
          $state.go("start");
        }
      }, function (err) {
        $log.error(err);
      });
    };

    $scope.isDataValid = function () {
      var canContinue = $scope.data.vehicleBrand && $scope.data.vehicleBrand.name && $scope.data.vehicleBrand.name.length && $scope.data.vehicleModel && $scope.data.vehicleModel.name && $scope.data.vehicleModel.name.length && $scope.data.vehicleColor && $scope.data.vehicleColor.name && $scope.data.vehicleColor.name.length;
      return canContinue;
    };

    $scope["continue"] = function () {
      if (!$scope.isDataValid()) {
        $scope.showErrors = true;
        return;
      } // Store data in session


      CoreService.session.wizardNew.vehicle.brand = $scope.data.vehicleBrand;
      CoreService.session.wizardNew.vehicle.model = $scope.data.vehicleModel;
      CoreService.session.wizardNew.vehicle.color = $scope.data.vehicleColor;
      $state.go("cvu-new-s4-topup");
    };

    $scope.goBack = function () {
      if (CoreService.session.wizardNew.operation == "NEW_CLIENT") {
        $state.go("cvu-new-s2-user-data");
      } else if (CoreService.session.wizardNew.operation == "ADD_VEHICLE") {
        $state.go("cvu-new-s1-id");
      } else if (CoreService.session.wizardNew.operation == "ASSIGN_TAG") {
        $state.go("cvu-new-s1-id");
      } else {
        $state.go("cvu-new-s1-id");
      }
    }; //
    // Session timeout handler


    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuNewStep2UserData", {
    controller: CVUNewStep2UserDataController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-new/s2-user-data/cvu-new-s2-user-data.view.html"
  });
  /** @ngInject */

  function CVUNewStep2UserDataController($log, $scope, $rootScope, $document, $timeout, $state, CoreService, $window) {
    $log.debug("CVU New Step 2 User Data activated"); // $scope.form = $document[0].getElementById('s2form');

    $scope.keyboardLayout = "default";
    $scope.keyboardInput = "";
    $scope.showKeyboard = true;
    $scope.showErrors = false;
    $scope.data = {};

    if ($window.IS_DEBUG) {
      $scope.data = {
        userName: $window.DEBUG_DATA.userName ? $window.DEBUG_DATA.userName : "",
        userCel: $window.DEBUG_DATA.userCel ? $window.DEBUG_DATA.userCel : "",
        userEmail: $window.DEBUG_DATA.userEmail ? $window.DEBUG_DATA.userEmail : ""
      };
    }

    $scope.showFields = {
      userName: true,
      userCel: true,
      userEmail: true
    };
    $scope.operation = CoreService.session.wizardNew.operation;

    $scope.init = function () {
      if (CoreService.session.wizardNew.operation != "NEW_CLIENT") {
        $scope.showFields.userName = !(CoreService.session.wizardNew.user.name && CoreService.session.wizardNew.user.name.length > 0);
        $scope.showFields.userCel = !(CoreService.session.wizardNew.user.cel && CoreService.session.wizardNew.user.cel.toString().length > 0);
        $scope.showFields.userEmail = !(CoreService.session.wizardNew.user.email && CoreService.session.wizardNew.user.email.length > 0);
      }
    };

    $scope.inputFocus = function (ev) {
      $scope.showKeyboard = true;
      $rootScope.$broadcast("keyboard::changeInput", ev.target.value ? ev.target.value : ""); // $scope.keyboardInput = ev.target.value ? ev.target.value : '';

      if (ev.target.id == "userEmail") {
        $scope.keyboardLayout = "email";
      } else if (ev.target.id == "userCel") {
        $scope.keyboardLayout = "phoneNumber";
      } else {
        $scope.keyboardLayout = "default";
      }
    };

    $scope["continue"] = function (isValid) {
      if (!isValid) {
        $scope.showErrors = true;
        return;
      } // Store data in session


      CoreService.session.wizardNew.user.name = $scope.data.userName;
      CoreService.session.wizardNew.user.cel = $scope.data.userCel;
      CoreService.session.wizardNew.user.email = $scope.data.userEmail;

      if (CoreService.session.wizardNew.operation == "NEW_CLIENT" || CoreService.session.wizardNew.operation == "ADD_VEHICLE") {
        CoreService.session.wizardNew.vehicle.brand = {
          id: 1,
          name: "Indefinido"
        };
        CoreService.session.wizardNew.vehicle.model = {
          id: 2506,
          name: "Indefinido"
        };
        CoreService.session.wizardNew.vehicle.color = {
          id: 1,
          name: "Indefinido"
        };
        $log.log("Skipped vehicle selection");
        $state.go("cvu-new-s4-topup");
      } else if (CoreService.session.wizardNew.operation == "ASSIGN_TAG") {
        $state.go("cvu-new-s4-topup");
      } else {
        $state.go("cvu-new-s4-topup");
      }
    };

    $scope.cancel = function () {
      CoreService.showCancelDialog().then(function (cancel) {
        if (cancel) {
          CoreService.clearSession();
          $state.go("start");
        }
      }, function (err) {
        $log.error(err);
      });
    };

    $scope.goBack = function () {
      $state.go("cvu-new-s1-id");
    };

    $scope.init();
    $timeout(function () {
      var e = $document[0].getElementById("userName");
      if (e) e.focus();
    }, 500); //
    // Session timeout handler

    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuNewStep1User", {
    controller: CVUNewStep1UserController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/wizard-new/s1-id/cvu-new-s1-id.view.html"
  });
  /** @ngInject */

  function CVUNewStep1UserController($log, $scope, $rootScope, $state, $document, $timeout, CoreService, ApiService, $window) {
    $log.debug("CVU New Step 1 User activated");
    $scope.keyboardLayout = "default";
    $scope.keyboardInput = "";
    $scope.showKeyboard = true;
    $scope.showErrors = false;
    $scope.data = {
      userDocType: 2,
      userDocValue: "",
      vehiclePlateNumber: ""
    };

    if ($window.IS_DEBUG && window.DEBUG_DATA) {
      if ($window.DEBUG_DATA.vehiclePlateNumber && $window.DEBUG_DATA.vehiclePlateNumber.length > 0) {
        $window.DEBUG_DATA.vehiclePlateNumber = $window.DEBUG_DATA.vehiclePlateNumber.slice(0, -4) + CoreService.zeroPad(parseInt($window.DEBUG_DATA.vehiclePlateNumber.slice(-4)) + 1, 4);
        $scope.data = {
          userDocType: $window.DEBUG_DATA.userDocType ? $window.DEBUG_DATA.userDocType : 0,
          userDocValue: $window.DEBUG_DATA.userDocValue ? $window.DEBUG_DATA.userDocValue : "",
          vehiclePlateNumber: $window.DEBUG_DATA.vehiclePlateNumber ? $window.DEBUG_DATA.vehiclePlateNumber : ""
        };
      }
    }

    function clean_ci(ci) {
      return ci.replace(/\D/g, "");
    }

    function validation_digit(ci) {
      var a = 0;
      var i = 0;

      if (ci.length <= 6) {
        for (i = ci.length; i < 7; i++) {
          ci = "0" + ci;
        }
      }

      for (i = 0; i < 7; i++) {
        a += parseInt("2987634"[i]) * parseInt(ci[i]) % 10;
      }

      if (a % 10 === 0) {
        return 0;
      } else {
        return 10 - a % 10;
      }
    }

    function validate_ci(ci) {
      ci = clean_ci(ci);
      var dig = ci[ci.length - 1];
      ci = ci.replace(/[0-9]$/, "");
      return dig == validation_digit(ci);
    }

    $scope.validateDocValue = function () {
      if ($scope.data.userDocType == 2) {
        return validate_ci($scope.data.userDocValue);
      }

      return true;
    };

    $scope.inputFocus = function (ev) {
      $scope.showKeyboard = true; // $scope.keyboard.setInput(ev.target.value);
      // if ($scope.keyboardInput){
      //   $log.log('Setting input from ' + $scope.keyboardInput + ' to ' + ev.target.value + ' (' + ev.target.name + ')');
      // }else{
      //   $log.log('Setting input from undefined to ' + ev.target.name + ' (' + ev.target.value + ')');
      // }

      $rootScope.$broadcast("keyboard::changeInput", ev.target.value); // $scope.keyboardInput = ev.target.value;

      if (ev.target.id == "userDocValue") {
        $timeout(function () {
          switch ($scope.data.userDocType) {
            case 1:
              $scope.keyboardLayout = "number";
              break;

            case 2:
              $scope.keyboardLayout = "number";
              break;

            case 3:
              $scope.keyboardLayout = "default";
              break;

            case 4:
              $scope.keyboardLayout = "default";
              break;
          }
        }, 50);
      } else if (ev.target.id == "vehiclePlateNumber") {
        // $scope.keyboard.setOptions({
        //   layoutName: 'default'
        // });
        $scope.keyboardLayout = "default";
      }
    };

    $scope.docTypeSelect = function (value) {
      $document[0].getElementById("userDocValue").focus();
    };

    $scope["continue"] = function (isValid) {
      if (!isValid) {
        $scope.showErrors = true;
        return;
      } // Store data in session


      CoreService.session.wizardNew.user = {
        docType: $scope.data.userDocType,
        docValue: $scope.data.userDocValue
      };
      CoreService.session.wizardNew.vehicle = {
        plateNumber: $scope.data.vehiclePlateNumber
      }; // $state.go('cvu-new-s2-user-data');
      // return;

      CoreService.showProgress();
      $scope.showKeyboard = false;

      try {
        ApiService.CVUStartNewTag($scope.data).then(function (response) {
          // $log.log(response);
          CoreService.hideProgress();
          $scope.showKeyboard = true; //
          // Evaluate response
          //

          if (response.data.operation) {
            CoreService.session.wizardNew.operation = response.data.operation;

            if (response.data.operation == "NEW_CLIENT") {
              CoreService.session.wizardNew.transactionId = response.data.transactionId;
              CoreService.session.wizardNew.theoricTag = response.data.tagCode;
              CoreService.session.wizardNew.theoricTagId = response.data.tagId;
              CoreService.session.wizardNew.printQty = response.data.printQty;
              $state.go("cvu-new-s2-user-data");
            } else if (response.data.operation == "ADD_VEHICLE") {
              CoreService.session.wizardNew.transactionId = response.data.transactionId;
              CoreService.session.wizardNew.user.name = response.data.userName;
              CoreService.session.wizardNew.user.cel = response.data.userCel;
              CoreService.session.wizardNew.user.email = response.data.userEmail;
              CoreService.session.wizardNew.user.externalId = response.data.nroCliente;
              CoreService.session.wizardNew.theoricTag = response.data.tagCode;
              CoreService.session.wizardNew.theoricTagId = response.data.tagId;
              CoreService.session.wizardNew.printQty = response.data.printQty;

              if ($scope.userDataComplete()) {
                CoreService.session.wizardNew.vehicle.brand = {
                  id: 1,
                  name: "Indefinido"
                };
                CoreService.session.wizardNew.vehicle.model = {
                  id: 2506,
                  name: "Indefinido"
                };
                CoreService.session.wizardNew.vehicle.color = {
                  id: 1,
                  name: "Indefinido"
                };
                $log.log("Skipped vehicle selection");
                $state.go("cvu-new-s4-topup");
              } else {
                $log.warn("User data is not complete, will ask for more data");
                $state.go("cvu-new-s2-user-data");
              }
            } else if (response.data.operation == "ASSIGN_TAG") {
              CoreService.session.wizardNew.transactionId = response.data.transactionId;
              CoreService.session.wizardNew.user.name = response.data.userName;
              CoreService.session.wizardNew.user.cel = response.data.userCel;
              CoreService.session.wizardNew.user.email = response.data.userEmail;
              CoreService.session.wizardNew.user.externalId = response.data.nroCliente;
              CoreService.session.wizardNew.theoricTag = response.data.tagCode;
              CoreService.session.wizardNew.theoricTagId = response.data.tagId;
              CoreService.session.wizardNew.printQty = response.data.printQty; // User and vehicle are already created.
              // Check if user data is complete

              if ($scope.userDataComplete()) {
                $state.go("cvu-new-s4-topup");
              } else {
                $log.warn("User data is not complete, will ask for more data");
                $state.go("cvu-new-s2-user-data");
              }
            } else {
              //
              // Unknown operation received!
              //
              $scope.showKeyboard = false;
              CoreService.showError("Ocurrió un error", response.data.error && response.data.error.length ? response.data.error : "Operación desconocida", "-1");
              $log.error("Unknown operation received!");
              $log.error(response);
            }
          } else {
            //
            // Empty operation received!
            //
            $scope.showKeyboard = false;
            CoreService.showError("Ocurrió un error", response.data.error && response.data.error.length ? response.data.error : "No se recibió operación", "-1");
            $log.error("Empty operation received");
          }
        }, function (error) {
          CoreService.showError("Ocurrió un error", error.message, error.outcode);
          $log.error("Error on continue");
          $log.error(error);
          $scope.showKeyboard = false;
          CoreService.hideProgress();
        });
      } catch (exc) {
        $log.error("Exception catched on continue");
        $log.error(exc);
        $scope.showKeyboard = false;
        CoreService.hideProgress();
      }
    };

    $scope.userDataComplete = function () {
      var isComplete = false;

      if (CoreService.session.wizardNew.user.cel && CoreService.session.wizardNew.user.cel.toString().length && CoreService.session.wizardNew.user.email && CoreService.session.wizardNew.user.email.length && CoreService.session.wizardNew.user.name && CoreService.session.wizardNew.user.name.length) {
        isComplete = true;
      }

      return isComplete;
    };

    $scope.cancel = function () {
      CoreService.clearSession();
      $state.go("start");
    };

    $scope.goBack = function () {
      $state.go("start");
    };

    $timeout(function () {
      var e = $document[0].getElementById("userDocValue");
      if (e) e.focus();
    }, 500); //
    // Session timeout handler

    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuSupportScreen", {
    controller: CVUSupportScreenController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/support-screen/cvu-support-screen.view.html"
  });
  /** @ngInject */

  function CVUSupportScreenController($log, $scope, $state, CoreService) {
    $log.debug("CVU Support Screen activated");
    $scope.data = CoreService.session;

    $scope.finish = function () {
      $state.go("home");
    }; //
    // Session timeout handler


    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("cvuInfo", {
    controller: CVUInfoController,
    controllerAs: "vm",
    templateUrl: "app/pages/cvu/info/cvu-info.view.html"
  });
  /** @ngInject */

  function CVUInfoController($log, $scope, $state, CoreService, uiGmapGoogleMapApi) {
    $scope.map = null;
    $scope.gAPIKey = "AIzaSyC0aYDd9d-wJHe0pLunCw_POfyaAm6Rfv8";
    $log.debug("CVU Info Screen activated");
    $scope.tolls = [{
      key: "barraSantaLucia",
      name: "Barra de Santa Lucía",
      address: "Ruta 1 Km. 23.500",
      coords: {
        latitude: -34.7769348,
        longitude: -56.3659734
      }
    }, {
      key: "cufre",
      name: "Cufré",
      address: "Ruta 1 Km. 107.350",
      coords: {
        latitude: -34.3549509,
        longitude: -57.1138582
      }
    }, {
      key: "mercedes",
      name: "Mercedes",
      address: "Ruta 2 Km. 284.400",
      coords: {
        latitude: -33.2122336,
        longitude: -58.0485032
      }
    }, {
      key: "pasoPuerto",
      name: "Paso del Puerto",
      address: "Ruta 3 km. 245.200",
      coords: {
        latitude: -33.1285767,
        longitude: -57.1705746
      }
    }, {
      key: "queguay",
      name: "Queguay",
      address: "Ruta 3 Km. 392,750",
      coords: {
        latitude: -32.1455421,
        longitude: -57.9409285
      }
    }, {
      key: "mendoza",
      name: "Mendoza",
      address: "Ruta 5 Km. 67,700",
      coords: {
        latitude: -34.3350732,
        longitude: -57.1705746
      }
    }, {
      key: "centenario",
      name: "Centenario",
      address: "Ruta 5 Km. 246,350",
      coords: {
        latitude: -32.8400212,
        longitude: -57.5481033
      }
    }, {
      key: "manuelDiaz",
      name: "Manuel Diaz",
      address: "Ruta 5 Km. 423,200",
      coords: {
        latitude: -31.5607898,
        longitude: -55.6869343
      }
    }, {
      key: "soca",
      name: "Soca",
      address: "Ruta 8 Km. 50,500",
      coords: {
        latitude: -34.6723044,
        longitude: -55.7675883
      }
    }, {
      key: "cebollati",
      name: "Cebollati",
      address: "Ruta 8 Km. 206,250",
      coords: {
        latitude: -33.8375426,
        longitude: -54.7686374
      }
    }, {
      key: "capillaDeCella",
      name: "Capilla De Cella",
      address: "Ruta 9 Km. 79,500",
      coords: {
        latitude: -34.7063975,
        longitude: -55.4683399
      }
    }, {
      key: "garzon",
      name: "Garzon",
      address: "Ruta 9 Km. 191",
      coords: {
        latitude: -34.6028426,
        longitude: -54.4286493
      }
    }, {
      key: "santaLucia",
      name: "Santa Lucía",
      address: "Ruta 11 Km. 81",
      coords: {
        latitude: -34.4432683,
        longitude: -56.425525
      }
    }, {
      key: "pando",
      name: "Pando",
      address: "Ruta Interbalnearia Km. 32,400",
      coords: {
        latitude: -34.7849055,
        longitude: -55.8905215
      }
    }, {
      key: "solis",
      name: "Solís",
      address: "Ruta Interbalnearia Km. 32,400",
      coords: {
        latitude: -34.728462,
        longitude: -55.7805296
      }
    }];
    $scope.prices = [{
      key: "category1",
      name: "Categoría 1",
      value: "$ 167,00"
    }, {
      key: "category2",
      name: "Categoría 2",
      value: "$ 167,00"
    }, {
      key: "category3",
      name: "Categoría 3",
      value: "$ 220,00"
    }, {
      key: "category4",
      name: "Categoría 4",
      value: "$ 220,00"
    }, {
      key: "category5",
      name: "Categoría 5",
      value: "$ 220,00"
    }, {
      key: "category6",
      name: "Categoría 6",
      value: "$ 220,00"
    }, {
      key: "category7",
      name: "Categoría 7",
      value: "$ 449,00"
    }, {
      key: "category8",
      name: "Categoría 8",
      value: "$ 751,00"
    }]; //
    // Map Setup
    //

    uiGmapGoogleMapApi.then(function () {
      var totemLatLngCoords = {
        latitude: -34.890823,
        longitude: -56.166561
      };

      if (CoreService.cache.totemInfo && CoreService.cache.totemInfo.latlng) {
        var totemLatLng = CoreService.cache.totemInfo.latlng.split(",");
        totemLatLngCoords.latitude = totemLatLng[0];
        totemLatLngCoords.longitude = totemLatLng[1];
      }

      var myStyles = [{
        featureType: "poi",
        elementType: "labels",
        stylers: [{
          visibility: "off"
        }]
      }]; // Labels

      $scope.markerOptions = {
        label: {
          text: "Usted esta aqui",
          className: "markerLabel"
        }
      };
      $scope.CVULabel01 = {
        label: {
          text: "Barra de Santa Lucía",
          className: "markerLabel"
        }
      };
      $scope.CVULabel02 = {
        label: {
          text: "Cufré",
          className: "markerLabel"
        }
      };
      $scope.CVULabel03 = {
        label: {
          text: "Mercedes",
          className: "markerLabel"
        }
      };
      $scope.CVULabel04 = {
        label: {
          text: "Paso del Puerto",
          className: "markerLabel"
        }
      };
      $scope.CVULabel05 = {
        label: {
          text: "Queguay",
          className: "markerLabel"
        }
      };
      $scope.CVULabel06 = {
        label: {
          text: "Mendoza",
          className: "markerLabel"
        }
      };
      $scope.CVULabel07 = {
        label: {
          text: "Centenario",
          className: "markerLabel"
        }
      };
      $scope.CVULabel08 = {
        label: {
          text: "Manuel Diaz",
          className: "markerLabel"
        }
      };
      $scope.CVULabel09 = {
        label: {
          text: "Soca",
          className: "markerLabel"
        }
      };
      $scope.CVULabel10 = {
        label: {
          text: "Cebollati",
          className: "markerLabel"
        }
      };
      $scope.CVULabel11 = {
        label: {
          text: "Capilla De Cella",
          className: "markerLabel"
        }
      };
      $scope.CVULabel12 = {
        label: {
          text: "Garzon",
          className: "markerLabel"
        }
      };
      $scope.CVULabel13 = {
        label: {
          text: "Santa Lucía",
          className: "markerLabel"
        }
      };
      $scope.CVULabel14 = {
        label: {
          text: "Pando",
          className: "markerLabel"
        }
      };
      $scope.CVULabel15 = {
        label: {
          text: "Solís",
          className: "markerLabel"
        }
      };
      $scope.map = {
        center: {
          latitude: totemLatLngCoords.latitude,
          longitude: totemLatLngCoords.longitude
        },
        zoom: 12,
        options: {
          scrollwheel: false,
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false,
          styles: myStyles
        },
        marker: {
          coords: {
            latitude: totemLatLngCoords.latitude,
            longitude: totemLatLngCoords.longitude
          }
        }
      };
    });

    $scope.tollShow = function (toll) {
      $scope.map.center = toll.coords; // $scope.map.zoom = 7;

      if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
        $scope.$apply();
      }
    };

    $scope.showHere = function () {
      $scope.map.center = {
        latitude: -34.890823,
        longitude: -56.166561
      };

      if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
        $scope.$apply();
      }
    };

    $scope.finish = function () {
      $state.go("home");
    };

    $scope.goBack = function () {
      $state.go("home");
    }; //
    // Session timeout handler
    // CoreService.sessionTimerStart();
    // $scope.$on('sessionTimedout', function(){
    //   // Do something special for this page
    // });


    CoreService.sessionTimerStop();
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("start", {
    controller: StartController,
    controllerAs: "vm",
    templateUrl: "app/pages/start/start.view.html"
  });
  /** @ngInject */

  function StartController($log, $state, $translate, CoreService, $scope, ApiService) {
    $scope.initialized = false;
    $scope.newTagEnabled = true;
    $log.debug("start activated");

    $state.switchLanguage = function switchLanguage(language) {
      $translate.use(language);
    };

    $scope.goCVUNew = function () {
      if ($scope.newTagEnabled) $state.go("cvu-new-s1-id");
    };

    $scope.goCVURecharge = function () {
      $state.go("cvu-rech-s1-id");
    };

    $scope.cancel = function () {
      CoreService.clearSession();
      $state.go("home");
    };

    CoreService.clearSession(); //
    // Initialize buttons
    //

    $scope.initializeButtons = function () {
      ApiService.getTotemInfo(true).then(function (response) {
        $scope.initialized = true;

        if (response.outcode == 200 || response.outcode == 201) {
          if (response.data) {
            if (response.data.roll && response.data.roll.qty == response.data.roll.sequencePosition) {
              $scope.newTagEnabled = false;
            }

            if ($scope.$root.$$phase != "$apply" && $scope.$root.$$phase != "$digest") {
              $scope.$apply();
            }
          } else {
            $log.error("initializeButtons| Server returned empty data on getTotemInfo");
            $log.error(response);
          }
        } else {
          $log.error("initializeButtons| Server returned outcode " + response.outcode + " on getTotemInfo");
          $log.error(response);
        }
      }, function (err) {
        $scope.initialized = true;
        $log.error("initializeButtons| Error getting totem info!");
        $log.error(err);
      });
    };

    $scope.initializeButtons(); //
    // Session timeout handler

    CoreService.sessionTimerStart(true);
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
  }
})();


"use strict";

var _electron = require("electron");

(function () {
  "use strict";

  angular.module("app").component("maintenance", {
    controller: MaintenanceController,
    controllerAs: "vm",
    templateUrl: "app/pages/maintenance/maintenance.view.html"
  });
  /** @ngInject */

  function MaintenanceController($log, $state, $translate, CoreService, $scope, $uibModal, ApiService, $window, $document, $uibModalStack) {
    $scope.validated = false;
    $scope.keyboardLayout = "default";
    $scope.keyboardInput = "";
    $scope.encPass = null;
    $log.debug("maintenance activated"); // $scope.data = {
    //   id : 827,
    //   name: 'Peaje Pando',
    //   lastTrx: {
    //     date: 'Hace 3 horas',
    //     result : 'OK'
    //   },
    //   roll : {
    //     id: 182,
    //     name: "Rollo 182",
    //     start: 8800,
    //     end  : 10000,
    //     theoric: 9013,
    //     usage: 55,
    //     remaining : 1287
    //   }
    // };

    $scope.exit = function () {
      CoreService.clearSession();
      $state.go("home");
    };

    $scope.validateOperator = function () {
      $uibModal.open({
        template: "\n          <div class=\"modal-content\">\n            <div class=\"modal-header\">Ingrese clave de mantenimiento</div>\n            <div class=\"modal-body\">\n              <form>\n                <div class=\"form-group\">\n                  <input type=\"password\" class=\"form-control\" autocomplete=\"off\" id=\"passcode\"\n                    style=\"text-align: center;\" ng-model=\"passcode\">\n                </div>\n              </form>\n            </div>\n            <div class=\"modal-footer\" style=\"justify-content: space-evenly;\">\n              <button type=\"button\" class=\"bt-button bt-primary-button \" \n                ripple ripple-class=\"ripple\" ripple-callback=\"loginOperator()\" ripple-radius=\"40\">OK</button>\n              <button type=\"button\" class=\"bt-button bt-link-button\" \n                ripple ripple-class=\"ripple\" ripple-callback=\"cancel()\" ripple-radius=\"40\">Cancelar</button>\n            </div>\n          </div>\n        ",
        controller: function controller($uibModalInstance, $scope, ApiService, CoreService, $log, $timeout, $document) {
          $scope.passcode = "";

          $scope.cancel = function () {
            $uibModalInstance.dismiss();
          };

          $scope.loginOperator = function () {
            ApiService.maintenanceLogin($scope.passcode.toLowerCase()).then(function (response) {
              if (response.outcode == 200) {
                $uibModalInstance.close(response.data.credentials);
              } else if (response.outcode == 401) {
                $log.error("Wrong credentials!");
                CoreService.showError("Error de inicio", "La clave no es correcta");
              }
            }, function (err) {
              $log.error("Error validating passcode!");
              $log.error(err);
              CoreService.showError("Ocurrió un error", "No se pudo validar la clave", err.outcode);
            });
          };

          $timeout(function () {
            var e = $document[0].getElementById("passcode");
            if (e) e.focus();
          }, 1000);
        } // size: size,

      }).result.then(function (encPass) {
        if (encPass) {
          $scope.encPass = encPass;
          $scope.loadTotemInfo();
          $scope.validated = true;
          $scope.keyboardLayout = "default";
        } else {
          $log.info("invalid");
          $state.go("home");
        }
      }, function () {
        $state.go("home");
        $log.info("canceled?");
      });
    };

    $scope.loadTotemInfo = function () {
      ApiService.getTotemInfo().then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          if (response.data) {
            var djs = null;

            if (response.data.outOfServiceOn && response.data.outOfServiceOn.length > 0) {
              djs = $window.dayjs(response.data.outOfServiceOn);
              response.data.outOfServiceDesc = "Desde " + djs.calendar() + " (" + response.data.outOfServiceCause + ")";
            }

            if (response.data.roll) {
              response.data.roll.remaining = response.data.roll.qty - response.data.roll.sequencePosition;
              response.data.roll.usage = response.data.roll.sequencePosition / response.data.roll.qty * 100;
              response.data.roll.sequencePosition++;
            }

            if (response.data.lastTransaction) {
              djs = $window.dayjs(response.data.lastTransaction.date);
              response.data.lastTransaction.dateNice = djs.format("dddd D [de] MMMM, YYYY h:mm A");
              response.data.lastTransaction.dateCalendar = djs.calendar();
            } // Update status card


            var statusCard = $document[0].getElementById("statusCard");

            if (response.data.outOfService == 0) {
              statusCard.style.backgroundColor = "#c8e6c9";
            } else {
              statusCard.style.backgroundColor = "#ffccbc";
            }
          }

          $scope.data = response.data;
        } else {
          $log.error("Error on process");
          $log.error(response);
          $scope.showRetry("Ocurrió un error al obtener los datos del totem", response.message, response.outcode);
        }
      }, function (err) {
        $log.error("Error getting totem info!");
        $log.error(err);
        CoreService.showError("Ocurrió un error", "No se pudo obtener la información del totem", err.outcode);
      });
    };

    $scope.expendTag = function () {
      var tagText = $scope.data.roll.nextTag ? $scope.data.roll.nextTag : "DESCONOCIDO";
      CoreService.printTag(1, [tagText]).then(function () {
        CoreService.showMessage("Tag impreso", "Escanee el tag para continuar", true).then(function () {
          $window.onScan.detachFrom($document[0]);
        }, function () {
          $window.onScan.detachFrom($document[0]);
        });
        $window.onScan.attachTo($document[0], {
          suffixKeyCodes: [13],
          reactToPaste: true,
          onScan: function onScan(sCode, iQty) {
            $log.log("Tag read: " + sCode + " | Qty: " + iQty);
            ApiService.expendedTagManual(sCode, $scope.encPass).then(function (response) {
              if (response.outcode == 200 || response.outcode == 201) {
                $uibModalStack.dismissAll();
                CoreService.showMessage("Tag impreso", "Tag ".concat(sCode, " registrado correctamente."), true).then($scope.loadTotemInfo, $scope.loadTotemInfo);
              } else {
                $log.error("Error on process");
                $log.error(response);
                CoreService.showError("Ocurrió un error al registrar la impresión del tag en el servidor", response.message, response.outcode);
              }
            }, function (response) {
              $log.error("Error on webservice");
              $log.error(response);
              CoreService.showError("Ocurrió un error al validar el tag en el servidor", response.message, response.outcode);
            });
          }
        });
      }, function () {
        $log.error("Error trying to manually print tag!");
        CoreService.showError("Ocurrió un error", "Ocurrió un problema con la impresora al intentar imprimir");
      });
    };

    $scope.changeRoll = function () {
      $uibModal.open({
        template: "\n          <div class=\"modal-content\">\n            <div class=\"modal-header\">Buscar nuevo rollo</div>\n            <div class=\"modal-body\">\n              <form>\n                <div class=\"form-group\" style=\"display: flex;justify-content: center;\">\n                  <select class=\"form-control\" ng-model=\"selectedRoll\">\n                    <option value=\"\">Seleccione un rollo</option>\n                    <option ng-repeat=\"roll in rolls\" ng-value=\"roll\">{{roll.name}} ({{roll.qty}} tags)</option>\n                  </select>\n                </div>\n              </form>\n            </div>\n            <div class=\"modal-footer\" style=\"justify-content: space-evenly;\">\n              <button type=\"button\" class=\"bt-button bt-primary-button \" \n                ripple ripple-class=\"ripple\" ripple-callback=\"assign()\" ripple-radius=\"40\">Asignar rollo</button>\n              <button type=\"button\" class=\"bt-button bt-link-button\" \n                ripple ripple-class=\"ripple\" ripple-callback=\"cancel()\" ripple-radius=\"40\">Cancelar</button>\n            </div>\n          </div>\n        ",
        controller: function controller($uibModalInstance, $scope, ApiService, CoreService, $log, $timeout, data) {
          $scope.selectedRoll = null;

          $scope.cancel = function () {
            $uibModalInstance.dismiss();
          };

          $scope.loadRolls = function () {
            ApiService.searchRoll("", data.encPass).then(function (response) {
              if (response.outcode == 200 || response.outcode == 201) {
                if (response.data) {
                  $scope.rolls = response.data;
                }
              } else {
                $log.error("Error on process");
                $log.error(response);
                $scope.showRetry("Ocurrió un error al intentar obtener la lista de rollos desde el servidor", response.message, response.outcode);
              }
            }, function (err) {
              $log.error("Error getting rolls!");
              $log.error(err);
              CoreService.showError("Ocurrió un error", "No se pudo obtener la lista de rollos desde el servidor", err.outcode);
            });
          };

          $scope.assign = function () {
            $uibModalInstance.close($scope.selectedRoll);
          }; // Init


          $scope.loadRolls();
        },
        resolve: {
          data: {
            encPass: $scope.encPass
          }
        } // size: size,

      }).result.then(function (selectedRoll) {
        if (selectedRoll) {
          //
          // Send assign roll to server
          //
          CoreService.showProgress();
          $log.log("Sending assign rol with:");
          $log.log(selectedRoll);
          ApiService.installRoll(selectedRoll.id, $scope.encPass).then(function (response) {
            if (response.outcode == 200 || response.outcode == 201) {
              $scope.loadTotemInfo();
              CoreService.hideProgress();
              CoreService.showMessage("Rollo asignado", "Rollo asignado con éxito");
            } else {
              $log.error("Error assigning roll 2!");
              $log.error(response);
              $scope.showRetry("Ocurrió un error al intentar asignar el rollo seleccionado", response.message, response.outcode);
            }
          }, function (err) {
            $log.error("Error assigning roll!");
            $log.error(err);
            CoreService.showError("Ocurrió un error", "No se pudo asignar el rollo seleccionado", err.outcode);
          });
        } else {
          $log.info("invalid");
        }
      }, function () {
        $log.info("canceled?");
      });
    };

    $scope.setTotemStatusOnline = function (setOnline) {
      var statusCard = $document[0].getElementById("statusCard");

      if (setOnline) {
        $scope.data.outOfService = 0;
        statusCard.style.backgroundColor = "#c8e6c9";
      } else {
        $scope.data.outOfService = 1;
        statusCard.style.backgroundColor = "#ffccbc";
      }

      ApiService.setTotemStatus(!$scope.data.outOfService, "MANUAL", $scope.encPass).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $scope.loadTotemInfo();
        } else {
          $log.error("Error on setTotemStatus 2!");
          $log.error(response);
          $scope.showRetry("Ocurrió un error al cambiar el estado del totem", response.message, response.outcode);
        }
      }, function (err) {
        $log.error("Error on setTotemStatus ");
        $log.error(err);
        CoreService.showError("Ocurrió un error al cambiar el estado del totem", err.outcode);
      });
    };

    $scope.setTotemSettings = function () {
      ApiService.setTotemSettings({
        posTerminalId: $scope.data.posTerminalId
      }, $scope.encPass).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          $scope.loadTotemInfo();
        } else {
          $log.error("Error on setTotemSettings 2!");
          $log.error(response);
          $scope.showRetry("Ocurrió un error al cambiar la configuracion del totem", response.message, response.outcode);
        }
      }, function (err) {
        $log.error("Error on setTotemSettings ");
        $log.error(err);
        CoreService.showError("Ocurrió un error al cambiar la configuracion del totem", err.outcode);
      });
    };

    $scope.exitApp = function () {
      _electron.ipcRenderer.send("EXIT");
    }; //
    // Init screen
    //


    CoreService.clearSession();
    CoreService.sessionTimerStart();
    $scope.$on("sessionTimedout", function () {// Do something special for this page
    });
    $scope.validateOperator();
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").component("home", {
    controller: HomeController,
    controllerAs: "vm",
    templateUrl: "app/pages/home/home.view.html"
  });
  /** @ngInject */

  function HomeController($log, $scope, $state, $translate, $timeout, CoreService, $window, ApiService) {
    $scope.maintenanceTimer = null;
    $scope.appVersion = CoreService.appVersion;
    $scope.outOfService = true;
    $scope.totemInfoGetTimeout = 10000;
    $scope.date = new Date();

    $scope.switchLanguage = function (language) {
      $translate.use(language);
    };

    $log.debug("home activated");

    $scope.goToStart = function () {
      if (!$scope.outOfService) {
        $state.go("start");
      }
    };

    $scope.openInfo = function () {
      $state.go("info");
    }; //
    // Totem info check
    //


    $scope.checkTotemInfo = function () {
      $log.debug("checkTotemInfo|Checking...");
      ApiService.getTotemInfo(true).then(function (response) {
        if (response.outcode == 200 || response.outcode == 201) {
          if (response.data) {
            CoreService.cache.totemInfo = response.data;

            if (response.data.outOfService == 1) {
              $log.info("checkTotemInfo| Totem is out of service and must be online accoring to server, going back online...");
              $scope.outOfService = true;
              $scope.$apply();
            } else if (response.data.outOfService == 0) {
              $log.info("checkTotemInfo| Totem is not out of service and must be accoring to server, going out of business...");
              $scope.outOfService = false;
              $scope.$apply();
            }
          } else {
            $log.error("checkTotemInfo| Server returned empty data on getTotemInfo");
            $log.error(response);
          }
        } else {
          $log.error("checkTotemInfo| Server returned outcode " + response.outcode + " on getTotemInfo");
          $log.error(response);
        }

        $scope.totemInfoGetTimer = $timeout(function () {
          $scope.checkTotemInfo();
        }, $scope.totemInfoGetTimeout);
      }, function (err) {
        $log.error("checkTotemInfo| Error getting totem info!");
        $log.error(err);
        $scope.totemInfoGetTimer = $timeout(function () {
          $scope.checkTotemInfo();
        }, $scope.totemInfoGetTimeout);
      });
    };

    $scope.checkTotemInfo(); //
    // Maintanance ghost button
    //

    $scope.maintenancePressed = function (e) {
      $log.info("Maintenance pressed");
      e.stopPropagation();
      e.preventDefault();
      $scope.maintenanceTimer = $timeout(function () {
        $scope.openMaintenance();
      }, 1000);
      return false;
    };

    $scope.maintenanceReleased = function (e) {
      $log.info("Maintenance released");
      e.stopPropagation();
      e.preventDefault();
      $timeout.cancel($scope.maintenanceTimer);
      return false;
    };

    $scope.openMaintenance = function () {
      $state.go("maintenance");
    }; //
    // Version checker
    //


    $scope.versionChecker = function () {
      CoreService.checkVersion(function (checkResponse) {
        if (checkResponse.mustUpdate) {
          $log.info("Found new version, will restart app in 10 seconds...");
          $timeout.cancel($scope.versionCheckerTimer);

          if ($window.Sentry) {
            $window.Sentry.captureMessage("Upgrading Totem @ " + CoreService.config.hostname + " to version " + checkResponse.newVersion);
          }

          $timeout(function () {
            $log.info(" Reloading Hostname: " + CoreService.config.hostname + " to upgrade to version: " + checkResponse.newVersion);
            location.reload(true);
          }, 10000);
        } else {
          $log.debug("No new version found");
          $scope.versionCheckerTimer = $timeout(function () {
            $scope.versionChecker();
          }, 30000);
        }
      });
    };

    $scope.versionChecker();
    $scope.versionCheckerTimer = $timeout(function () {
      $scope.versionChecker();
    }, 30000);
    $scope.$on("$destroy", function () {
      $log.debug("Cancelling versionCheckerTimer and totemInfoGetTimer...");
      $timeout.cancel($scope.versionCheckerTimer);
      $timeout.cancel($scope.totemInfoGetTimer);
    });
  }
})();


"use strict";

var _electron = require("electron");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function () {
  "use strict";

  angular.module("app").factory("CoreService", CoreService);
  CoreService.$inject = ["$document", "$uibModal", "$uibModalStack", "ApiService", "$log", "$timeout", "$rootScope", "$state", "$http"];
  /* @ngInject */

  function CoreService($document, $uibModal, $uibModalStack, ApiService, $log, $timeout, $rootScope, $state, $http) {
    return {
      appVersion: '2.0.0',
      config: {
        hostname: null
      },
      session: {
        wizardNew: {},
        wizardRecharge: {}
      },
      sessionTimeout: 60 * 8,
      // Must be equal to sessionTimer.secsTimer (seconds)
      sessionTimer: {
        secsTimer: 60 * 8,
        // Must be equal to sessionTimeout (seconds)
        sessionTimer: null
      },
      cache: {},
      initialize: function initialize(hostname) {
        var self = this; //
        // Initialize config
        //

        $log.log("Initializing core for " + hostname + "...");
        this.config.hostname = hostname; // this.config.hostname = 'rondeu5-pc';
        //
        // Initialize comm with Electron
        //

        $log.log("Initializing IPC handlers...");

        _electron.ipcRenderer.on("PRINT_END", function (event, arg) {
          $log.log("Print successfully");
          $rootScope.$broadcast("PRINT_END", {
            event: event,
            arg: arg
          });
        });

        _electron.ipcRenderer.on("PRINT_ERROR", function (event, arg) {
          $log.error("Error on printing");
          $log.error(event);
          $log.error(arg);
          $rootScope.$broadcast("PRINT_ERROR", {
            event: event,
            arg: arg
          });
        }); //
        // Initialize click capture
        //


        $document.on("click", function () {
          self.sessionTimerRestart();
        }); //
        // Initialize timer ended event
        //

        self.sessionTimedoutHandler = $rootScope.$on("sessionTimedout", function () {
          $uibModalStack.dismissAll();
        });
      },
      checkVersion: function checkVersion(cb) {
        // Return true if need to be updated
        var self = this;
        $log.debug("Checking remote version...");
        $http.get("/version", {
          headers: {
            "Cache-Control": "no-cache"
          }
        }).then(function (response) {
          var remoteVersion = response.data.trim();
          $log.debug("Remote version: " + remoteVersion + " | Local version: " + self.appVersion);

          if (remoteVersion != self.appVersion) {
            // $log.warn('Found new version!');
            cb({
              mustUpdate: true,
              newVersion: remoteVersion
            });
          } else {
            cb({
              mustUpdate: false
            });
          }
        }, function (err) {
          $log.error("Could not check remote version!");
          $log.error(err);
          cb(false);
        });
      },
      //
      // Utils
      zeroPad: function zeroPad(num, places) {
        return String(num).padStart(places, "0");
      },
      //
      //
      // Session
      //
      clearSession: function clearSession() {
        if (this.sessionTimer.sessionTimerEval) $timeout.cancel(this.sessionTimer.sessionTimerEval);
        this.session = {
          wizardNew: {},
          wizardRecharge: {}
        };
      },
      sessionTimerRestart: function sessionTimerRestart() {
        // var self = this;
        if (this.sessionTimer.sessionTimerEval) {
          // $log.debug('SessionTimer| Restarting timer...');
          this.sessionTimer.secsTimer = this.sessionTimeout;
        }
      },
      sessionTimerStart: function sessionTimerStart(hideSessionTimeoutWarning) {
        $log.debug("SessionTimer| Starting session timer with " + this.sessionTimeout + " seconds...");
        var self = this;
        if (this.sessionTimer.sessionTimerEval) $timeout.cancel(this.sessionTimer.sessionTimerEval);
        this.sessionTimer.hideSessionTimeoutWarning = hideSessionTimeoutWarning;
        this.sessionTimer.secsTimer = this.sessionTimeout;
        this.sessionTimer.sessionTimerEval = $timeout(function () {
          self.sessionTimerEval();
        }, 1000);
      },
      sessionTimerEval: function sessionTimerEval() {
        var self = this;

        if (this.sessionTimer.secsTimer == 0) {
          $log.debug("SessionTimer| Session about to expire, show warning for extra 10 secs!");

          if (this.sessionTimer.hideSessionTimeoutWarning) {
            $rootScope.$broadcast("sessionTimedout");
            $state.go("home");
            return;
          }

          self.showSessionTimeoutWarning().then(function () {
            // if (keepSession) {
            //   $log.debug("SessionTimer| Session restarted");
            //   self.sessionTimer.secsTimer = self.sessionTimeout;
            //   self.sessionTimer.sessionTimerEval = $timeout(function () {
            //     self.sessionTimerEval();
            //   }, 1000);
            // } else {
            $rootScope.$broadcast("sessionTimedout"); // aqui debo hacer el rollback
            // ApiService.CVUExecuteRollback(session.wizardNew.payment.transaction.id).then(
            //   (response) => {
            //     $log.log(response);
            //     this.hideProgress();
            //     $state.go("home");
            //   })
            // ApiService.CVUExecuteRollback(session.wizardRecharge.payment.transaction.id).then(
            //   (response) => {
            //     $log.log(response);
            //     this.hideProgress();
            //     $state.go("home");
            //   })

            $state.go("home"); // }
          }, function () {});
        } else {
          // $log.debug('SessionTimer| Session timeout at ' + this.sessionTimer.secsTimer);
          this.sessionTimer.secsTimer--;
          this.sessionTimer.sessionTimerEval = $timeout(function () {
            self.sessionTimerEval();
          }, 1000);
        }
      },
      sessionTimerStop: function sessionTimerStop() {
        $log.debug("SessionTimer| Session timer stopped");
        if (this.sessionTimer.sessionTimerEval) $timeout.cancel(this.sessionTimer.sessionTimerEval);
      },
      //
      // Dialogs
      //
      showError: function showError(title, message, outcode, returnPromise) {
        var modal = $uibModal.open({
          // animation: $scope.animationsEnabled,
          templateUrl: "app/common/modalMessage.html",
          controller: function controller($uibModalInstance, $scope, data) {
            $scope.data = data;

            $scope.close = function () {
              $uibModalInstance.close();
            };
          },
          backdrop: "static",
          keyboard: false,
          // size: size,
          resolve: {
            data: {
              title: title,
              message: message,
              outcode: outcode
            }
          }
        }).result;
        if (returnPromise) return modal;
        modal.then(function () {}, function () {});
      },
      showMessage: function showMessage() {
        var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var returnPromise = arguments.length > 2 ? arguments[2] : undefined;
        var modal = $uibModal.open({
          templateUrl: "app/common/modalMessage.html",
          controller: function controller($uibModalInstance, $scope, data) {
            $scope.data = data;

            $scope.close = function () {
              $uibModalInstance.dismiss("close");
            };
          },
          backdrop: "static",
          keyboard: false,
          // size: size,
          resolve: {
            data: {
              title: title,
              message: message
            }
          }
        }).result;
        if (returnPromise) return modal;
        modal.then(function () {}, function () {});
      },
      showNewAccountMessage: function showNewAccountMessage() {
        var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var returnPromise = arguments.length > 2 ? arguments[2] : undefined;
        var modal = $uibModal.open({
          templateUrl: "app/common/modalMessageWithNewAccount.html",
          controller: function controller($uibModalInstance, $scope, data) {
            $scope.data = data;

            $scope.close = function () {
              $uibModalInstance.dismiss("close");
            };

            $scope.goToNewAccount = function () {
              $state.go("cvu-new-s1-id");
              $scope.close();
            };
          },
          backdrop: "static",
          keyboard: false,
          // size: size,
          resolve: {
            data: {
              title: title,
              message: message
            }
          }
        }).result;
        if (returnPromise) return modal;
        modal.then(function () {}, function () {});
      },
      showRetryDialog: function showRetryDialog(title, errorCode, errorDesc) {
        return new Promise(function (resolve, reject) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/common/retry-cancel-dialog.html",
            controller: function controller($uibModalInstance, $scope, data) {
              $scope.data = data;

              $scope.retry = function (retry) {
                $uibModalInstance.close(retry);
              };
            },
            size: "md",
            backdrop: "static",
            keyboard: false,
            resolve: {
              data: {
                title: title,
                errorCode: errorCode,
                errorDesc: errorDesc
              }
            }
          });
          modalInstance.result.then(function (retry) {
            resolve(retry);
          }, function () {
            reject();
          });
        });
      },
      showCancelDialog: function showCancelDialog(txt) {
        return new Promise(function (resolve, reject) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/common/cancel-dialog.html",
            controller: function controller($uibModalInstance, $scope) {
              $scope.cancel = function (doCancel) {
                $uibModalInstance.close(doCancel);
              };
            },
            size: "md",
            backdrop: "static",
            keyboard: false,
            resolve: {
              data: {
                text: txt
              }
            }
          });
          modalInstance.result.then(function (amount) {
            resolve(amount);
          }, function () {
            reject();
          });
        });
      },
      showSessionTimeoutWarning: function showSessionTimeoutWarning() {
        return new Promise(function (resolve, reject) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/common/session-timeout.html",
            controller: function controller($uibModalInstance, $scope, $timeout, $log) {
              $scope.remSecs = 30;
              $scope.timer = null;

              $scope.evaluateTimeout = function () {
                if ($scope.remSecs == 0) {
                  // Close session
                  $log.debug("sessionTimerDialog | Timed out!");
                  $uibModalInstance.close(false);
                } else {
                  $scope.remSecs--; // $log.debug('sessionTimerDialog | Session will expire in ' + $scope.remSecs);

                  $scope.timer = $timeout(function () {
                    $scope.evaluateTimeout();
                  }, 1000);
                }
              };

              $scope.keepSession = function () {
                if ($scope.timer) $timeout.cancel($scope.timer);
                $uibModalInstance.close(true);
              };

              $scope.closeSession = function () {
                if ($scope.timer) $timeout.cancel($scope.timer);
                $uibModalInstance.close(false);
              };

              $scope.evaluateTimeout();
            },
            size: "md",
            backdrop: "static",
            keyboard: false
          });
          modalInstance.result.then(function (keep) {
            resolve(keep);
          }, function () {
            reject();
          });
        });
      },
      //
      // Progress indicators
      //
      showProgress: function showProgress() {
        var progressIndicator = angular.element("<div id=\"progInd\" class=\"bt-progind\"><div><span class=\"bt-loading\">ESPERE...</span></div></div>");
        angular.element($document[0].body).append(progressIndicator);
      },
      hideProgress: function hideProgress() {
        angular.element($document[0].querySelector("#progInd")).remove();
      },
      //
      // Select Dialogs
      //
      showVehicleBrandSelector: function showVehicleBrandSelector(parentScope) {
        var _this = this;

        return new Promise(function (resolve, reject) {
          _this.showProgress();

          ApiService.CVUGetVehicleBrands().then(function (response) {
            $log.log(response);

            _this.hideProgress();

            var modalInstance = $uibModal.open({
              templateUrl: "app/common/cvu/vehicle-brand-selector.html",
              controller: function controller($uibModalInstance, $scope, data, $rootScope) {
                $scope.data = data;
                parentScope.showKeyboard = true;

                $scope.inputFocus = function (ev) {
                  parentScope.showKeyboard = true;
                  $rootScope.$broadcast("keyboard::changeInput", ev.target.value);
                };

                $timeout(function () {
                  $document[0].getElementById("bt-search").focus();
                }, 300);
                $scope.defaultBrands = [{
                  name: "FIAT",
                  id: 14
                }, {
                  name: "VOLKSWAGEN",
                  id: 46
                }, {
                  name: "CHEVROLET",
                  id: 5
                }, {
                  name: "RENAULT",
                  id: 37
                }, {
                  name: "PEUGEOT",
                  id: 34
                }, {
                  name: "CITROEN",
                  id: 8
                }, {
                  name: "SUZUKI",
                  id: 43
                }, {
                  name: "HYUNDAI",
                  id: 18
                }, {
                  name: "NISSAN",
                  id: 33
                }, {
                  name: "TOYOTA",
                  id: 45
                }, {
                  name: "FORD",
                  id: 15
                }, {
                  name: "MERCEDES BENZ",
                  id: 29
                }];
                $scope.filteredBrands = data.brands;
                $scope.filterText = "";

                $scope.filterBrands = function () {
                  if (!$scope.filterText || !$scope.filterText.length) {
                    $scope.filteredBrands = _toConsumableArray($scope.defaultBrands);
                    return;
                  }

                  $scope.filteredBrands = $scope.data.brands.filter(function (item) {
                    return item.name.toUpperCase().indexOf($scope.filterText.toUpperCase()) != -1;
                  });
                };

                $scope.filterBrands();

                $scope.close = function () {
                  $uibModalInstance.dismiss("close");
                };

                $scope.select = function (brand) {
                  $uibModalInstance.close(brand);
                };
              },
              size: "lg",
              backdrop: "static",
              keyboard: false,
              resolve: {
                data: {
                  brands: response.data
                }
              }
            });
            modalInstance.result.then(function (selectedBrand) {
              resolve(selectedBrand);
            }, function (err) {
              reject(err);
            });
          }, function (error) {
            _this.showError("Ocurrió un error", error.message, error.outcode);

            $log.error("Error on continue");
            $log.error(error);

            _this.hideProgress();

            reject();
          });
        });
      },
      showVehicleModelSelector: function showVehicleModelSelector(brand, parentScope) {
        var _this2 = this;

        return new Promise(function (resolve, reject) {
          parentScope.showKeyboard = false;

          _this2.showProgress();

          ApiService.CVUGetVehicleModels(brand).then(function (response) {
            $log.log(response);

            _this2.hideProgress();

            var modalInstance = $uibModal.open({
              templateUrl: "app/common/cvu/vehicle-model-selector.html",
              controller: function controller($uibModalInstance, $scope, data, $rootScope) {
                $scope.data = data;

                $scope.inputFocus = function (ev) {
                  parentScope.showKeyboard = true;
                  $rootScope.$broadcast("keyboard::changeInput", ev.target.value);
                };

                $timeout(function () {
                  $document[0].getElementById("bt-search").focus();
                }, 300);
                $scope.filteredModels = data.models;
                $scope.filterText = "";

                $scope.filterModels = function () {
                  $scope.filteredModels = $scope.data.models.filter(function (item) {
                    return item.name.toUpperCase().indexOf($scope.filterText.toUpperCase()) != -1;
                  });
                };

                $scope.filterModels();

                $scope.close = function () {
                  $uibModalInstance.dismiss("close");
                };

                $scope.select = function (model) {
                  $uibModalInstance.close(model);
                };
              },
              size: "lg",
              backdrop: "static",
              keyboard: false,
              resolve: {
                data: {
                  models: response.data
                }
              }
            });
            modalInstance.result.then(function (selectedModel) {
              resolve(selectedModel);
            }, function () {
              reject();
            });
          }, function (error) {
            _this2.showError("Ocurrió un error", error.message, error.outcode);

            $log.error("Error on continue");
            $log.error(error);

            _this2.hideProgress();

            reject();
          });
        });
      },
      showVehicleColorSelector: function showVehicleColorSelector(brand, parentScope) {
        var _this3 = this;

        return new Promise(function (resolve, reject) {
          ApiService.CVUGetVehicleColors().then(function (response) {
            $log.log(response);

            _this3.hideProgress();

            var modalInstance = $uibModal.open({
              templateUrl: "app/common/cvu/vehicle-color-selector.html",
              controller: function controller($uibModalInstance, $scope, data, $rootScope) {
                $scope.data = data;

                $scope.inputFocus = function (ev) {
                  parentScope.showKeyboard = true;
                  $rootScope.$broadcast("keyboard::changeInput", ev.target.value);
                };

                $timeout(function () {
                  $document[0].getElementById("bt-search").focus();
                }, 300);
                $scope.defaultColors = [{
                  name: "Amarillo",
                  id: 14
                }, {
                  name: "Azul",
                  id: 10
                }, {
                  name: "Blanco",
                  id: 16
                }, {
                  name: "Celeste",
                  id: 11
                }, {
                  name: "Gris",
                  id: 65
                }, {
                  name: "Marron",
                  id: 20
                }, {
                  name: "Naranja",
                  id: 3
                }, {
                  name: "Negro",
                  id: 17
                }, {
                  name: "Plata",
                  id: 23
                }, {
                  name: "Rojo",
                  id: 2
                }, {
                  name: "Rosa",
                  id: 4
                }, {
                  name: "Verde",
                  id: 7
                }];
                $scope.filteredColors = data.colors;
                $scope.filterText = "";

                $scope.filterColors = function () {
                  if (!$scope.filterText || !$scope.filterText.length) {
                    $scope.filteredColors = _toConsumableArray($scope.defaultColors);
                    return;
                  }

                  $scope.filteredColors = $scope.data.colors.filter(function (item) {
                    return item.name.toUpperCase().indexOf($scope.filterText.toUpperCase()) != -1;
                  });
                };

                $scope.filterColors();

                $scope.close = function () {
                  $uibModalInstance.dismiss("close");
                };

                $scope.select = function (color) {
                  $uibModalInstance.close(color);
                };
              },
              size: "lg",
              backdrop: "static",
              keyboard: false,
              resolve: {
                data: {
                  brand: brand,
                  colors: response.data
                }
              }
            });
            modalInstance.result.then(function (selectedColor) {
              resolve(selectedColor);
            }, function () {
              reject();
            });
          }, function (error) {
            _this3.showError("Ocurrió un error", error.message, error.outcode);

            $log.error("Error on continue");
            $log.error(error);

            _this3.hideProgress();

            reject();
          });
        });
      },
      showCustomAmountSelector: function showCustomAmountSelector(parentScope) {
        return new Promise(function (resolve, reject) {
          var modalInstance = $uibModal.open({
            templateUrl: "app/common/cvu/custom-amount-input.html",
            controller: function controller($uibModalInstance, $scope, $document, $timeout, $rootScope) {
              $scope.customAmount = null;
              $scope.maxError = false;

              $scope.close = function () {
                $uibModalInstance.dismiss();
              };

              $scope.validateAmount = function () {
                var isValid = true;
                $scope.maxError = false;

                if (isNaN($scope.customAmount)) {
                  isValid = false;
                } else if ($scope.customAmount <= 0) {
                  isValid = false;
                } else if ($scope.customAmount > 10000) {
                  isValid = false;
                  $scope.maxError = true;
                }

                $scope.showErrors = !isValid;
                return isValid;
              };

              $scope.confirm = function () {
                if ($scope.validateAmount()) {
                  $uibModalInstance.close($scope.customAmount);
                }
              };

              $scope.inputFocus = function (ev) {
                parentScope.showKeyboard = true;
                $rootScope.$broadcast("keyboard::changeInput", ev.target.value);
              };

              $timeout(function () {
                $document[0].getElementById("customAmount").focus();
              }, 500);
            },
            size: "lg",
            backdrop: "static",
            keyboard: false
          });
          modalInstance.result.then(function (amount) {
            resolve(amount);
          }, function () {
            reject();
          });
        });
      },
      //
      // Printing methods
      //
      printTag: function printTag(qty, tags) {
        var self = this;
        return new Promise(function (resolve, reject) {
          $log.log("Sending print request with " + qty + " copies...");
          self.printTagEndEvent = $rootScope.$on("PRINT_END", function ()
          /*evt, data*/
          {
            resolve();
          });
          self.printTagErrorEvent = $rootScope.$on("PRINT_ERROR", function ()
          /*evt, data*/
          {
            reject();
          });

          _electron.ipcRenderer.send("PRINT", qty, tags);
        });
      }
    };
  }
})();


"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

angular.module("app").factory("ApiService", ApiService);
ApiService.inject = ["$http", "$log"];
/* @ngInject */

function ApiService($http, $log, $window) {
  var api = {
    coreConfig: null,
    // serverUrl: $window.API_URL ? $window.API_URL : 'http://localhost:12345',     // LOCAL
    // serverUrl: $window.API_URL ? $window.API_URL : 'http://192.168.1.207:12345', // RONDY
    serverUrl: $window.API_URL ? $window.API_URL : "http://192.168.1.235:12345",
    // NACHO
    timeout: 40000,
    // timeout: 100,
    authorization: $window.credentials // authorization: '6b8ZyP0XnlS67J3v6'

  }; // -------------------------------------------------------------------------
  //
  // Core methods
  //

  api.initialize = function (coreConfig) {
    api.coreConfig = coreConfig;
  }, api.httpGet = function (url, custom_headers) {
    var _this = this;

    var headers = _objectSpread(_objectSpread({}, custom_headers), {}, {
      authorization: api.authorization,
      "X-Totem": api.coreConfig.hostname
    });

    return new Promise(function (resolve, reject) {
      try {
        $http.get(url, {
          headers: headers,
          timeout: _this.timeout
        }).then(function (response) {
          if (!response) {
            $log.error("ApiService|httpGet|Empty response for url: " + url);
            $log.error(response);
            reject({
              outcode: -1,
              message: "Respuesta vacía del servidor"
            });
          } else {
            if (response.status != 200 && response.status != 201 && response.status != 401) {
              $log.error("ApiService|httpGet|Error with status code " + response.status);
              $log.error(response);
              reject({
                outcode: response.status,
                message: response.meta.desc
              });
            } else {
              resolve(response.data);
            }
          }
        }, function (error) {
          $log.error("ApiService|httpGet|Comm error for url: " + url);
          $log.error(error);
          reject({
            outcode: error.data && error.data.outcode ? error.data.outcode : -1,
            message: error.data && error.data.message ? error.data.message : "Error en la comunicación con el servidor (" + error.status + ")"
          });
        });
      } catch (exc) {
        $log.error("ApiService|httpGet|Exception catched for url: " + url);
        $log.error(exc);
        reject({
          outcode: -1,
          message: "Error interno"
        });
      }
    });
  };

  api.httpPost = function (url, data, custom_headers) {
    var _this2 = this;

    var headers = _objectSpread(_objectSpread({}, custom_headers), {}, {
      authorization: api.authorization,
      "X-Totem": api.coreConfig.hostname
    });

    return new Promise(function (resolve, reject) {
      try {
        $http.post(url, data, {
          headers: headers,
          timeout: _this2.timeout
        }).then(function (response) {
          if (!response) {
            $log.error("ApiService|httpPost|Empty response for url: " + url);
            $log.error(response);
            reject({
              outcode: -1,
              message: "Respuesta vacía del servidor"
            });
          } else {
            if (response.status != 200 && response.status != 201 && response.status != 401) {
              $log.error("ApiService|httpPost|Error with status code " + response.status);
              $log.error(response.data);
              reject({
                outcode: response.status,
                message: response.meta.desc
              });
            } else {
              resolve(response.data);
            }
          }
        }, function (error) {
          $log.error("ApiService|httpPost|Comm error (" + error.xhrStatus + ") for url: " + url);
          $log.error(error);

          if (error.xhrStatus == "timeout") {
            reject({
              outcode: -2,
              message: "Timeout en la comunicación con el servidor (" + error.status + ")"
            });
          } else {
            reject({
              outcode: error.data && error.data.outcode ? error.data.outcode : -1,
              message: error.data && error.data.message ? error.data.message : "Error en la comunicación con el servidor (" + error.status + ")"
            });
          }
        });
      } catch (exc) {
        $log.error("ApiService|httpPost|Exception catched for url: " + url);
        $log.error(exc);
        reject({
          outcode: -1,
          message: "Error interno"
        });
      }
    });
  }; // -------------------------------------------------------------------------
  //
  // Server Core Methods
  //


  api.maintenanceLogin = function (password) {
    var data = {
      password: password
    };
    $log.debug("ApiService | maintenanceLogin | Requesting...");
    return this.httpPost(this.serverUrl + "/totem/access", data);
  };

  api.getTotemInfo = function (summarized) {
    $log.debug("ApiService | getTotemInfo | Requesting...");
    var params = "";

    if (summarized) {
      params = "?summarized=1";
    }

    return this.httpGet(this.serverUrl + "/totem" + params);
  };

  api.searchRoll = function (filter, encPass) {
    $log.debug("ApiService | searchRoll | Requesting with " + filter + "...");
    return this.httpGet(this.serverUrl + "/rolls/filter?name=" + filter, {
      "x-totem-credentials": encPass
    });
  };

  api.installRoll = function (rollId, encPass) {
    var data = {
      rollId: rollId
    };
    $log.debug("ApiService | installRoll | Requesting with [" + angular.toJson(data) + "]...");
    return this.httpPost(this.serverUrl + "/rolls/assign", data, {
      "x-totem-credentials": encPass
    });
  };

  api.setTotemStatus = function (status, cause, encPass) {
    var data = {
      status: status,
      cause: cause
    };
    $log.debug("ApiService | setTotemStatus | Requesting...");
    return this.httpPost(this.serverUrl + "/totem/status", data, {
      "x-totem-credentials": encPass
    });
  };

  api.setTotemSettings = function (data, encPass) {
    $log.debug("ApiService | setTotemSettings | Requesting...");
    return this.httpPost(this.serverUrl + "/totem/settings", data, {
      "x-totem-credentials": encPass
    });
  }; // -------------------------------------------------------------------------
  //
  // CVU Methods
  //


  api.CVUStartNewTag = function (data) {
    $log.debug("ApiService | CVUStartNewTag | Requesting with [" + angular.toJson(data) + "]...");
    return this.httpPost(this.serverUrl + "/cvu/start/new", data);
  };

  api.CVUStartRecharge = function (data) {
    $log.debug("ApiService | CVUStartRecharge | Requesting with [" + angular.toJson(data) + "]...");
    return this.httpPost(this.serverUrl + "/cvu/start/recharge", data);
  };

  api.CVUGetVehicleBrands = function () {
    $log.debug("ApiService | CVUGetVehicleBrands | Requesting...");
    return this.httpGet(this.serverUrl + "/cvu/vehicle/brands");
  };

  api.CVUGetVehicleModels = function (brand) {
    $log.debug("ApiService | CVUGetVehicleBrands | Requesting models for brand [" + brand + "]...");
    return this.httpGet(this.serverUrl + "/cvu/vehicle/models?brand=" + brand);
  };

  api.CVUGetVehicleColors = function () {
    $log.debug("ApiService | CVUGetVehicleColors | Requesting colors...");
    return this.httpGet(this.serverUrl + "/cvu/vehicle/colors");
  };

  api.CVUGetRechargeAmounts = function () {
    $log.debug("ApiService | CVUGetRechargeAmounts | Requesting amounts for recharge/topup...");
    return this.httpGet(this.serverUrl + "/cvu/rechargeAmounts");
  };

  api.CVUExecuteStart = function (trxId, vehicle, clientNumber, amount, user) {
    $log.debug("ApiService | CVUExecuteStart | Requesting execute start for trxId " + trxId + "...");
    var data = {
      transactionId: trxId
    };

    if (vehicle) {
      data.vehicle = vehicle;
    }

    if (clientNumber) {
      data.clientNumber = clientNumber;
    }

    if (amount) {
      data.amount = amount;
    }

    if (user) {
      data.user = user;
    }

    return this.httpPost(this.serverUrl + "/cvu/executeStart", data);
  };

  api.CVUExecuteStatus = function (trxId, clientNumber) {
    var data = {
      transactionId: trxId
    };

    if (clientNumber) {
      data.clientNumber = clientNumber;
    }

    $log.debug("ApiService | CVUExecuteStatus | Requesting execute status with [" + JSON.stringify(data) + "]...");
    return this.httpPost(this.serverUrl + "/cvu/executeStatus", data);
  };

  api.CVUExecuteRollback = function (trxId) {
    var data = {
      transactionId: trxId
    };
    $log.debug("ApiService | CVUExecuteRollback | Requesting execute rollback with [" + JSON.stringify(data) + "]...");
    return this.httpPost(this.serverUrl + "/cvu/executeRollback", data);
  };

  api.CVUReverseRecharge = function (trxId) {
    var data = {
      transactionId: trxId
    };
    $log.debug("ApiService | CVUReverseRecharge | Requesting recharge reverse with [" + JSON.stringify(data) + "]...");
    return this.httpPost(this.serverUrl + "/cvu/reverseRecharge", data);
  };

  api.CVUConfirmRecharge = function (trxId) {
    var data = {
      transactionId: trxId
    };
    $log.debug("ApiService | CVUReverseRecharge | Requesting recharge reverse with [" + JSON.stringify(data) + "]...");
    return this.httpPost(this.serverUrl + "/cvu/confirmRecharge", data);
  };

  api.expendedTag = function (transactionId, printQty) {
    var data = {
      transactionId: transactionId,
      printQty: printQty
    };
    $log.debug("ApiService | expendedTag | Requesting with [" + angular.toJson(data) + "]...");
    return this.httpPost(this.serverUrl + "/cvu/expendedTag", data);
  };

  api.expendedTagManual = function (tagCode, encPass) {
    $log.debug("ApiService | expendedTagManual | Requesting...");
    return this.httpPost(this.serverUrl + "/cvu/expendedTagManual", {
      tagCode: tagCode
    }, {
      "x-totem-credentials": encPass
    });
  };

  api.CVUCheckTAG = function (transactionId, tagCode) {
    var data = {
      transactionId: transactionId,
      tagCode: tagCode
    };
    $log.debug("ApiService | CVUCheckTAG | Requesting checkTag with [" + JSON.stringify(data) + "]...");
    return this.httpPost(this.serverUrl + "/cvu/checkTag/", data);
  };

  api.CVUConfirm = function (transactionId, vehicle) {
    var data = {
      transactionId: transactionId,
      vehicle: vehicle
    };
    $log.debug("ApiService | CVUConfirm | Requesting confirm with [" + JSON.stringify(data) + "]...");
    return this.httpPost(this.serverUrl + "/cvu/confirm/", data);
  }; // -------------------------------------------------------------------------
  //
  // Sarea Methods
  //


  api.SareaPay = function (data) {
    $log.debug("ApiService | SareaPay | Requesting payment...");
    return this.httpPost(this.serverUrl + "/sarea/pay", data);
  };

  api.SareaCheckPayment = function (paymentId, transactionId, customerId) {
    $log.debug("ApiService | SareaCheckPayment | Checking payment...");
    return this.httpPost(this.serverUrl + "/sarea/checkPayment", {
      paymentId: paymentId,
      transactionId: transactionId
    });
  };

  api.SareaRefund = function (paymentId) {
    $log.debug("ApiService | SareaRefund | Requesting payment refund...");
    return this.httpPost(this.serverUrl + "/sarea/refund", {
      paymentId: paymentId
    });
  };

  api.SareaCheckRefund = function (paymentId) {
    $log.debug("ApiService | SareaCheckRefund | Checking payment refund request...");
    return this.httpPost(this.serverUrl + "/sarea/checkRefund", {
      paymentId: paymentId
    });
  };

  return api;
}


"use strict";

angular.module("app").directive("ngTouchstart", function () {
  return {
    controller: ["$scope", "$element", function ($scope, $element) {
      $element.bind("touchstart", onTouchStart);

      function onTouchStart(event) {
        var method = $element.attr("ng-touchstart");
        $scope.$event = event;
        $scope.$apply(method);
      }
    }]
  };
}).directive("ngTouchmove", function () {
  return {
    controller: ["$scope", "$element", function ($scope, $element) {
      $element.bind("touchstart", onTouchStart);

      function onTouchStart(event) {
        event.preventDefault();
        $element.bind("touchmove", onTouchMove);
        $element.bind("touchend", onTouchEnd);
      }

      function onTouchMove(event) {
        var method = $element.attr("ng-touchmove");
        $scope.$event = event;
        $scope.$apply(method);
      }

      function onTouchEnd(event) {
        event.preventDefault();
        $element.unbind("touchmove", onTouchMove);
        $element.unbind("touchend", onTouchEnd);
      }
    }]
  };
}).directive("ngTouchend", function () {
  return {
    controller: ["$scope", "$element", function ($scope, $element) {
      $element.bind("touchend", onTouchEnd);

      function onTouchEnd(event) {
        var method = $element.attr("ng-touchend");
        $scope.$event = event;
        $scope.$apply(method);
      }
    }]
  };
}).directive("ngTap", function () {
  return {
    controller: ["$scope", "$element", function ($scope, $element) {
      var moved = false;
      $element.bind("touchstart", onTouchStart);

      function onTouchStart()
      /*event*/
      {
        $element.bind("touchmove", onTouchMove);
        $element.bind("touchend", onTouchEnd);
      }

      function onTouchMove()
      /*event*/
      {
        moved = true;
      }

      function onTouchEnd()
      /*event*/
      {
        $element.unbind("touchmove", onTouchMove);
        $element.unbind("touchend", onTouchEnd);

        if (!moved) {
          var method = $element.attr("ng-tap");
          $scope.$apply(method);
        }
      }
    }]
  };
});


"use strict";

angular.module("progress.bar", []).directive("ngProgressbar", function ($timeout) {
  return {
    restrict: "E",
    template: "<div class='progress'><div class='progress-bar progress-bar-{{type}}' role='progressbar' style='width:{{percent_complete}}%;'>{{current}} / {{max}} seconds</div></div>",
    replace: true,
    scope: {
      max: "@",
      start: "@",
      type: "@",
      onStop: "&"
    },
    controller: ["$scope", "$timeout", function ($scope, $timeout) {
      $scope.onTimeout = function () {
        $scope.startAt++;
        $scope.current = $scope.startAt;
        $scope.mytimeout = $timeout($scope.onTimeout, 1000);

        if ($scope.startAt >= $scope.max) {
          $scope.stop();
          $scope.onStop();
        }

        $scope.percent_complete = Number(100 * $scope.current / $scope.max);
      };

      $scope.stop = function () {
        $timeout.cancel($scope.mytimeout);
      };
    }],
    link: function link(scope, elem, attrs) {
      attrs.$observe("start", function (value) {
        if (value === "true") {
          scope.startAt = 0;
          scope.mytimeout = $timeout(scope.onTimeout, 1000);
        } else if (value === "false") {
          scope.stop();
        }
      });
    }
  };
});


"use strict";

// angular.module('app').directive('ripple', ['$window', function ($window) {
angular.module("app").directive("ripple", function () {
  var linkFn = function linkFn(scope, element
  /*, attrs*/
  ) {
    element.css("overflow", "hidden"); // var elementClientHeight = element[0].clientHeight,
    //     elementScrollHeight = element[0].scrollHeight;

    var rippling = false; //var rippleStream = scope.rippleStream || false;
    // var adjust = function () {
    //   elementClientHeight = element[0].clientHeight;
    //   elementScrollHeight = element[0].scrollHeight;
    // };

    var ripple = function ripple(e) {
      rippling = true;
      var eRipple = angular.element('<span class="' + scope.rippleClass + '"></span>'); // var rect = element[0].getBoundingClientRect(),
      //     left = e.x - rect.left - (scope.rippleRadius ? scope.rippleRadius/2 : 25)
      //             - (scope.rippleOffsetX ? scope.rippleOffsetX : 0),
      //     top = e.y - rect.top - (scope.rippleRadius ? scope.rippleRadius/2 : 25)
      //             - (scope.rippleOffsetY ? scope.rippleOffsetY : 0);
      // if(elementScrollHeight !== elementClientHeight) {
      //   top -= elementScrollHeight;
      // } else {
      //   top -= scope.rippleRadius ? scope.rippleRadius/2 : 25;
      // }

      var left = e.layerX;
      var top = e.layerY;
      eRipple.css("display", "block");
      eRipple.css("position", "absolute");
      eRipple.css("width", scope.rippleRadius ? scope.rippleRadius + "px" : "50px");
      eRipple.css("height", scope.rippleRadius ? scope.rippleRadius + "px" : "50px"); // eRipple.css('margin-left', left +'px');
      // eRipple.css('margin-top', top+'px');

      eRipple.css("left", left + "px");
      eRipple.css("top", top + "px");
      element.append(eRipple);
      eRipple.on("animationend msAnimationEnd webkitAnimationEnd oAnimationEnd", function () {
        eRipple.remove();
        rippling = false;
        scope.rippleCallback && scope.rippleCallback({});
      });
      e.stopPropagation();
      e.preventDefault();
    }; // angular.element($window).bind('resize', function() {
    //   adjust();
    // });


    element.on("mousedown ontouchstart", function (e) {
      if (!rippling || scope.rippleStream) {
        ripple(e);
      }
    });
  };

  return {
    scope: {
      rippleClass: "@",
      rippleRadius: "@",
      rippleOffsetX: "@",
      rippleOffsetY: "@",
      rippleStream: "@",
      rippleCallback: "&"
    },
    retrict: "A",
    link: linkFn
  };
}); // }]);


"use strict";

(function () {
  angular.module("app").directive("keyboard", function () {
    var controller = ["$scope", "$rootScope", "$element", "$attrs", "$log", "$window", "$document", function ($scope, $rootScope, $element, $attrs, $log, $window, $document) {
      $scope.form = $document[0].getElementById($scope.formName); //
      // Attributes watch
      //

      $scope.$watch("layout", function (newValue
      /*, oldValue*/
      ) {
        if (!$scope.keyboard) return; // $log.debug('Keyboard|Setting new layout to ' + newValue + ' from ' + oldValue);

        $scope.keyboard.setOptions({
          layoutName: newValue
        });
      }, true); // $scope.$watch('input', function (newValue , oldValue) {
      //   $log.warn('Keyboard| Input watch | Setting new input to ' + newValue + ' from ' + oldValue);
      //   if (newValue == oldValue) {
      //     $log.log('equal');
      //     return;
      //   }
      //   if (!$scope.keyboard) return;
      //   $scope.keyboard.setInput(newValue);
      // }, true);

      $scope.changeInputHanlder = $rootScope.$on("keyboard::changeInput", function (event, arg) {
        // $log.warn('Keyboard| Input watch | Setting new input to ' + arg );
        $scope.keyboard.setInput(arg);
      }); //
      // Init
      //

      $scope.handleShift = function () {
        var currentLayout = $scope.keyboard.options.layoutName;
        var shiftToggle = currentLayout === "default" ? "shift" : "default"; // $log.log('Setting layout to ' + shiftToggle);

        $scope.keyboard.setOptions({
          layoutName: shiftToggle
        });
      };

      $scope.handleNext = function () {
        var els = $scope.form.elements;
        var activeEl = $document[0].activeElement;

        for (var i = 0; i < els.length; i++) {
          if (els[i].id == activeEl.id) {
            if (i + 1 < els.length) {
              els[i + 1].focus();
              $scope.keyboard.setInput(els[i + 1].value);
            } else if (i + 1 == els.length) {
              els[0].focus();
              $scope.keyboard.setInput(els[0].value);
              break;
            }
          }
        }
      };

      $scope.onChange = function (newValue) {
        $document[0].activeElement.value = newValue;
        $scope.input = newValue;
        angular.element($document[0].activeElement).triggerHandler("input"); // $log.log("Input changed to " + newValue);
      };

      $scope.onKeyPress = function (button) {
        // $log.log("Button pressed", button);
        if (button === "{shift}" || button === "{lock}") {
          $scope.handleShift();
          return;
        }

        if (button === "{tab}") {
          $scope.handleNext();
          return;
        }

        if (button === "{bksp}") {
          return;
        }

        if (button === "←") {
          return;
        } // $scope.input += button;
        //$scope.input = $scope.keyboard.getInput();

      };

      $scope.keyboard = new $window.SimpleKeyboard["default"]({
        layout: {
          min: ["1 2 3 4 5 6 7 8 9 0 {bksp}", " q w e r t y u i o p ", " a s d f g h j k l ñ", "  z x c v b n m  ", " {space} "],
          "default": ["1 2 3 4 5 6 7 8 9 0 {bksp}", " Q W E R T Y U I O P ", " A S D F G H J K L Ñ ", "  Z X C V B N M  ", " {space} "],
          email: [" @gmail.com @hotmail.com @ .com ", "1 2 3 4 5 6 7 8 9 0 {bksp}", " q w e r t y u i o p ", " a s d f g h j k l ñ ", " z x c v b n m . _ - ", " {tab} "],
          phoneNumber: [" 1 2 3 ", " 4 5 6 ", " 7 8 9 ", " + 0 {bksp} ", $scope.showNext ? " {tab} " : ""],
          number: [" 1 2 3 ", " 4 5 6 ", " 7 8 9 ", "  0  ", " {bksp} ", $scope.showNext ? " {tab} " : ""]
        },
        display: {
          "{bksp}": "←",
          "{enter}": "ENTER",
          "{space}": "ESPACIO",
          "{lock}": "MAYUS",
          "{tab}": "SIGUIENTE"
        },
        buttonTheme: [{
          "class": "bt-key-blank",
          buttons: " "
        }, {
          "class": "bt-key-next",
          buttons: "{tab}"
        }],
        onChange: function onChange(input) {
          return $scope.onChange(input);
        },
        onKeyPress: function onKeyPress(button) {
          return $scope.onKeyPress(button);
        },
        preventMouseDownDefault: true,
        tabCharOnTab: false,
        physicalKeyboardHighlight: true
      });
    }],
        template = '<div class="keyboard-cntr bt-keyboard"><div class="simple-keyboard"></div></div>';
    return {
      restrict: "E",
      scope: {
        layout: "=layout",
        // input: '=input',
        formName: "=formName",
        showNext: "=showNext" //add: '&',

      },
      controller: controller,
      template: template,
      replace: true
    };
  });
})();


"use strict";

// var electron = require('electron');
(function () {
  "use strict";

  var app = angular.module("app"); // eslint-disable-next-line angular/module-getter

  app.run(runBlock);
  /** @ngInject */

  function runBlock($document, $log, $rootScope, tmhDynamicLocale, CoreService, ApiService, $window) {
    $log.info("App run started...");
    $window.dayjs.extend($window.dayjs_plugin_updateLocale);
    $window.dayjs.locale("es");
    $window.dayjs.extend($window.dayjs_plugin_calendar);
    $window.dayjs.updateLocale("es", {
      calendar: {
        lastDay: "[Ayer a las] h:mm A",
        sameDay: "[Hoy a las] h:mm A",
        nextDay: "[Mañama a las] h:mm A",
        lastWeek: "dddd [pasado a las] h:mm A",
        nextWeek: "dddd [a las] h:mm A",
        sameElse: "dddd D [de] MMMM [de] YYYY [a las] h:mm A"
      }
    });
    $window.dayjs().format(); //
    // Initialize locale
    //
    // $rootScope.$on("$translateChangeSuccess", function (event, data) {
    //   // eslint-disable-line angular/on-watch
    //   tmhDynamicLocale.set(data.language);
    //   $document[0].documentElement.setAttribute("lang", data.language);
    // });
    //
    // Check DEBUG MODE
    //

    if ($window.IS_DEBUG) {
      $log.info("-----------------------------");
      $log.info("    RUNNING IN DEBUG MODE!   ");
      $log.info("-----------------------------");
    } // $rootScope.$on("$translateChangeSuccess", function (event, data) {
    //   // eslint-disable-line angular/on-watch
    //   tmhDynamicLocale.set(data.language);
    //   $document[0].documentElement.setAttribute("lang", data.language);
    // });
    //
    // Initialize Core
    //


    CoreService.initialize($window.totem);
    $log.info("---------Config--------");
    $log.info(CoreService.config);
    $log.info("-----------------------");
    ApiService.initialize(CoreService.config); //
    // Connection monitor
    //

    $window.addEventListener("offline", function () {
      var el = $document[0].getElementById("noconn");
      el.style.display = "flex";
    }, false);
    $window.addEventListener("online", function () {
      var el = $document[0].getElementById("noconn");
      el.style.display = "none";
    }, false);
    $log.info("App run ready!");
  } // eslint-disable-next-line angular/module-getter


  app.filter("maskCi", function () {
    return function (user) {
      var ci = user.xsIdentificadorCli;
      var type = user.xiTipoCli;
      if (type !== "2") return ci; // eslint-disable-next-line angular/typecheck-string

      if (typeof ci === "string" && ci.length >= 5) {
        var visiblePart = ci.substring(0, 2) + "***" + ci.substring(ci.length - 3, ci.length - 2) + "-" + ci.substring(ci.length - 1);
        return visiblePart;
      } else {
        return ci;
      }
    };
  });
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").config(routerConfig);
  /** @ngInject */

  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state("home", {
      url: "/",
      component: "home"
    }); // ******************************************************
    // CVU
    //

    $stateProvider.state("start", {
      url: "/start",
      component: "start"
    });
    $stateProvider.state("contact-support", {
      url: "/contact-support",
      component: "cvuSupportScreen"
    });
    $stateProvider.state("maintenance", {
      url: "/maintenance",
      component: "maintenance"
    });
    $stateProvider.state("info", {
      url: "/info",
      component: "cvuInfo"
    }); //
    // Wizard New
    //

    $stateProvider.state("cvu-new-s1-id", {
      url: "/cvu/new/1",
      component: "cvuNewStep1User"
    });
    $stateProvider.state("cvu-new-s2-user-data", {
      url: "/cvu/new/2",
      component: "cvuNewStep2UserData"
    });
    $stateProvider.state("cvu-new-s3-vehicle", {
      url: "/cvu/new/3",
      component: "cvuNewStep3Vehicle"
    });
    $stateProvider.state("cvu-new-s4-topup", {
      url: "/cvu/new/4",
      component: "cvuNewStep4Topup"
    });
    $stateProvider.state("cvu-new-s5-pay", {
      url: "/cvu/new/5",
      component: "cvuNewStep5Pay"
    });
    $stateProvider.state("cvu-new-s6-tag", {
      url: "/cvu/new/6",
      component: "cvuNewStep6Tag"
    });
    $stateProvider.state("cvu-new-s7-process", {
      url: "/cvu/new/7",
      component: "cvuNewStep7Process"
    });
    $stateProvider.state("cvu-new-s7b-refund", {
      url: "/cvu/new/7b",
      component: "cvuNewStep7bRefund"
    });
    $stateProvider.state("cvu-new-s8-done", {
      url: "/cvu/new/8",
      component: "cvuNewStep8Done"
    });
    $stateProvider.state("cvu-new-s8b-refunded", {
      url: "/cvu/new/8b",
      component: "cvuNewStep8bRefunded"
    }); //
    // Recharge account
    //

    $stateProvider.state("cvu-rech-s1-id", {
      url: "/cvu/recharge/1",
      component: "cvuRechStep1User"
    });
    $stateProvider.state("cvu-rech-s1b-client-select", {
      url: "/cvu/recharge/1-client-select",
      component: "cvuRechStep1ClientSelect"
    });
    $stateProvider.state("cvu-rech-s2-topup", {
      url: "/cvu/recharge/2",
      component: "cvuRechStep2Topup"
    });
    $stateProvider.state("cvu-rech-s3-process", {
      url: "/cvu/recharge/3",
      component: "cvuRechStep3Process"
    });
    $stateProvider.state("cvu-rech-s4-pay", {
      url: "/cvu/recharge/4",
      component: "cvuRechStep4Pay"
    });
    $stateProvider.state("cvu-rech-s4b-revert", {
      url: "/cvu/recharge/4b",
      component: "cvuRechStep4bRevert"
    });
    $stateProvider.state("cvu-rech-s5-confirm", {
      url: "/cvu/recharge/5",
      component: "cvuRechStep5Confirm"
    });
    $stateProvider.state("cvu-rech-s5b-refund", {
      url: "/cvu/recharge/5b",
      component: "cvuRechStep5bRefund"
    });
    $stateProvider.state("cvu-rech-s6-done", {
      url: "/cvu/recharge/6",
      component: "cvuRechStep6Done"
    });
    $stateProvider.state("cvu-rech-s6b-refunded", {
      url: "/cvu/recharge/6b",
      component: "cvuRechStep6bRefunded"
    });
    $urlRouterProvider.otherwise("/");
  }
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").constant("SAMPLE_CONSTANT", "Sample constant");
})();


"use strict";

(function () {
  "use strict";

  angular.module("app").config(configBlock);
  /** @ngInject */

  function configBlock($locationProvider, $logProvider, $translateProvider, tmhDynamicLocaleProvider, uiGmapGoogleMapApiProvider) {
    $locationProvider.html5Mode(true);
    $logProvider.debugEnabled(true);
    $translateProvider.useStaticFilesLoader({
      // Update `config.locales.directory` in `gulp/config.js` if change.
      prefix: "./locales/",
      suffix: ".json"
    }).preferredLanguage("es").fallbackLanguage("es").useSanitizeValueStrategy("escape").useMissingTranslationHandlerLog();
    tmhDynamicLocaleProvider // Angular locales pattern used by `buildAngularLocales()` in
    // `gulp/locales.js`.
    .localeLocationPattern("./locales/angular-locale_{{locale}}.js").defaultLocale("es");
    uiGmapGoogleMapApiProvider.configure({
      key: "AIzaSyC0aYDd9d-wJHe0pLunCw_POfyaAm6Rfv8",
      v: "3.20",
      //defaults to latest 3.X anyhow
      libraries: "weather,geometry,visualization"
    });
  }
})();


angular.module('app').run(['$templateCache', function($templateCache) {$templateCache.put('app/common/cancel-dialog.html','<div class=modal-header><h4 class=modal-title>Cancelar</h4></div><div class=modal-body><div style="display: flex; align-content: center; justify-content: center; font-size: 27px; line-height: 36px; text-align: center">\xBFEst\xE1 seguro que desea cancelar la transacci\xF3n actual?</div></div><div class=modal-footer style="justify-content: space-evenly"><button type=button class="bt-button bt-danger-button" ripple ripple-class=ripple ripple-callback=cancel(true) ripple-radius=40>S\xED, cancelar</button> <button type=button class=bt-button ripple ripple-class=ripple ripple-callback=cancel(false) ripple-radius=40>No</button></div>');
$templateCache.put('app/common/modalMessage.html','<div class=modal-header><!--\n  <button type="button" class="close" data-dismiss="modal">&times;</button>\n--><h4 class=modal-title ng-if="data && data.title && data.title.length > 0">{{data.title}}</h4></div><div class=modal-body><div ng-bind-html=data.message></div><div ng-if=data.outcode style="margin-top: 40px; color: #888; font-size: 20px; font-family: monospace">C\xF3digo de error: {{data.outcode}}</div></div><div class=modal-footer><!--\n  <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\n  --> <button type=button class="bt-button bt-primary-button" ng-click=close()>Cerrar</button></div>');
$templateCache.put('app/common/modalMessageWithNewAccount.html','<div class=modal-header><!--\n  <button type="button" class="close" data-dismiss="modal">&times;</button>\n--><h4 class=modal-title ng-if="data && data.title && data.title.length > 0">{{data.title}}</h4></div><div class=modal-body><div ng-bind-html=data.message></div><div ng-if=data.outcode style="margin-top: 40px; color: #888; font-size: 20px; font-family: monospace">C\xF3digo de error: {{data.outcode}}</div></div><div class=modal-footer><button type=button class="bt-button bt-primary-button" ng-click=goToNewAccount()>Crear nueva cuenta</button> <button type=button class="bt-button bt-small" ng-click=close()>Cerrar</button></div>');
$templateCache.put('app/common/retry-cancel-dialog.html','<div class=modal-header><h4 class=modal-title>{{data.title}}</h4></div><div class=modal-body><div ng-if=data.errorDesc>{{data.errorDesc}} {{ data.errorCode ? \' (\'+data.errorCode+\')\' : \'\'}}</div><div style="display: flex; align-content: center; justify-content: center; line-height: 36px; text-align: center">\xBFDesea reintentar la operaci\xF3n?</div></div><div class=modal-footer style="justify-content: space-evenly"><button type=button class="bt-button bt-primary-button" ripple ripple-class=ripple ripple-callback=retry(true) ripple-radius=40>Reintentar</button> <button type=button class="bt-button bt-link-button" ripple ripple-class=ripple ripple-callback=retry(false) ripple-radius=40>Cancelar</button></div>');
$templateCache.put('app/common/session-timeout.html','<div class=modal-header><h4 class=modal-title style="text-align: center; font-size: 36px">Atenci\xF3n</h4></div><div class=modal-body style="text-align: center"><div>La sesi\xF3n se cerrar\xE1 en</div><div style="margin: 20px 0px 5px 0px; font-size: 50px">{{remSecs}}</div><div style="margin: 18px 0px 30px 0px">segundos</div><div>\xBFNecesita m\xE1s tiempo?</div></div><div class=modal-footer style="flex-direction: column; align-items: center"><button type=button class="bt-button bt-primary-button" ng-click=keepSession()>Si</button> <button type=button class="bt-button bt-link-button" ng-click=closeSession()>No, cerrar sesi\xF3n</button></div>');
$templateCache.put('app/common/cvu/custom-amount-input.html','<!-- <div class="modal-header">\n  <h4 class="modal-title">Ingrese un monto a recargar</h4>\n</div> --><div class=modal-body><div style="display: flex; align-content: center; justify-content: center; flex-direction: column"><h2 style="text-align: center; font-weight: 800; font-size: 36px; margin: 70px 0px 20px 0px">Ingrese un monto a recargar</h2><form class=wizard-form name=customAmountForm id=customAmountForm novalidate><div class=form-group style="margin-top: 20px"><input type=text class=form-control id=customAmount name=customAmount placeholder="" autocomplete=off ng-focus=inputFocus($event) style="text-align: center; font-size: 60px; height: 80px" ng-model=customAmount ng-change=validateAmount() ng-minlength=3 ng-required=true><div class=field-error-cntr><p ng-show="customAmountForm.customAmount.$error.minlength && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Ingrese un monto mayor o igual a 100</p><p ng-show="customAmountForm.customAmount.$error.required && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor ingrese un monto</p><p ng-show="maxError && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor ingrese un monto entre 100 y 10000</p></div></div></form></div></div><div class=modal-footer style="flex-direction: column; align-items: center"><button type=button class="bt-button bt-primary-button" style="margin-bottom: 30px" ripple ripple-class=ripple ripple-callback=confirm(customAmountForm.$valid) ng-disabled=!validateAmount() ripple-radius=40>Confirmar</button> <button type=button class=bt-button ripple ripple-class=ripple ripple-callback=close() ripple-radius=40>Cancelar</button></div>');
$templateCache.put('app/common/cvu/vehicle-brand-selector.html','<div class=modal-body style="height: 738px"><div class="bt-search-input input-group col-md-12"><input id=bt-search ng-focus=inputFocus($event) ng-change=filterBrands() ng-model=filterText type=text class="form-control input-lg" placeholder=Buscar> <span class=input-group-btn><button class="btn btn-info btn-lg" type=button><i class="glyphicon glyphicon-search"></i></button></span></div><div style="margin-top: 30px; display: flex; align-content: center; justify-content: center; flex-direction: column"><div class="bt-grid-btns bt-grid-cols-3"><div ng-repeat="brand in filteredBrands | limitTo: 12" class=bt-grid-button ripple ripple-class=ripple ripple-callback=select(brand) ripple-radius=50><span class=bt-grid-button-text>{{brand.name}}</span></div></div></div><div ng-if="filteredBrands.length > 12 || !filterText || !filterText.length" class=bt-info-box style="margin-top: 15px; align-items: center; padding: 0"><div class=bt-info-box-icon><span class=material-icons-outlined>info</span></div><div class=bt-info-box-text>Utilice el buscador para encontrar mas marcas</div></div></div><div class=modal-footer style="margin: 0"><button type=button class=bt-button ripple ripple-class=ripple ripple-callback=close() ripple-radius=40>Cancelar</button></div>');
$templateCache.put('app/common/cvu/vehicle-color-selector.html','<div class=modal-body style="height: 738px"><div class="bt-search-input input-group col-md-12"><input id=bt-search ng-change=filterColors() ng-focus=inputFocus($event) ng-model=filterText type=text class="form-control input-lg" placeholder=Buscar> <span class=input-group-btn><button class="btn btn-info btn-lg" type=button><i class="glyphicon glyphicon-search"></i></button></span></div><div style="margin-top: 30px; display: flex; align-content: center; justify-content: center; flex-direction: column"><div class="bt-grid-btns bt-grid-cols-3"><div ng-repeat="color in filteredColors | limitTo: 12" class=bt-grid-button ripple ripple-class=ripple ripple-callback=select(color) ripple-radius=50><span class=bt-grid-button-text>{{color.name}}</span></div></div></div><div ng-if="filteredColors.length > 12 || !filterText || !filterText.length" class=bt-info-box style="margin-top: 15px; align-items: center; padding: 0"><div class=bt-info-box-icon><span class=material-icons-outlined>info</span></div><div class=bt-info-box-text>Utilice el buscador para encontrar mas colores</div></div></div><div class=modal-footer style="margin: 0"><button type=button class=bt-button ripple ripple-class=ripple ripple-callback=close() ripple-radius=40>Cancelar</button></div>');
$templateCache.put('app/common/cvu/vehicle-model-selector.html','<div class=modal-body style="height: 738px"><div class="bt-search-input input-group col-md-12"><input id=bt-search ng-change=filterModels() ng-focus=inputFocus($event) ng-model=filterText type=text class="form-control input-lg" placeholder=Buscar> <span class=input-group-btn><button class="btn btn-info btn-lg" type=button><i class="glyphicon glyphicon-search"></i></button></span></div><div style="margin-top: 30px; display: flex; align-content: center; justify-content: center; flex-direction: column"><div class="bt-grid-btns bt-grid-cols-3"><div ng-repeat="model in filteredModels | limitTo: 12" class=bt-grid-button ripple ripple-class=ripple ripple-callback=select(model) ripple-radius=50><span class=bt-grid-button-text>{{model.name}}</span></div></div></div><div ng-if="filteredModels.length > 12" class=bt-info-box style="margin-top: 15px; align-items: center; padding: 0"><div class=bt-info-box-icon><span class=material-icons-outlined>info</span></div><div class=bt-info-box-text>Utilice el buscador para encontrar mas modelos</div></div></div><div class=modal-footer style="margin: 0"><button type=button class=bt-button ripple ripple-class=ripple ripple-callback=close() ripple-radius=40>Cancelar</button></div>');
$templateCache.put('app/pages/home/home.view.html','<div ng-click=goToStart()><div style="width: 100vw; margin-top: 250px; height: 545px"><img src=assets/img/home/logo.png style="width: 700px; margin-bottom: 100px"></div><div ng-click=goToStart()><div style="display: flex; width: 100%; height: 400px; flex-direction: column; align-items: center; justify-content: center"><div ng-if=!outOfService style="display: flex; margin-top: 180px; align-items: center; flex-grow: 1; justify-content: center; font-size: 100px; color: #fff; max-width: 700px">{{ \'pages.home.touch\' | translate }}</div><div ng-if=outOfService style="margin-top: 100px; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #fff; background-color: #4caf50; border-radius: 10px; padding: 30px 30px; border: 5px solid #ffffff; max-width: 800px"><div style="font-size: 45px">{{ \'pages.home.outOfServiceTitle1\' | translate }}</div><div style="font-size: 50px; font-weight: 600">{{ \'pages.home.outOfServiceTitle2\' | translate }}</div><div style="font-size: 32px; margin-top: 20px">{{ \'pages.home.outOfServiceMessage\' | translate }}</div></div></div><div style="position: absolute; bottom: 0px; align-items: center"><img src=assets/img/home/logo-back.png style="width: 100%"><div style="width: 100vw; position: relative; height: 112px; background-color: #9ab740"><svg style="transform: rotateX(180deg); position: absolute; width: 100%; left: 0px" viewBox="0 0 1920 200"><path fill=#c2d346 d="M 0 164 C 485.5 164 485.5 110 971 110 L 971 110 L 971 0 L 0 0 Z" stroke-width=0></path><path fill=#c2d346 d="M 970 110 C 1445 110 1445 120 1920 120 L 1920 120 L 1920 0 L 970 0 Z" stroke-width=0></path></svg> <svg style="transform: rotateX(180deg); position: absolute; width: 100%; left: 0px" viewBox="0 0 1920 200"><path fill=#9ab740 d="M 0 31 C 485.5 31 485.5 110 971 110 L 971 110 L 971 0 L 0 0 Z" stroke-width=0></path><path fill=#9ab740 d="M 970 110 C 1445 110 1445 49 1920 49 L 1920 49 L 1920 0 L 970 0 Z" stroke-width=0></path></svg></div><div style="height: 100px; background-color: #9ab740"></div></div></div><!-- MAINTENANCE SECRET BUTTON --><div style="background-color: rgba(255, 255, 255, 0); width: 100px; height: 100px; position: absolute; left: 0px; top: 0px" ng-touchstart=maintenancePressed($event) ng-touchend=maintenanceReleased($event)></div><!-- \n  <p>\n      {{ \'home.details\' | translate }}\n      <a href="https://github.com/loginov-rocks/Angular-Gulp-Boilerplate"\n        target="_blank">https://github.com/loginov-rocks/Angular-Gulp-Boilerplate</a>\n  </p>\n\n  <p>\n      <button ng-click="vm.switchLanguage(\'en\')">In English</button>\n      <button ng-click="vm.switchLanguage(\'ru\')">\u041F\u043E-\u0440\u0443\u0441\u0441\u043A\u0438</button>\n  </p>\n\n  <p>\n      <button ng-click="vm.showSampleConstant()">{{ \'home.button\' | translate }}</button>\n  </p> --></div><div style="position: absolute; bottom: 95px; width: 100%; display: flex; justify-content: center"><ng-progressbar type=info max={{max_count}} start={{timer_running}} on-stop=stopProgress()></ng-progressbar><!--  bt-outline-button --> <button type=submit class=bt-button style="background-color: #2196f3" ripple ripple-class=ripple ripple-callback=openInfo() ripple-radius=40><span class="glyphicon glyphicon-info-sign" aria-hidden=true style="font-size: 34px; color: #ffffff"></span> <span style="margin-left: 20px; color: #ffffff">Informaci\xF3n</span></button></div><div style="position: absolute; bottom: 10px; left: 10px; color: #fff; font-size: 12px" ng-click=openMaintenance()>{{appVersion}} - {{date | date:\'yyyy\'}}</div>');
$templateCache.put('app/pages/maintenance/maintenance.view.html','<div class="fullpage has-keyboard"><div ng-if=validated style="height: 100%"><div class=card style="height: 100%; width: 80vw"><h1>Mantenimiento</h1><!-- STATUS --><div id=statusCard style="width: 90%;\n          background-color: #ffccbc;\n          display: flex;\n          flex-direction: row;\n          margin: 0 auto;\n          padding: 15px 20px;\n          border-radius: 10px;"><div style="flex-grow: 1;\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;"><div style="font-weight: 600">ESTADO</div><div style="display: flex;\n              flex-direction: column;\n              align-items: flex-start;"><div style="font-size: 26px; line-height: 36px; font-weight: 800">{{data.outOfService == 1 ? \'FUERA DE SERVICIO\' : \'ONLINE\'}}</div><div>{{data.outOfServiceDesc}}</div></div></div><div style="display: flex; align-items: center"><div class="btn-group btn-toggle" ng-if="data.outOfService == 1"><button class="btn btn-lg btn-default" ng-click=setTotemStatusOnline(true)>ON</button> <button class="btn btn-lg btn-danger active">OFF</button></div><div class="btn-group btn-toggle" ng-if="data.outOfService == 0"><button class="btn btn-lg btn-success active">ON</button> <button class="btn btn-lg btn-default" ng-click=setTotemStatusOnline(false)>OFF</button></div></div></div><!-- ID --><div class=configcard style="margin-top: 20px"><div class=row><div class=col-md-6><div class=form-group><label for=userDocValue>Identificador</label><div class=form-value>{{data.id}}</div></div></div><div class=col-md-6><div class=form-group><label for=userDocValue>Nombre</label><div class=form-value>{{data.name}}</div></div></div></div></div><!-- LAST ACTIVITY --><div class=configcard style="margin-top: 20px" ng-if=data.lastTransaction><div class=row><div class=col-md-12><h3>\xDAltima transacci\xF3n</h3></div></div><div class=row><div class=col-md-6><div class=form-group><label for=userDocValue>Fecha</label><div class=form-value>{{data.lastTransaction.dateNice}}<br><span style="color: #999">({{data.lastTransaction.dateCalendar}})</span></div></div></div><div class=col-md-6><div class=form-group><label for=userDocValue>Resultado</label><div class=form-value>{{data.lastTransaction.status}}</div></div></div></div></div><!-- ROLL --><div class=configcard style="margin-top: 20px" ng-if=data.roll><div class=row><div class=col-md-12><h3>Rollo actual</h3></div></div><div class=row><div class=col-md-6><div class=form-group><label for=userDocValue>Identificador</label><div class=form-value>{{data.roll.id}}</div></div></div><div class=col-md-6><div class=form-group><label for=userDocValue>Nombre</label><div class=form-value>{{data.roll.name}}</div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label for=userDocValue>Posici\xF3n</label><div class=form-value>{{data.roll.sequencePosition}}</div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label for=userDocValue>Siguiente TAG</label><div class=form-value>{{data.roll.nextTagCode ? data.roll.nextTagCode : \'DESCONOCIDO\'}}</div></div></div></div><div class=row><div class=col-md-12><div class=progressCntr><div class=progressVal style=width:{{data.roll.usage}}%></div></div><div style="font-size: 22px">Quedan {{data.roll.remaining}} TAGs</div></div></div></div><!-- POS --><div class=configcard style="margin-top: 20px" ng-if=data><div class=row><div class=col-md-12><h3>Terminal POS</h3></div></div><div class=row><div style="display: flex; align-items: center"><div><div style="margin-left: 10px; display: flex; align-items: center"><select class=form-control style="width: 200px; margin-right: 10px" ng-model=data.paymentProcessor><option value=ingenico>Ingenico</option><option value=verifone>Verifone</option></select> <input ng-focus=inputFocus($event) placeholder=confTerminal class=form-control style="width: 300px" ng-model=data.posTerminalId> <button class="btn btn-lg btn-default" style="margin-left: 10px" type=button ng-click=setTotemSettings()>Guardar</button></div></div></div></div></div><div style="display: flex; justify-content: space-evenly; margin-top: 50px"><button type=button class="bt-button bt-link-button" ripple ripple-class=ripple ripple-callback=changeRoll() ripple-radius=40>Cambiar rollo</button> <button type=button class="bt-button bt-link-button" ripple ripple-class=ripple ripple-callback=expendTag() ripple-radius=40>Expedir un TAG</button></div><div style="display: flex; justify-content: space-evenly; margin-top: 10px"><button type=button class="bt-button bt-link-button" ripple ripple-class=ripple ripple-callback=exitApp() ripple-radius=40>Salir de la APP</button></div></div><div style="position: absolute; bottom: 10px; left: 10px; z-index: 10000"><button type=submit class="bt-button bt-outline-button" style="margin-top: 40px" ripple ripple-class=ripple ripple-callback=exit() ripple-radius=40>Salir</button></div></div></div><keyboard layout=keyboardLayout input=keyboardInput form-name="\'s2Form\'" show-next=false></keyboard>');
$templateCache.put('app/pages/start/start.view.html','<div class=fullpage><!--div style="position: absolute;width: 100%;top: 150px;">\n    <img src="assets/img/totem-logo-w.png">\n  </div--><div style="width: 100vw; margin-top: 100px; height: 320px"><img src=assets/img/home/logo.png style="width: 400px; margin-bottom: 50px"></div><div style="margin-top: 100px"><h1>{{ \'pages.start.title\' | translate }}</h1></div><div class=card-cntr-hori style="max-height: 500px" ng-if=initialized><div style="width: 50%; padding: 10px; display: flex; position: relative"><div class=card ng-class="{\'card-clickable\': newTagEnabled, \'card-disabled\': !newTagEnabled}" ripple ripple-class=ripple ripple-callback=goCVUNew() ripple-radius=100 style="width: 100%"><div class=card-img-container><img src=assets/img/start/tag.png style="width: 400px"></div><div class=card-body><h2>{{ \'pages.start.card1-title\' | translate }}</h2><p>{{ \'pages.start.card1-desc\' | translate }}</p></div></div><div ng-if=!newTagEnabled style="font-size: 29px; position: absolute; top: 50px; left: 20px; right: 19px; padding: 2px 0px; text-align: center; color: #fff; background-color: #ff5722">Moment\xE1neamente no disponible</div></div><div style="width: 50%; padding: 10px; display: flex"><div class="card card-clickable" ripple ripple-class=ripple ripple-callback=goCVURecharge() ripple-radius=100 style="width: 100%"><div class=card-img-container><img src=assets/img/start/recharge_tag.png style="width: 400px"></div><div class=card-body><h2>{{ \'pages.start.card2-title\' | translate }}</h2><p>{{ \'pages.start.card2-desc\' | translate }}</p></div></div></div></div><div style="max-height: 500px; margin-top: 300px; font-size: 34px; color: #fff; font-weight: 600" ng-if=!initialized>Espere...</div><div style="position: absolute; bottom: 50px"><button type=submit class="bt-button bt-outline-button" style="margin-top: 40px" ripple ripple-class=ripple ripple-callback=cancel() ripple-radius=40>Cancelar</button></div></div>');
$templateCache.put('app/pages/cvu/info/cvu-info.view.html','<script src="//maps.googleapis.com/maps/api/js?sensor=true"></script><div class="fullpage wizard"><div class=wizard-header><h2>Informaci\xF3n</h2></div><div class=mapCntr><ui-gmap-google-map ng-if=map center=map.center zoom=map.zoom draggable=true options=map.options><!-- Map Markers --><ui-gmap-marker coords=map.marker.coords idkey="\'URHere\'" options=markerOptions><!--ui-gmap-window show="true" closeClick="closeClick()">\n          <div>UTE TA QUI</div>\n        </ui-gmap-window--></ui-gmap-marker><ui-gmap-marker idkey=cvu01 coords=scope.tolls.barraSantaLucia.coords options=CVULabel01></ui-gmap-marker><ui-gmap-marker idkey=cvu02 coords=scope.tolls.cufre.coords options=CVULabel02></ui-gmap-marker><ui-gmap-marker idkey=cvu03 coords=scope.tolls.mercedes.coords options=CVULabel03></ui-gmap-marker><ui-gmap-marker idkey=cvu04 coords=scope.tolls.pasoPuerto.coords options=CVULabel04></ui-gmap-marker><ui-gmap-marker idkey=cvu05 coords=scope.tolls.queguay.coords options=CVULabel05></ui-gmap-marker><ui-gmap-marker idkey=cvu06 coords=scope.tolls.mendoza.coords options=CVULabel06></ui-gmap-marker><ui-gmap-marker idkey=cvu07 coords=scope.tolls.centenario.coords options=CVULabel07></ui-gmap-marker><ui-gmap-marker idkey=cvu08 coords=scope.tolls.manuelDiaz.coords options=CVULabel08></ui-gmap-marker><ui-gmap-marker idkey=cvu09 coords=scope.tolls.soca.coords options=CVULabel09></ui-gmap-marker><ui-gmap-marker idkey=cvu10 coords=scope.tolls.cebollati.coords options=CVULabel10></ui-gmap-marker><ui-gmap-marker idkey=cvu11 coords=scope.tolls.capillaDeCella.coords options=CVULabel11></ui-gmap-marker><ui-gmap-marker idkey=cvu12 coords=scope.tolls.garzon.coords options=CVULabel12></ui-gmap-marker><ui-gmap-marker idkey=cvu13 coords=scope.tolls.santaLucia.coords options=CVULabel13></ui-gmap-marker><ui-gmap-marker idkey=cvu14 coords=scope.tolls.pando.coords options=CVULabel14></ui-gmap-marker><ui-gmap-marker idkey=cvu15 coords=scope.tolls.solis.coords options=CVULabel15></ui-gmap-marker></ui-gmap-google-map></div><div class=card style="width: 90%; padding-bottom: 30px"><h1>Peajes</h1><div class=card-body style="height: 350px; overflow-y: scroll"><table style="width: 100%"><tr ng-repeat="toll in tolls track by toll.name"><td><strong>{{toll.name}}</strong></td><td>{{toll.address}}</td><td><button class="bt-button bt-link-button" ripple ripple-class=ripple ripple-callback=tollShow(toll) ripple-radius=40>Ubicar</button></td></tr></table></div></div><div class=card style="width: 90%; padding-bottom: 30px; margin-bottom: 30px"><h1>Tarifas</h1><div class=card-body style="overflow-y: scroll"><table style="width: 100%"><tr><th style="width: 50%; height: 50px; text-align: center">Categorias</th><th style="width: 50%; text-align: center">Telepeaje</th></tr><tr ng-repeat="price in prices track by price.name"><td style="width: 50%; height: 50px">{{price.name}}</td><td style="width: 50%">{{price.value}}</td></tr></table></div></div><footer><button type=submit class="bt-button btn-success" ng-click=goBack()><span class="material-icons md-36">west</span> Atr\xE1s</button></footer></div>');
$templateCache.put('app/pages/cvu/support-screen/cvu-support-screen.view.html','<div class="fullpage wizard"><div class=wizard-body><div class=card style="padding: 20px 40px; max-width: 90%; min-width: 70%"><h1>Cont\xE1ctese con nosotros</h1><div class=step-instructions style="color: #111111">Ha ocurri\xF3 un inconveniente con su transacci\xF3n</div><div style="padding: 10px; margin: 0 auto"><div style="font-size: 28px; margin-bottom: 10px">Llame al tel\xE9fono:</div><div style="font-size: 40px; font-weight: bold; margin: 10px 0px 30px 0px">(+598) 2626 0026</div><div style="display: flex; justify-content: center"><div style="background-color: #eee; padding: 10px 30px; border-radius: 8px"><div style="font-size: 22px">Referencia</div><div ng-if=data.wizardRecharge style="font-family: monospace; font-size: 30px">{{data.wizardRecharge.payment.transaction.id}} 28363927</div></div></div></div></div><div style="text-align: center; display: flex; justify-content: center"><button type=submit class="bt-button bt-primary-button bt-green-button bt-button-big" style="margin-top: 40px" ng-click=finish()>TERMINAR</button></div></div></div>');
$templateCache.put('app/pages/cvu/wizard-new/s1-id/cvu-new-s1-id.view.html','<div class="fullpage wizard has-keyboard"><div class=wizard-header><button type=submit class="bt-button bt-text-button wizard-header-left-button" ripple ripple-class=ripple ripple-callback=goBack() ripple-radius=40><span class="material-icons md-36">west</span> Atras</button><h2>Solicitud de nuevo tag</h2></div><div class=wizard-body><div class=card style="width: 75%; padding-bottom: 30px"><h1>Identificaci\xF3n</h1><div class=step-instructions>Ingrese su n\xFAmero de documento y la matr\xEDcula de su veh\xEDculo para comenzar</div><form class=wizard-form name=s1Form id=s1Form novalidate><label>Tipo de documento</label><div class=bt-radio-tile-group><div class=input-container><input id=userDocTypeCI name=userDocTypeCI class=radio-button type=radio ng-value=2 ng-model=data.userDocType checked ng-click=docTypeSelect() ng-focus=inputFocus($event)><div class=radio-tile><label for=userDocTypeCI class=radio-tile-label>{{ \'pages.cvu.wizard-new.s1-id.docType1\' | translate }}</label></div></div><div class=input-container><input id=userDocType name=userDocType class=radio-button type=radio name=radio ng-value=1 ng-model=data.userDocType ng-click=docTypeSelect() ng-focus=inputFocus($event)><div class=radio-tile><label for=userDocType class=radio-tile-label>{{ \'pages.cvu.wizard-new.s1-id.docType2\' | translate }}</label></div></div><div class=input-container><input id=userDocType name=userDocType class=radio-button type=radio name=radio ng-value=3 ng-model=data.userDocType ng-click=docTypeSelect() ng-focus=inputFocus($event)><div class=radio-tile><label for=userDocType class=radio-tile-label>{{ \'pages.cvu.wizard-new.s1-id.docType3\' | translate }}</label></div></div></div><div class=form-group style="margin-top: 20px"><label for=userDocValue>{{s1Form.userDocType.$modelValue == 1 ? \'RUT\' : s1Form.userDocType.$modelValue == 2 ? \'Documento Uruguayo\' : \'Documento extranjero\'}}</label> <input type=text class=form-control id=userDocValue name=userDocValue placeholder="" autocomplete=off ng-focus=inputFocus($event) style="text-align: center" ng-model=data.userDocValue ng-minlength="{{s1Form.userDocType.$modelValue == 1 ? 12 : s1Form.userDocType.$modelValue == 2 ? 7 : 6}}" ng-required=true><div class=field-error-cntr><p ng-show="!(s1Form.userDocValue.$error.minlength || s1Form.userDocValue.$error.required) && !validateDocValue()" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Ingrese un n\xFAmero de documento v\xE1lido</p><p ng-show="s1Form.userDocValue.$error.minlength && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Ingrese un n\xFAmero de documento v\xE1lido</p><p ng-show="s1Form.userDocValue.$error.required && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor ingrese su n\xFAmero de {{s1Form.userDocType.$modelValue == 1 ? \'RUT\' : s1Form.userDocType.$modelValue == 2 ? \'c\xE9dula\' : \'documento extranjero\'}}</p></div></div><div class=form-group style="margin-top: 20px"><label for=vehiclePlateNumber>Matr\xEDcula</label> <input type=text class=form-control id=vehiclePlateNumber name=vehiclePlateNumber placeholder="" autocomplete=off ng-focus=inputFocus($event) style="text-align: center" ng-model=data.vehiclePlateNumber ng-minlength=6 ng-required=true><div class=field-error-cntr><p ng-show="s1Form.vehiclePlateNumber.$error.minlength && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Ingrese un n\xFAmero de matr\xEDcula v\xE1lido</p><p ng-show="s1Form.vehiclePlateNumber.$error.required && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor ingrese un n\xFAmero de matr\xEDcula</p></div></div><button type=button class="bt-button bt-primary-button" style="margin-top: 40px" ng-disabled="!s1Form.$valid || !validateDocValue()" ripple ripple-class=ripple ripple-callback=continue(s1Form.$valid) ripple-radius=40>Continuar <span class="glyphicon glyphicon-chevron-right" aria-hidden=true></span></button></form></div><div style="position: absolute; bottom: 50px"><button type=submit class="bt-button bt-outline-button" style="margin-top: 40px" ripple ripple-class=ripple ripple-callback=cancel() ripple-radius=40>Cancelar</button></div></div></div><keyboard ng-show=showKeyboard layout=keyboardLayout input=keyboardInput form-name="\'s1Form\'"></keyboard>');
$templateCache.put('app/pages/cvu/wizard-new/s2-user-data/cvu-new-s2-user-data.view.html','<div class="fullpage wizard has-keyboard"><div class=wizard-header><button type=submit class="bt-button bt-text-button wizard-header-left-button" ripple ripple-class=ripple ripple-callback=goBack() ripple-radius=40><span class="material-icons md-36">west</span> Atras</button><h2>Solicitud de nuevo tag</h2></div><div class=wizard-body><div class=card style="width: 75%; padding-bottom: 30px"><h1>Datos personales</h1><div><div class=step-instructions>{{ $scope.operation == \'NEW_CLIENT\' ? \'Ingrese sus datos personales para crear una nueva cuenta\' : \'Complete sus datos para continuar\'}}</div><form class=wizard-form id=s2Form name=s2Form novalidate autocomplete=off><div class=form-group style="margin-top: 20px" ng-if=showFields.userName><label for=userName>Nombre completo</label> <input type=text class=form-control id=userName name=userName placeholder="" autocomplete=off ng-focus=inputFocus($event) style="text-align: center" ng-minlength=3 ng-required=true ng-model=data.userName><div class=field-error-cntr><p ng-show="s2Form.userName.$error.minlength && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor ingrese un nombre v\xE1lido</p><p ng-show="s2Form.userName.$error.required && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor ingrese su nombre completo</p></div></div><div class=form-group style="margin-top: 20px" ng-if=showFields.userCel><label for=userCel>Celular</label> <input type=tel class=form-control id=userCel name=userCel placeholder="" autocomplete=off ng-focus=inputFocus($event) style="text-align: center" ng-minlength=6 ng-required=true ng-model=data.userCel><div class=field-error-cntr><p ng-show="s2Form.userCel.$error.minlength && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor ingrese un n\xFAmero de celular v\xE1lido</p><p ng-show="s2Form.userCel.$error.required && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor ingrese su n\xFAmero de celular</p></div></div><div class=form-group style="margin-top: 20px; width: 400px" ng-if=showFields.userEmail><label for=userEmail>Correo electr\xF3nico</label> <input type=email class=form-control id=userEmail name=userEmail placeholder="" autocomplete=off ng-focus=inputFocus($event) style="text-align: center" ng-minlength=6 ng-required=true ng-model=data.userEmail><div class=field-error-cntr><p ng-show="s2Form.userEmail.$error.minlength && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor ingrese un correo electr\xF3nico v\xE1lido</p><p ng-show="s2Form.userEmail.$error.required && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor ingrese su correo electr\xF3nico</p></div></div><button type=submit class="bt-button bt-primary-button" style="margin-top: 40px" ng-disabled=!s2Form.$valid ripple ripple-class=ripple ripple-callback=continue(s2Form.$valid) ripple-radius=40>Continuar <span class="glyphicon glyphicon-chevron-right" aria-hidden=true></span></button></form></div></div><div style="position: absolute; bottom: 50px"><button type=submit class="bt-button bt-outline-button" style="margin-top: 40px" ripple ripple-class=ripple ripple-callback=cancel() ripple-radius=40>Cancelar</button></div></div></div><keyboard ng-show=showKeyboard layout=keyboardLayout input=keyboardInput form-name="\'s2Form\'" show-next=true></keyboard>');
$templateCache.put('app/pages/cvu/wizard-new/s3-vehicle/cvu-new-s3-vehicle.view.html','<div class="fullpage wizard"><div class=wizard-header><button type=submit class="bt-button bt-text-button wizard-header-left-button" ripple ripple-class=ripple ripple-callback=goBack() ripple-radius=40><span class="material-icons md-36">west</span> Atras</button><h2>Solicitud de nuevo tag</h2></div><div class=wizard-body><div class=card style="width: 75%; padding-bottom: 30px"><h1>Datos del veh\xEDculo</h1><div><div class=step-instructions>Ingrese los datos de su veh\xEDculo</div><form class=wizard-form id=s2Form name=s2Form novalidate autocomplete=off><div class=form-group style="margin-top: 20px"><label>Marca</label><div class=form-value-label>{{data.vehicleBrand.name}}</div><div class=field-error-cntr ng-if="data.vehicleBrand.length == 0 && showErrors"><p class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor seleccione una marca del vech\xEDculo</p></div><button class="bt-button bt-link-button" type=button ripple ripple-class=ripple ripple-callback=pickBrand() ripple-radius=40>{{ data.vehicleBrand.length == 0 ? \'Seleccionar\' : \'Cambiar\' }}</button></div><div class=form-group style="margin-top: 60px"><label>Modelo</label><div class=form-value-label>{{data.vehicleModel.name}}</div><div class=field-error-cntr ng-if="data.vehicleModel.length == 0 && showErrors"><p class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor seleccione un modelo del vech\xEDculo</p></div><button class="bt-button bt-link-button" type=button ripple ripple-class=ripple ripple-callback=pickModel() ripple-radius=40>{{ data.vehicleModel.length == 0 ? \'Seleccionar\' : \'Cambiar\' }}</button></div><div class=form-group style="margin-top: 60px; margin-bottom: 20px"><label>Color</label><div class=form-value-label>{{data.vehicleColor.name}}</div><div class=field-error-cntr ng-if="data.vehicleColor.length == 0 && showErrors"><p class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor seleccione un color del vech\xEDculo</p></div><button class="bt-button bt-link-button" type=button ripple ripple-class=ripple ripple-callback=pickColor() ripple-radius=40>{{ data.vehicleColor.length == 0 ? \'Seleccionar\' : \'Cambiar\' }}</button></div><button type=button class="bt-button bt-primary-button bt-button-icon-right" style="margin-top: 40px" ng-disabled="!s2Form.$valid || !isDataValid()" ripple ripple-class=ripple ripple-callback=continue(s2Form.$valid) ripple-radius=40>Continuar <span class="glyphicon glyphicon-chevron-right" aria-hidden=true></span></button></form></div></div><div style="position: absolute; bottom: 50px"><button type=submit class="bt-button bt-outline-button" style="margin-top: 40px" ripple ripple-class=ripple ripple-callback=cancel() ripple-radius=40>Cancelar</button></div></div></div><keyboard ng-show=showKeyboard layout="\'default\'" input=keyboardInput form-name="\'s1Form\'"></keyboard>');
$templateCache.put('app/pages/cvu/wizard-new/s4-topup/cvu-new-s4-topup.view.html','<div class="fullpage wizard"><div class=wizard-header><button type=submit class="bt-button bt-text-button wizard-header-left-button" ng-click=goBack()><span class="material-icons md-36">west</span> Atras</button><h2>Solicitud de nuevo tag</h2></div><div class=wizard-body><div><h1 style="color: #ffffff; margin-bottom: 50px">Seleccione un monto a recargar</h1><div class=card-cntr-hori><div class="card card-clickable card-medium" ng-repeat="amount in data.amounts" ripple ripple-class=ripple ripple-callback=select(amount) ripple-radius=80><h2 style="font-size: 60px"><span style="font-size: 70%; margin-right: 10px">$</span>{{ amount.amount }}</h2><p>Equivale a {{ amount.tollGoThroughs }} pasadas</p></div><div class="card card-clickable card-medium" ripple ripple-class=ripple ripple-callback=selectCustom() ripple-radius=80><h2 style="font-size: 40px">Ingresar<br>otro monto</h2></div></div></div><div ng-if=data.includesTaxes class=bt-info-box><div class=bt-info-box-icon><span class=material-icons-outlined>info</span></div><div class=bt-info-box-text>Los precios est\xE1n en pesos uruguayos e incluyen IVA</div></div><div style="position: absolute; bottom: 50px"><button type=submit class="bt-button bt-outline-button" style="margin-top: 40px" ripple ripple-class=ripple ripple-callback=cancel() ripple-radius=40>Cancelar</button></div></div></div><keyboard ng-show=showKeyboard layout=keyboardLayout input=keyboardInput form-name="\'customAmountForm\'" show-next=false></keyboard>');
$templateCache.put('app/pages/cvu/wizard-new/s5-pay/cvu-new-s5-pay.view.html','<div class="fullpage wizard"><div class=wizard-header><h2>Solicitud de nuevo tag</h2></div><div class=wizard-body><div ng-if="payStep == 0"><h1>Preparando la transacci\xF3n</h1><div class=step-instructions style="color: #111111">Por favor espere mientras preparamos la solicitud...</div><div ng-if=!processCompleted><div class="spinner spinner-white"><div class=bounce1></div><div class=bounce2></div><div class=bounce3></div><div class=bounce4></div></div></div><div ng-if=processCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div class=bt-status-box>{{processStatus}}</div></div><div ng-if="payStep == 1" style="display: flex; align-items: center; justify-content: center"><div class=card style="width: 75%; padding-bottom: 30px"><div><img src=assets/img/creditcard.svg style="width: 250px; height: 250px"></div><div class=card-body><h1>Pago</h1><div class=step-instructions style="color: #111111">A continuaci\xF3n deber\xE1 realizar el pago mediante una tarjeta de cr\xE9dito o d\xE9bito.</div><div style="margin: 60px 0px 60px 0px"><div style="font-size: 30px; font-weight: 800">Monto a pagar</div><div style="font-size: 60px; font-weight: 800; color: #2196f3"><span style="font-size: 80%">$</span> {{amountToPay}}</div></div><div style="margin: 10px 0px"><!-- --></div><div style="text-align: center; display: flex; justify-content: center"><button type=submit class="bt-button bt-primary-button bt-green-button bt-button-big" style="text-align: center;\n                display: table-cell;\n                vertical-align: middle;\n                width: 400px;\n                height: 140px;" ng-click=continueToPay()>PAGAR</button></div></div></div><div style="position: absolute; bottom: 50px"><button type=submit class="bt-button bt-outline-button" style="margin-top: 40px" ripple ripple-class=ripple ripple-callback=cancel() ripple-radius=40>Cancelar</button></div></div><div ng-if="payStep == 2"><div class=card style="width: 90vw; padding-bottom: 30px"><div class=card-body><h1>Pago</h1><!-- h2 style="font-size:50px"><span style="font-size:80%">$</span> 500</h2--><div style="max-width: 650px; margin: 0 auto"><img src=assets/img/pos-animated2.svg></div><div class=instructions-bullets><ul><li>Presione la tecla blanca en el POS en caso de que no aparezca la transacci\xF3n</li><li>Acerque o deslice su tarjeta para completar el pago</li><li>Ingrese su PIN en caso de que el POS lo solicite</li></ul></div></div></div><div ng-if=!payCompleted><img src=assets/img/arrow-right.svg style="width: 230px;\n            animation: bounceH 1s infinite alternate;\n            -webkit-animation: bounceH 1s infinite alternate;"></div><div ng-if=payCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div class=bt-status-box>{{status}}</div></div><div ng-if="payStep == 4"><h1>Cancelando la transacci\xF3n</h1><div class=step-instructions style="color: #111111">Por favor espere mientras cancelamos la solicitud...</div><div ng-if=!processCompleted><div class="spinner spinner-white"><div class=bounce1></div><div class=bounce2></div><div class=bounce3></div><div class=bounce4></div></div></div><div ng-if=processCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div class=bt-status-box>{{status}}</div></div></div></div>');
$templateCache.put('app/pages/cvu/wizard-new/s6-tag/cvu-new-s6-tag.view.html','<div class="fullpage wizard"><div class=wizard-header><h2>Compra de nuevo tag</h2></div><div class=wizard-body><div class=card style="width: 75%"><h1>Retire y escanee el tag</h1><div class=step-instructions style="color: #111111">Por favor retire el tag del expendedor y coloquelo en el lector de codigos de barra</div><!-- div style="width: 100%;min-height: 350px;position: relative;">\n          <div class="preloader-scan" style="transform: scale(2);">\n            <ul>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              <li></li>\n              \n              <div class="diode">\n                <div class="laser"></div>\n              </div>\n            </ul>\n            \n          </div>\n        </div--><div style="width: 100%; min-height: 350px; position: relative"><div><img src=assets/img/tag.png style="width: 433px"><div class=diode><div class=laser></div></div></div></div><div ng-if="data.printQty > 1" style="display: flex; width: 80%; padding: 15px; background-color: #fff9c4; margin: 20px auto 40px auto; border-radius: 13px"><div style="min-width: 70px; display: flex; align-items: flex-start; justify-content: center"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true style="font-size: 40px"></span></div><div style="text-align: left; padding-left: 10px"><div style="font-weight: 600; font-size: 24px">ATENCION!</div><div style="font-size: 20px; line-height: 25px">Se imprimieron <strong>{{data.printQty}}</strong> TAGs. Utilice <strong>SOLO</strong> el que <strong>NO ESTA</strong> marcado con unas cruces.</div></div></div></div><div ng-if=scanCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div ng-if=!scanCompleted style="height: 240px"></div><div class=bt-status-box>{{status}}</div></div><!-- <div style="position:absolute;bottom: 50px;right: 50px;width: 1000px;display: flex;justify-content: flex-end;">\n      <button type="submit" class="bt-button" ng-click="simulateScan()" style="margin-right: 20px;">\n        Simular correcto\n      </button>\n      <button type="submit" class="bt-button" ng-click="simulateScanWrong()">\n        Simular err\xF3neo\n      </button>\n    </div> --></div>');
$templateCache.put('app/pages/cvu/wizard-new/s7-process/cvu-new-s7-process.view.html','<div class="fullpage wizard"><div class=wizard-header><h2>Sllicitud de nuevo tag</h2></div><div class=wizard-body><div><h1>Completando la transacci\xF3n</h1><div class=step-instructions style="color: #111111">Por favor espere mientras completamos su solicitud y activamos el TAG...</div><div ng-if=!processCompleted><div class="spinner spinner-white"><div class=bounce1></div><div class=bounce2></div><div class=bounce3></div><div class=bounce4></div></div></div><div ng-if=processCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div class=bt-status-box>{{status}}</div></div></div></div>');
$templateCache.put('app/pages/cvu/wizard-new/s7b-refund/cvu-new-s7b-refund.view.html','<div class="fullpage wizard"><div class=wizard-header><h2>Solicitud de nuevo tag</h2></div><div class=wizard-body><div ng-if="refundStep == 0"><h1>Cancelando la transacci\xF3n</h1><div class=step-instructions style="color: #111111">Por favor espere mientras cancelamos la solicitud...</div><div ng-if=!processCompleted><div class="spinner spinner-white"><div class=bounce1></div><div class=bounce2></div><div class=bounce3></div><div class=bounce4></div></div></div><div ng-if=processCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div class=bt-status-box>{{status}}</div></div><div ng-if="refundStep == 1" style="display: flex; align-items: center; justify-content: center"><div class=card style="width: 75%; padding-bottom: 30px"><div><img src=assets/img/creditcard.svg style="width: 250px; height: 250px"></div><div class=card-body><h1>Anulaci\xF3n de la compra</h1><div class=step-instructions style="color: #111111">A continuaci\xF3n procederemos a anular la transacci\xF3n.<br><br>Por favor utilice la misma tarjeta que utilizo para el pago.</div><div style="margin: 60px 0px 60px 0px"><div style="font-size: 30px; font-weight: 800">Monto a anular</div><div style="font-size: 60px; font-weight: 800; color: #2196f3"><span style="font-size: 80%">$</span> {{amountToRefund}}</div></div><div style="text-align: center; display: flex; justify-content: center"><button type=submit class="bt-button bt-primary-button bt-green-button bt-button-big" style="margin-top: 40px" ng-click=continueToRefund()>INICIAR ANULACI\xD3N</button></div></div></div></div><div ng-if="refundStep == 2"><div class=card-body><h1>Anulaci\xF3n de la compra</h1><div style="max-width: 650px; margin: 0 auto"><img src=assets/img/pos-animated2.svg></div><div class=instructions-bullets><ul><li>Presione la tecla blanca en el POS en caso de que no aparezca la transacci\xF3n</li><li>Acerque o deslice su tarjeta para completar la anulaci\xF3n</li><li>Ingrese su PIN en caso de que el POS lo solicite</li></ul></div></div><div ng-if=!payCompleted><img src=assets/img/arrow-right.svg style="width: 230px; animation: bounceH 1s infinite alternate; -webkit-animation: bounceH 1s infinite alternate"></div><div ng-if=payCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div class=bt-status-box>{{status}}</div></div></div></div>');
$templateCache.put('app/pages/cvu/wizard-new/s8-done/cvu-new-s8-done.view.html','<div class="fullpage wizard"><div class=wizard-body><div><h1>Solicitud completada con \xE9xito</h1><div class=step-instructions style=color:#111111>El TAG ya ha sido activado y se ha realizado la recarga</div><div><img src=assets/img/car-done.svg style="width: 600px;margin: 0 auto;"></div><div class=step8-instructs><h2>Instructivo de colocaci\xF3n de TAG</h2><h3>\xBFD\xF3nde debe colocarse el TAG?</h3><p>El TAG debe colocarse en la parte interna del parabrisas con el c\xF3digo de barras hacia el conductor.</p><h3>\xBFEn qu\xE9 lugar del parabrisas?</h3><p>A 10 cm del borde superior.<br>Si el parabrisas posee una faja polarizada, el TAG debe colocarse 5 cm por debajo de la misma.<br>En veh\xEDculos con malla cuadriculada detr\xE1s y/o arriba del retrovisor, el TAG debe ser colocado dentro de la malla.<br></p><div style="margin-top: 20px;text-align: center;"><img src=assets/img/instruct-tag.jpg style=width:300px></div><p></p><h3>Consejos para colocar el TAG correctamente:</h3><p>Presiona bien el dispositivo al momento de pegarlo.<br>Quit\xE1 las burbujas de aire que puedan haber quedado presionando firmemente.</p></div><div style="text-align: center;display:flex;justify-content: center;"><button type=submit class="bt-button bt-primary-button bt-green-button bt-button-big" style=margin-top:40px ng-click=finish()>TERMINAR</button></div></div></div></div>');
$templateCache.put('app/pages/cvu/wizard-new/s8b-refunded/cvu-new-s8b-refunded.view.html','<div class="fullpage wizard"><div class=wizard-body><div><h1>Pago devuelto con \xE9xito</h1><div class=step-instructions style="color: #111111">La transacci\xF3n fue cancelada con \xE9xito.</div><div style="text-align: center; display: flex; justify-content: center"><button type=submit class="bt-button bt-primary-button bt-green-button bt-button-big" style="margin-top: 40px" ng-click=finish()>TERMINAR</button></div></div></div></div>');
$templateCache.put('app/pages/cvu/wizard-recharge/s1-id/cvu-rech-s1-id.view.html','<div class="fullpage wizard has-keyboard"><div class=wizard-header><button type=submit class="bt-button bt-text-button wizard-header-left-button" ng-click=goBack()><span class="material-icons md-36">west</span> Atras</button><h2>Recargar cuenta</h2></div><div class=wizard-body><div class=card style="width: 75%; padding-bottom: 30px"><h1>Identificaci\xF3n</h1><div class=step-instructions>Ingrese su n\xFAmero de matr\xEDcula para comenzar</div><form class=wizard-form name=s1Form id=s1Form novalidate><!-- <label>Tipo de documento</label> --><!-- <div class="bt-radio-tile-group"> --><!-- <div class="input-container">\n            <input id="userDocTypeCI" name="userDocTypeCI" class="radio-button" type="radio" ng-value="2" ng-focus="inputFocus($event)" ng-model="data.userDocType" checked="checked" ng-click="docTypeSelect()" />\n            <div class="radio-tile">\n              <label for="userDocTypeCI" class="radio-tile-label">{{ \'pages.cvu.wizard-recharge.s1-id.docType1\' | translate }}</label>\n            </div>\n          </div> --><!-- <div class="input-container">\n            <input id="userDocType" name="userDocType" class="radio-button" type="radio" name="radio" ng-value="5" ng-focus="inputFocus($event)" ng-model="data.userDocType" ng-click="docTypeSelect()" />\n            <div class="radio-tile">\n              <label for="userDocType" class="radio-tile-label">{{ \'pages.cvu.wizard-recharge.s1-id.docType5\' | translate }}</label>\n            </div>\n          </div> --><!-- <br />\n          <div class="input-container">\n            <input id="userDocType" name="userDocType" class="radio-button" type="radio" name="radio" ng-value="1" ng-focus="inputFocus($event)" ng-model="data.userDocType" ng-click="docTypeSelect()" />\n            <div class="radio-tile">\n              <label for="userDocType" class="radio-tile-label">{{ \'pages.cvu.wizard-recharge.s1-id.docType2\' | translate }}</label>\n            </div>\n          </div>\n          <div class="input-container">\n            <input id="userDocType" name="userDocType" class="radio-button" type="radio" name="radio" ng-value="3" ng-focus="inputFocus($event)" ng-model="data.userDocType" ng-click="docTypeSelect()" />\n            <div class="radio-tile">\n              <label for="userDocType" class="radio-tile-label">{{ \'pages.cvu.wizard-recharge.s1-id.docType3\' | translate }}</label>\n            </div>\n          </div>\n          <div class="input-container">\n            <input id="userDocType" name="userDocType" class="radio-button" type="radio" name="radio" ng-value="4" ng-focus="inputFocus($event)" ng-model="data.userDocType" ng-click="docTypeSelect()" />\n            <div class="radio-tile">\n              <label for="userDocType" class="radio-tile-label">{{ \'pages.cvu.wizard-recharge.s1-id.docType4\' | translate }}</label>\n            </div>\n          </div>\n        </div> --><div class=form-group style="margin-top: 20px"><label for=userDocValue>Matr\xEDcula</label> <input type=text class=form-control id=userDocValue name=userDocValue placeholder="" autocomplete=off ng-focus=inputFocus($event) style="text-align: center" ng-model=data.userDocValue ng-minlength=6 ng-required=true><div class=field-error-cntr><p ng-show="!(s1Form.userDocValue.$error.minlength || s1Form.userDocValue.$error.required) && !validateDocValue()" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Ingrese un n\xFAmero de documento v\xE1lido</p><p ng-show="s1Form.userDocValue.$error.minlength && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Ingrese un n\xFAmero de documento v\xE1lido</p><p ng-show="s1Form.userDocValue.$error.required && showErrors" class=field-error><span class="glyphicon glyphicon-exclamation-sign" aria-hidden=true></span> Por favor ingrese su n\xFAmero de matr\xEDcula</p></div></div><button type=button class="bt-button bt-primary-button" style="margin-top: 40px" ng-disabled="!s1Form.$valid || !validateDocValue()" ripple ripple-class=ripple ripple-callback=continue(s1Form.$valid) ripple-radius=40>Continuar <span class="glyphicon glyphicon-chevron-right" aria-hidden=true></span></button></form></div><div style="position: absolute; bottom: 200px"><button type=submit class="bt-button bt-outline-button" style="margin-top: 60px" ripple ripple-class=ripple ripple-callback=cancel() ripple-radius=40>Cancelar</button></div></div></div><keyboard ng-show=showKeyboard layout=keyboardLayout input=keyboardInput form-name="\'s1Form\'"></keyboard>');
$templateCache.put('app/pages/cvu/wizard-recharge/s1b-client-select/cvu-rech-s1b-client-select.view.html','<div class="fullpage wizard"><div class=wizard-header><button type=submit class="bt-button bt-text-button wizard-header-left-button bt-button-icon-left" ng-click=goBack()><span class="material-icons md-36">west</span> Atras</button><h2>Recargar cuenta</h2></div><div class=wizard-body><div><h1 style="color: #ffffff; margin-bottom: 50px">Seleccione el cliente a recargar</h1><div class=card-cntr-hori><div class="card card-clickable" ng-repeat="user in data.clientes" ripple ripple-class=ripple ng-click=selectUser(user) ripple-radius=80><h2>{{ user.xsNombreCliente }}</h2><p>{{{ 1: \'RUT\', 2: \'Documento Uruguayo\', 3: \'Documento extranjero\', 4: \'Precargado\', 5: \'Matr\xEDcula\' }[user.xiTipoCli] || \'Documento extranjero\' }}<br>{{ user | maskCi }}</p></div></div></div><div style="position: absolute; bottom: 200px"><button type=submit class="bt-button bt-outline-button" style="margin-top: 40px" ripple ripple-class=ripple ripple-callback=cancel() ripple-radius=40>Cancelar</button></div></div></div><keyboard ng-show=showKeyboard layout=keyboardLayout input=keyboardInput form-name="\'customAmountForm\'" show-next=false></keyboard>');
$templateCache.put('app/pages/cvu/wizard-recharge/s2-topup/cvu-rech-s2-topup.view.html','<div class="fullpage wizard"><div class=wizard-header><button type=submit class="bt-button bt-text-button wizard-header-left-button bt-button-icon-left" ng-click=goBack()><span class="material-icons md-36">west</span> Atras</button><h2>Recargar cuenta</h2></div><div class=wizard-body><div><h1 style="color: #ffffff; margin-bottom: 50px">Seleccione un monto a recargar</h1><div class=card-cntr-hori><div class="card card-clickable card-medium" ng-repeat="amount in data.amounts" ripple ripple-class=ripple ripple-callback=select(amount) ripple-radius=80><h2><span style="font-size: 70%; margin-right: 10px">$</span>{{ amount.amount }}</h2><p>Equivale a {{ amount.tollGoThroughs }} pasadas</p></div><div class="card card-clickable card-medium" ripple ripple-class=ripple ripple-callback=selectCustom() ripple-radius=80><h2 style="font-size: 40px">Ingresar<br>otro monto</h2></div></div></div><div ng-if=data.includesTaxes class=bt-info-box><div class=bt-info-box-icon><span class=material-icons-outlined>info</span></div><div class=bt-info-box-text>Los precios est\xE1n en pesos uruguayos e incluyen IVA</div></div><div style="position: absolute; bottom: 200px"><button type=submit class="bt-button bt-outline-button" style="margin-top: 40px" ripple ripple-class=ripple ripple-callback=cancel() ripple-radius=40>Cancelar</button></div></div></div><keyboard ng-show=showKeyboard layout=keyboardLayout input=keyboardInput form-name="\'customAmountForm\'" show-next=false></keyboard>');
$templateCache.put('app/pages/cvu/wizard-recharge/s3-process/cvu-rech-s3-process.view.html','<div class="fullpage wizard"><div class=wizard-header><h2>Recarga</h2></div><div class=wizard-body><!-- div ng-if="processStep == 0" --><div><h1>Preparando la recarga</h1><div class=step-instructions style="color: #111111">Por favor espere mientras preparamos la recarga...</div><div><div class="spinner spinner-white"><div class=bounce1></div><div class=bounce2></div><div class=bounce3></div><div class=bounce4></div></div></div><div class=bt-status-box>{{status}}</div></div><!-- div ng-if="processStep == 1">\n      <div class="card" style="width: 100%;padding: 30px;">\n        <h1>Pago</h1>\n    \n        <div class="step-instructions" style="color:#111111">\n          A continuaci\xF3n deber\xE1 realizar el pago mediante una tarjeta de cr\xE9dito o d\xE9bito.\n        </div> \n\n        <div style="text-align: center;display:flex;justify-content: center;">\n          <button type="submit" class="bt-button bt-primary-button bt-green-button bt-button-big" style="margin-top:40px"\n            ng-click="continueToPay()">\n            PAGAR\n          </button>\n        </div>\n\n      </div>\n\n      <div style="text-align: center;display:flex;justify-content: center;">\n        <button type="submit" class="bt-button bt-outline-button" style="margin-top:40px"\n          ripple ripple-class="ripple" ripple-callback="cancel()" ripple-radius="40">\n          Cancelar\n        </button>\n      </div>\n    </div>\n\n    <div ng-if="processStep == 2">\n      <h1>Cancelando la recarga</h1>\n  \n      <div class="step-instructions" style="color:#111111">\n        Por favor espere mientras cancelamos la recarga...\n      </div> \n\n      <div ng-if="!cancelCompleted">\n        <div class="spinner spinner-white">\n          <div class="bounce1"></div>\n          <div class="bounce2"></div>\n          <div class="bounce3"></div>\n          <div class="bounce4"></div>\n        </div>\n      </div>\n\n      <div ng-if="cancelCompleted" style="margin: 40px 0px;">\n        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">\n          <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>\n          <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>\n        </svg>\n      </div>\n\n      <div class="bt-status-box">{{status}}</div>\n\n    </div--></div></div>');
$templateCache.put('app/pages/cvu/wizard-recharge/s4-pay/cvu-rech-s4-pay.view.html','<div class="fullpage wizard"><div class=wizard-header><h2>Recarga de cuenta</h2></div><div class=wizard-body><div ng-if="payStep == 0" style="display: flex; align-items: center; justify-content: center"><div class=card style="width: 75%; padding-bottom: 30px"><div><img src=assets/img/creditcard.svg style="width: 250px"></div><div class=card-body><h1>Pago</h1><div class=step-instructions style="color: #111111">A continuaci\xF3n deber\xE1 realizar el pago mediante una tarjeta de cr\xE9dito o d\xE9bito.</div><div style="margin: 60px 0px 60px 0px"><div style="font-size: 30px; font-weight: 800">Monto a pagar</div><div style="font-size: 60px; font-weight: 800; color: #2196f3"><span style="font-size: 80%">$</span> {{amountToPay}}</div></div><div style="text-align: center; display: flex; justify-content: center"><button type=submit class="bt-button bt-primary-button bt-green-button bt-button-big" style="text-align:center; display:table-cell; vertical-align:middle; width:400px; height:140px;" ng-click=continueToPay()>PAGAR</button></div></div></div><div style="position: absolute; bottom: 50px"><button type=submit class="bt-button bt-outline-button" style="margin-top: 40px" ripple ripple-class=ripple ripple-callback=cancel() ripple-radius=40>Cancelar</button></div></div><div ng-if="payStep == 1"><div class=card style="width: 90vw; padding-bottom: 30px"><div class=card-body><h1>Pago</h1><!-- h2 style="font-size:50px"><span style="font-size:80%">$</span> 500</h2--><div style="max-width: 650px; margin: 0 auto"><img src=assets/img/pos-animated2.svg></div><div class=instructions-bullets><ul><li>Presione la tecla blanca en el POS en caso de que no aparezca la transacci\xF3n</li><li>Acerque o deslice su tarjeta para completar el pago</li><li>Ingrese su PIN en caso de que el POS lo solicite</li></ul></div></div></div><div ng-if=!payCompleted><img src=assets/img/arrow-right.svg style="width: 230px; animation: bounceH 1s infinite alternate; -webkit-animation: bounceH 1s infinite alternate"></div><div ng-if=payCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div class=bt-status-box>{{status}}</div></div><div ng-if="payStep == 2"><h1>Cancelando la transacci\xF3n</h1><div class=step-instructions style="color: #111111">Por favor espere mientras cancelamos la solicitud...</div><div ng-if=!processCompleted><div class="spinner spinner-white"><div class=bounce1></div><div class=bounce2></div><div class=bounce3></div><div class=bounce4></div></div></div><div ng-if=processCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div class=bt-status-box>{{status}}</div></div></div></div>');
$templateCache.put('app/pages/cvu/wizard-recharge/s4b-revert/cvu-rech-s4b-revert.view.html','<div class="fullpage wizard"><div class=wizard-header><h2>Recarga de cuenta</h2></div><div class=wizard-body><div><h1>Cancelando recarga</h1><div class=step-instructions style="color: #111111">Espere mientras se cancela la recarga</div><div ng-if=!revertCompleted><div class="spinner spinner-white"><div class=bounce1></div><div class=bounce2></div><div class=bounce3></div><div class=bounce4></div></div></div><div ng-if=revertCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div class=bt-status-box>{{status}}</div></div></div></div>');
$templateCache.put('app/pages/cvu/wizard-recharge/s5-confirm/cvu-rech-s5-confirm.view.html','<div class="fullpage wizard"><div class=wizard-header><h2>Recarga</h2></div><div class=wizard-body><div><h1>Confirmando la transacci\xF3n</h1><div class=step-instructions style="color: #111111">Por favor espere mientras finalizamos la recarga...</div><div ng-if=!processCompleted><div class="spinner spinner-white"><div class=bounce1></div><div class=bounce2></div><div class=bounce3></div><div class=bounce4></div></div></div><div ng-if=processCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div class=bt-status-box>{{status}}</div></div></div></div>');
$templateCache.put('app/pages/cvu/wizard-recharge/s5b-refund/cvu-rech-s5b-refund.view.html','<div class="fullpage wizard"><div class=wizard-header><h2>Recarga</h2></div><div class=wizard-body><div ng-if="refundStep == 0"><h1>Cancelando la transacci\xF3n</h1><div class=step-instructions style="color: #111111">Por favor espere mientras cancelamos la solicitud...</div><div ng-if=!processCompleted><div class="spinner spinner-white"><div class=bounce1></div><div class=bounce2></div><div class=bounce3></div><div class=bounce4></div></div></div><div ng-if=processCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div class=bt-status-box>{{status}}</div></div><div ng-if="refundStep == 1" style="display: flex; align-items: center; justify-content: center"><div class=card style="width: 75%; padding-bottom: 30px"><div><img src=assets/img/creditcard.svg style="width: 250px; height: 250px"></div><div class=card-body><h1>Anulaci\xF3n de la compra</h1><div class=step-instructions style="color: #111111">A continuaci\xF3n procederemos a anular la transacci\xF3n.<br><br>Por favor utilice la misma tarjeta que utilizo para el pago.</div><div style="margin: 60px 0px 60px 0px"><div style="font-size: 30px; font-weight: 800">Monto a anular</div><div style="font-size: 60px; font-weight: 800; color: #2196f3"><span style="font-size: 80%">$</span> {{amountToRefund}}</div></div><div style="text-align: center; display: flex; justify-content: center"><button type=submit class="bt-button bt-primary-button bt-green-button bt-button-big" style="margin-top: 40px" ng-click=continueToRefund()>INICIAR ANULACI\xD3N</button></div></div></div></div><div ng-if="refundStep == 2"><div class=card-body><h1>Anulaci\xF3n de la compra</h1><div style="max-width: 650px; margin: 0 auto"><img src=assets/img/pos-animated2.svg></div><div class=instructions-bullets><ul><li>Presione la tecla blanca en el POS en caso de que no aparezca la transacci\xF3n</li><li>Acerque o deslice su tarjeta para completar la anulaci\xF3n</li><li>Ingrese su PIN en caso de que el POS lo solicite</li></ul></div></div><div ng-if=!payCompleted><img src=assets/img/arrow-right.svg style="width: 230px; animation: bounceH 1s infinite alternate; -webkit-animation: bounceH 1s infinite alternate"></div><div ng-if=payCompleted style="margin: 40px 0px"><svg class=checkmark xmlns=http://www.w3.org/2000/svg viewBox="0 0 52 52"><circle class=checkmark__circle cx=26 cy=26 r=25 fill=none /><path class=checkmark__check fill=none d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div><div class=bt-status-box>{{status}}</div></div></div></div>');
$templateCache.put('app/pages/cvu/wizard-recharge/s6-done/cvu-rech-s6-done.view.html','<div class="fullpage wizard"><div class=wizard-body><div ng-if=completed><div class=card style="width: 100%; padding: 30px; min-width: 700px"><span class=material-icons-outlined style="font-size: 120px; color: #4caf50">check_circle</span><h1>Recarga completada con \xE9xito</h1><div class=step-instructions style="color: #111111">La cuenta ya fue recargada y puede comenzar a usarse.<br>Le llegar\xE1 una notificaci\xF3n de la transacci\xF3n v\xEDa correo electr\xF3nico.</div><div style="text-align: center; display: flex; justify-content: center"><button type=submit class="bt-button bt-primary-button bt-green-button bt-button-big" style="margin-top: 40px" ng-click=finish()>TERMINAR</button></div></div></div><div ng-if=!completed><div class=card style="width: 100%; padding: 30px; min-width: 700px"><span class=material-icons-outlined style="font-size: 120px; color: #ff5722">highlight_off</span><h1>Recarga cancelada</h1><div class=step-instructions style="color: #111111">La recarga no se ha completado.<br>Puede volver a intentarlo.</div><div style="text-align: center; display: flex; justify-content: center"><button type=submit class="bt-button bt-primary-button bt-green-button bt-button-big" style="margin-top: 40px" ng-click=finish()>TERMINAR</button></div></div></div></div></div>');
$templateCache.put('app/pages/cvu/wizard-recharge/s6b-refunded/cvu-rech-s6b-refunded.view.html','<div class="fullpage wizard"><div class=wizard-body><div><h1>Compra anulada con \xE9xito</h1><div class=step-instructions style="color: #111111">La transacci\xF3n fue cancelada con \xE9xito.</div><div style="text-align: center; display: flex; justify-content: center"><button type=submit class="bt-button bt-primary-button bt-green-button bt-button-big" style="margin-top: 40px" ng-click=finish()>TERMINAR</button></div></div></div></div>');}]);